webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(20);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(133);
	
	var _Root = __webpack_require__(631);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _configureStore = __webpack_require__(637);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _rpMqBreakpoints = __webpack_require__(71);
	
	var mqBreakpoints = _interopRequireWildcard(_rpMqBreakpoints);
	
	var _rpGuiGuide = __webpack_require__(110);
	
	var _rpGuiGuide2 = _interopRequireDefault(_rpGuiGuide);
	
	var _rpPopup = __webpack_require__(604);
	
	var _rpPopup2 = _interopRequireDefault(_rpPopup);
	
	var _rpAdvertising = __webpack_require__(596);
	
	var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);
	
	var _rpUrlNavigationPrefs = __webpack_require__(1347);
	
	var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);
	
	__webpack_require__(914);
	
	__webpack_require__(913);
	
	__webpack_require__(912);
	
	var _versionHelper = __webpack_require__(642);
	
	var _analyticsPage = __webpack_require__(607);
	
	var _analyticsPage2 = _interopRequireDefault(_analyticsPage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.cookie('to_force_inclusion_in_code');
	
	(0, _analyticsPage2.default)();
	
	(0, _versionHelper.checkVersionChanges)();
	
	(0, _rpGuiGuide2.default)({
	    svg: { polyfill: true }
	});
	
	var store = (0, _configureStore2.default)();
	
	(0, _reactDom.render)(_react2.default.createElement(_Root2.default, { store: store }), document.getElementById('root'));
	
	(0, _rpPopup2.default)();
	
	(0, _rpAdvertising2.default)();
	(0, _rpUrlNavigationPrefs2.default)();
	
	window.rpBreakpoints = mqBreakpoints;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(120);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(176),
	    isLength = __webpack_require__(251);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(371),
	    baseKeys = __webpack_require__(379),
	    isArrayLike = __webpack_require__(56);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(974),
	    getValue = __webpack_require__(1014);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(26),
	    isKey = __webpack_require__(248),
	    stringToPath = __webpack_require__(1053),
	    toString = __webpack_require__(407);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(168),
	    baseAssignValue = __webpack_require__(372);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(953),
	    Map = __webpack_require__(238),
	    Promise = __webpack_require__(955),
	    Set = __webpack_require__(956),
	    WeakMap = __webpack_require__(957),
	    baseGetTag = __webpack_require__(86),
	    toSource = __webpack_require__(397);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(131);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.putToStorage = putToStorage;
	exports.getFromStorage = getFromStorage;
	exports.hasLocalData = hasLocalData;
	exports.purge = purge;
	function putToStorage(key, data) {
	    if (!localStorage.hasOwnProperty(key)) {
	        try {
	            localStorage.setItem(key, JSON.stringify(data));
	        } catch (e) {
	            console.warn(e);
	        }
	    }
	}
	
	function getFromStorage(key) {
	    try {
	        if (localStorage.hasOwnProperty(key)) {
	            return JSON.parse(localStorage.getItem(key));
	        }
	    } catch (e) {
	        console.warn('Local storage doesn\'t have ' + key + ' value');
	    }
	    return undefined;
	}
	
	function hasLocalData(key) {
	    return localStorage.hasOwnProperty(key);
	}
	
	function purge(keys) {
	    var items = keys || ['type-active', 'type-inactive', 'type-weatherbys', 'results-active', 'results-inactive', 'results-weatherbys', 'version'];
	
	    items.forEach(function (i) {
	        return localStorage.removeItem(i);
	    });
	}

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var map = __webpack_require__(403);
	var filter = __webpack_require__(398);
	var find = __webpack_require__(250);
	var sortBy = __webpack_require__(1079);
	var difference = __webpack_require__(1058);
	
	var ColumnProperties = (function () {
	  function ColumnProperties() {
	    var allColumns = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	    var filteredColumns = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	    var childrenColumnName = arguments.length <= 2 || arguments[2] === undefined ? "children" : arguments[2];
	    var columnMetadata = arguments.length <= 3 || arguments[3] === undefined ? [] : arguments[3];
	    var metadataColumns = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	
	    _classCallCheck(this, ColumnProperties);
	
	    this.allColumns = allColumns;
	    this.filteredColumns = filteredColumns;
	    this.childrenColumnName = childrenColumnName;
	    this.columnMetadata = columnMetadata;
	    this.metadataColumns = metadataColumns;
	  }
	
	  _createClass(ColumnProperties, [{
	    key: 'getMetadataColumns',
	    value: function getMetadataColumns() {
	      var meta = map(filter(this.columnMetadata, { visible: false }), function (item) {
	        return item.columnName;
	      });
	      if (meta.indexOf(this.childrenColumnName) < 0) {
	        meta.push(this.childrenColumnName);
	      }
	      return meta.concat(this.metadataColumns);
	    }
	  }, {
	    key: 'getVisibleColumnCount',
	    value: function getVisibleColumnCount() {
	      return this.getColumns().length;
	    }
	  }, {
	    key: 'getColumnMetadataByName',
	    value: function getColumnMetadataByName(name) {
	      return find(this.columnMetadata, { columnName: name });
	    }
	  }, {
	    key: 'hasColumnMetadata',
	    value: function hasColumnMetadata() {
	      return this.columnMetadata !== null && this.columnMetadata.length > 0;
	    }
	  }, {
	    key: 'getMetadataColumnProperty',
	    value: function getMetadataColumnProperty(columnName, propertyName, defaultValue) {
	      var meta = this.getColumnMetadataByName(columnName);
	
	      //send back the default value if meta isn't there
	      if (typeof meta === "undefined" || meta === null) return defaultValue;
	
	      return meta.hasOwnProperty(propertyName) ? meta[propertyName] : defaultValue;
	    }
	  }, {
	    key: 'orderColumns',
	    value: function orderColumns(cols) {
	      var _this = this;
	
	      var ORDER_MAX = 100;
	
	      var orderedColumns = sortBy(cols, function (item) {
	        var metaItem = find(_this.columnMetadata, { columnName: item });
	
	        if (typeof metaItem === 'undefined' || metaItem === null || isNaN(metaItem.order)) {
	          return ORDER_MAX;
	        }
	
	        return metaItem.order;
	      });
	
	      return orderedColumns;
	    }
	  }, {
	    key: 'getColumns',
	    value: function getColumns() {
	      //if we didn't set default or filter
	      var filteredColumns = this.filteredColumns.length === 0 ? this.allColumns : this.filteredColumns;
	
	      filteredColumns = difference(filteredColumns, this.metadataColumns);
	
	      filteredColumns = this.orderColumns(filteredColumns);
	
	      return filteredColumns;
	    }
	  }]);
	
	  return ColumnProperties;
	})();
	
	module.exports = ColumnProperties;


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(99),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(978),
	    baseMatchesProperty = __webpack_require__(979),
	    identity = __webpack_require__(130),
	    isArray = __webpack_require__(26),
	    property = __webpack_require__(404);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(130),
	    overRest = __webpack_require__(395),
	    setToString = __webpack_require__(396);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(86),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1083);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
	exports.clamp = clamp;
	exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	
	var safePreventDefault = function safePreventDefault(event) {
	  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
	
	  if (!passiveEvents.includes(event._reactName)) {
	    event.preventDefault();
	  }
	};
	
	exports.safePreventDefault = safePreventDefault;
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  var lazyLoadedList = spec.lazyLoadedList;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList = lazyLoadedList.concat(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    if (lazyLoad) {
	      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	        currentSlide: animationSlide
	      })));
	    }
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      previousTargetSlide = spec.targetSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && safePreventDefault(e);
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return safePreventDefault(e);
	  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    safePreventDefault(e);
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe,
	      targetSlide = spec.targetSlide,
	      currentSlide = spec.currentSlide,
	      infinite = spec.infinite;
	
	  if (!dragging) {
	    if (swipe) safePreventDefault(e);
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    safePreventDefault(e);
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = activeSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPE = exports.TYPE = 'FILTER_TYPE';
	var CLEAR = exports.CLEAR = 'FILTER_CLEAR';
	var STATE_PRISTINE = exports.STATE_PRISTINE = 'FILTER_STATE_PRISTINE';
	var SIRE = exports.SIRE = 'FILTER_SIRE';
	var STALLION = exports.STALLION = 'FILTER_STALLION';
	var SIRE_TYPE = exports.SIRE_TYPE = 'FILTER_SIRE_TYPE';
	var SIRE_LINE_FLAG = exports.SIRE_LINE_FLAG = 'FILTER_SIRE_LINE_FLAG';
	var SIRE_LINE = exports.SIRE_LINE = 'FILTER_SIRE_LINE';
	var WIN_DIST = exports.WIN_DIST = 'FILTER_WIN_DIST';
	var YEAR_TO_STUD = exports.YEAR_TO_STUD = 'FILTER_YEAR_TO_STUD';
	var COUNTRY = exports.COUNTRY = 'FILTER_COUNTRY';
	var STUD_FARM = exports.STUD_FARM = 'FILTER_STUD_FARM';
	var STUD_FEE = exports.STUD_FEE = 'STUD_FEE';
	var PROGENY_SUCCESS = exports.PROGENY_SUCCESS = 'FILTER_PROGENY_SUCCESS';
	var SET_ADVANCED_SECTION = exports.SET_ADVANCED_SECTION = 'SET_ADVANCED_SECTION';
	var SET_FILTER_POPOVER = exports.SET_FILTER_POPOVER = 'SET_FILTER_POPOVER';

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var horseUrlBuilder = function horseUrlBuilder(id, name) {
	    if (id && name) {
	        var replaceMap = {
	            ' ': '-',
	            '\'': '',
	            '.': ''
	        };
	
	        var urlName = name.toLowerCase().replace(/ |'|./g, function (matched) {
	            return typeof replaceMap[matched] !== 'undefined' ? replaceMap[matched] : matched;
	        });
	
	        return '/profile/horse/' + id + '/' + urlName;
	    }
	    return null;
	};
	
	exports.default = horseUrlBuilder;

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1027),
	    listCacheDelete = __webpack_require__(1028),
	    listCacheGet = __webpack_require__(1029),
	    listCacheHas = __webpack_require__(1030),
	    listCacheSet = __webpack_require__(1031);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(372),
	    eq = __webpack_require__(129);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(129);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1025);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(168),
	    copyObject = __webpack_require__(100),
	    createAssigner = __webpack_require__(1005),
	    isArrayLike = __webpack_require__(56),
	    isPrototype = __webpack_require__(128),
	    keys = __webpack_require__(62);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(970),
	    isObjectLike = __webpack_require__(57);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48),
	    stubFalse = __webpack_require__(1080);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)(module)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(86),
	    isObject = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(371),
	    baseKeysIn = __webpack_require__(977),
	    isArrayLike = __webpack_require__(56);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultCellRangeRenderer = exports.Grid = exports.default = undefined;
	
	var _Grid2 = __webpack_require__(1189);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultCellRangeRenderer2 = __webpack_require__(578);
	
	var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getApiUrl = getApiUrl;
	exports.requestFailure = requestFailure;
	exports.requestEntries = requestEntries;
	exports.receiveEntries = receiveEntries;
	exports.filterStatePristine = filterStatePristine;
	exports.fetchLocal = fetchLocal;
	exports.fetchFilterData = fetchFilterData;
	exports.fetchStallion = fetchStallion;
	exports.mostFeaturedFailure = mostFeaturedFailure;
	exports.mostFeaturedRequest = mostFeaturedRequest;
	exports.mostFeaturedRecieved = mostFeaturedRecieved;
	exports.fetchMostFeatured = fetchMostFeatured;
	exports.toggleFilter = toggleFilter;
	exports.updateFilterType = updateFilterType;
	exports.updateSireLineFlag = updateSireLineFlag;
	exports.dropFilter = dropFilter;
	exports.setAdvancedSectionVisibility = setAdvancedSectionVisibility;
	exports.setFilterPopoverVisibility = setFilterPopoverVisibility;
	
	var _isomorphicFetch = __webpack_require__(945);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _filter = __webpack_require__(190);
	
	var _localStorageHelper = __webpack_require__(112);
	
	var _stallion = __webpack_require__(189);
	
	var stallionActions = _interopRequireWildcard(_stallion);
	
	var _filter2 = __webpack_require__(142);
	
	var filterActions = _interopRequireWildcard(_filter2);
	
	var _dataHelper = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiURL = '/bloodstock/stallion-book/filter';
	var stallionNamesUrl = '/bloodstock/stallion-book/names';
	var mostFeaturedUrl = '/bloodstock/stallion-book/most-featured';
	
	/**
	 * getApiUrl function
	 *
	 * @return string - Resulted Url to make api request
	 *
	 * @param filterObj - Object
	 *
	 * Function iterates over filter object and appends corresponding keys and values
	 * as request parameters to globally declared apiUrl. Fields that are used to
	 * help manage state are taken from stateHelperObj and filtered out
	 * **/
	function getApiUrl(filterObj) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'entries';
	
	    var queryParams = '';
	    var paramsObj = Object.assign({}, filterObj);
	    var excludedKeys = Object.keys(_filter.stateHelperObj);
	
	    if (type === 'names') {
	        return stallionNamesUrl + '?type=' + filterObj.type;
	    }
	
	    Object.keys(paramsObj).filter(function (key) {
	        return paramsObj[key] && excludedKeys.indexOf(key) < 0;
	    }).forEach(function (key) {
	        var isArrayParam = false;
	
	        if (key !== 'studFarm') {
	            paramsObj[key] = paramsObj[key].replace(/\.|'|"|&| /g, '');
	        }
	
	        if (paramsObj[key].split(',').length > 1) {
	            isArrayParam = true;
	            paramsObj[key] = paramsObj[key].split(',').join('&' + key + '[]=');
	        }
	
	        if (key === 'studFee') {
	            var _paramsObj$key$split = paramsObj[key].split('/'),
	                _paramsObj$key$split2 = _slicedToArray(_paramsObj$key$split, 2),
	                minPrice = _paramsObj$key$split2[0],
	                maxPrice = _paramsObj$key$split2[1];
	
	            if (minPrice) {
	                queryParams = queryParams + '&minPrice=' + minPrice;
	            }
	
	            if (maxPrice) {
	                queryParams = queryParams + '&maxPrice=' + maxPrice;
	            }
	            return;
	        }
	
	        queryParams = queryParams ? queryParams + '&' + key + (isArrayParam ? '[]' : '') + '=' + paramsObj[key] : key + '=' + paramsObj[key];
	    });
	
	    return queryParams ? apiURL + '?' + queryParams : apiURL;
	}
	/**
	 * requestFailure function
	 *
	 * @return Object, data request failure action
	 *
	 * @param error - Object, error object received with response
	 * **/
	function requestFailure(error) {
	    return {
	        type: stallionActions.DATA_FAILURE,
	        error: error
	    };
	}
	/**
	 * requestEntries function
	 *
	 * @return Object, corresponding data request action
	 *
	 * @param dataType - string, determines which type of data is being requested
	 * @param initial - boolean, initial action flag, defaults to false
	 * @param isSwitcherAction - boolean, switcher action flag, defaults to false
	 *
	 * Switches over data types to determine which action should be dispatched.
	 * This is necessary as, based on type of data that is being requested,
	 * different logic will be triggered.
	 * **/
	function requestEntries(dataType) {
	    var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var isSwitcherAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    switch (dataType) {
	        case 'stallion':
	            return {
	                type: stallionActions.DATA_REQUEST,
	                initial: initial,
	                isSwitcherAction: isSwitcherAction
	            };
	        default:
	            return {
	                type: stallionActions.RAW_DATA_REQUEST
	            };
	    }
	}
	/**
	 * receiveEntries function
	 *
	 * @return Object, action to dispatch
	 *
	 * @param dataType - string, data type that has been received
	 * @param filterType - string, current state filter type
	 * @param payload - json, data that has been received
	 * @param isSwitcherAction - boolean, switcher action flag
	 * @param initial - boolean, initial action flag
	 *
	 * Returns data request success action with corresponding action type (based on dataType param),
	 * payload (data param), filter type (filterType param) and flags (initial, isSwitcherAction)
	 * **/
	function receiveEntries() {
	    var dataType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'names';
	    var filterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';
	    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var isSwitcherAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var initial = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	    var type = void 0;
	
	    switch (dataType) {
	        case 'stallion':
	            type = stallionActions.DATA_SUCCESS;
	            break;
	        default:
	            type = stallionActions.RAW_DATA_SUCCESS;
	            break;
	    }
	
	    return {
	        type: type,
	        payload: payload,
	        filterType: filterType,
	        isSwitcherAction: isSwitcherAction,
	        initial: initial
	    };
	}
	/**
	 * filterStatePristine function
	 *
	 * @return Object, action to dispatch, set filter state as pristine
	 *
	 * @param initial - boolean, initial action flag
	 * **/
	function filterStatePristine() {
	    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return {
	        type: filterActions.STATE_PRISTINE,
	        initial: initial
	    };
	}
	/**
	 * fetchLocal function
	 *
	 * @param currentFilter - object, current filter state.
	 * @param prefix - string, defaults to "type". Used to determine a type of data that
	 *                 is being pulled from localStorage and form correct payload structure and
	 *                 correct action type to dispatch.
	 * @param dispatch - function, used to dispatch action
	 * @param initial - boolean, used to mark initial data requests.
	 *
	 * Get required data from localStorage and dispatch corresponding action.
	 * **/
	function fetchLocal(currentFilter) {
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'type';
	    var dispatch = arguments[2];
	    var initial = arguments[3];
	
	    var localData = (0, _localStorageHelper.getFromStorage)(prefix + '-' + currentFilter.type);
	    var dataType = 'names';
	
	    if (prefix === 'results') {
	        localData = {
	            stallion_book: localData
	        };
	        dataType = 'stallion';
	    }
	
	    dispatch(receiveEntries(dataType, currentFilter.type, localData, false, initial));
	}
	/**
	 * fetchFilterData function
	 * @return function, action dispatcher
	 *
	 * Filter requires additional data (stallion names), it is being stored in localStorage,
	 * so it is loaded only once. Function checks for data presence in localStorage,
	 * lookup is performed by filter type key (e.g. "type-active"). If data is present -
	 * it will be taken from localStorage, otherwise it will be fetched,
	 * using specific Url (stallionNamesUrl) with current filter type as request param.
	 * **/
	function fetchFilterData() {
	    return function (dispatch, getState) {
	        var currentFilter = getState().filter;
	        var inLocalStorage = (0, _localStorageHelper.hasLocalData)('type-' + currentFilter.type);
	
	        if (inLocalStorage) {
	            fetchLocal(currentFilter, 'type', dispatch);
	        } else {
	            var apiUrl = getApiUrl(currentFilter, 'names');
	            dispatch(requestEntries('names'));
	            (0, _isomorphicFetch2.default)(apiUrl).then(function (response) {
	                return response.json();
	            }).then(function (json) {
	                return dispatch(receiveEntries('names', currentFilter.type, json, true));
	            }).catch(function (error) {
	                return dispatch(requestFailure(error));
	            });
	        }
	    };
	}
	/**
	 * fetchStallion function
	 *
	 * @return function, action dispatcher
	 *
	 * @param initial - boolean, Flag that marks initial data requests.
	 * @param isSwitcherAction - boolean, Flag that marks stallion requests
	 *                                    triggered by switcher actions
	 *
	 * Function is used to fetch stallions. Stallion search results for default filter state is stored
	 * in localStorage for each stallion type group by a specific key (e.g. "results-active").
	 * Initial flag will be received by corresponding reducer to
	 * determine whether results table should be shown,
	 * as we don't show results on first load even though it is available.
	 * isSwitcherAction flag will also be passed to reducer to
	 * help determine if results table should be updated,
	 * as while switching stallion types we should not update results table until user pressed "Search".
	 * If data is present in localStorage and filter is in default state (currentFilter.shouldUpdate),
	 * it will be pulled from localStorage.
	 * **/
	function fetchStallion() {
	    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var isSwitcherAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function (dispatch, getState) {
	        var filterKeysList = Object.keys(_filter.filterValuesInitState);
	
	        var currentFilter = filterKeysList.reduce(function (obj, filterKey) {
	            return Object.assign(obj, _defineProperty({}, filterKey, getState().filter[filterKey]), {});
	        }, _filter.filterValuesInitState);
	
	        var inLocalStorage = (0, _localStorageHelper.hasLocalData)('results-' + currentFilter.type);
	        var isDefaultFilter = !(0, _filter.shouldUpdate)(currentFilter);
	
	        if (inLocalStorage && isDefaultFilter) {
	            fetchLocal(currentFilter, 'results', dispatch, initial);
	            dispatch(filterStatePristine(initial));
	        } else {
	            var defaultFilter = Object.assign({}, _filter.filterValuesInitState, { type: currentFilter.type });
	            var apiUrl = getApiUrl(isSwitcherAction ? defaultFilter : currentFilter);
	
	            dispatch(requestEntries('stallion', initial, isSwitcherAction));
	
	            (0, _isomorphicFetch2.default)(apiUrl).then(function (response) {
	                return response.json();
	            }).then(function (json) {
	                return dispatch(receiveEntries('stallion', currentFilter.type, json, isSwitcherAction, initial));
	            }).then(function () {
	                if (!isSwitcherAction) {
	                    return dispatch(filterStatePristine(initial));
	                }
	                return undefined;
	            }).catch(function (error) {
	                return dispatch(requestFailure(error));
	            });
	        }
	    };
	}
	
	function mostFeaturedFailure(error) {
	    return {
	        type: stallionActions.MOST_FEATURED_FAILURE,
	        error: error
	    };
	}
	
	function mostFeaturedRequest() {
	    return {
	        type: stallionActions.MOST_FEATURED_REQUEST
	    };
	}
	
	function mostFeaturedRecieved(data) {
	    return {
	        type: stallionActions.MOST_FEATURED_SUCCESS,
	        data: data
	    };
	}
	function fetchMostFeatured() {
	    return function (dispatch) {
	        dispatch(mostFeaturedRequest());
	
	        (0, _isomorphicFetch2.default)(mostFeaturedUrl).then(function (response) {
	            return response.json();
	        }).then(function (json) {
	            dispatch(mostFeaturedRecieved((0, _dataHelper.shuffleArray)(json.mostFeatured, new Date().getTime())));
	        }).catch(function (error) {
	            return dispatch(mostFeaturedFailure(error));
	        });
	    };
	}
	
	/**
	 * toggleFilter function
	 *
	 * @return function, toggle filter action dispatcher
	 *
	 * @param type - string, action type of corresponding Select
	 * @param value - string, value of select
	 * **/
	function toggleFilter(type, value) {
	    return function (dispatch) {
	        dispatch({
	            type: type,
	            value: value
	        });
	    };
	}
	/**
	 * updateFilterType function
	 *
	 * @return function, update filter action dispatcher.
	 *
	 * @param value - string, selected value
	 *
	 * Updates state of filter with selected type
	 * **/
	function updateFilterType(value) {
	    return function (dispatch) {
	        dispatch({
	            type: filterActions.TYPE,
	            value: value
	        });
	    };
	}
	/**
	 * updateSireLineFlag function
	 *
	 * @return function, update sire line flag action dispatcher
	 *
	 * @param value - string, selected value
	 *
	 * Updates state of filter with selected sire line flag
	 * **/
	function updateSireLineFlag(value) {
	    return function (dispatch) {
	        dispatch({
	            type: filterActions.SIRE_LINE_FLAG,
	            value: value
	        });
	    };
	}
	/**
	 * dropFilter function
	 *
	 * @return function, drop filter action dispatcher
	 *
	 * Restores filter to default state
	 * **/
	function dropFilter() {
	    return function (dispatch) {
	        dispatch({
	            type: filterActions.CLEAR
	        });
	    };
	}
	/**
	 * toggleAdvancedSection function
	 *
	 * @return function, displays/hide advanced filter section
	 *
	 * Updates state of filter with advanced section visibility flag
	 * **/
	function setAdvancedSectionVisibility(value) {
	    return function (dispatch) {
	        dispatch({
	            type: filterActions.SET_ADVANCED_SECTION,
	            value: value
	        });
	    };
	}
	
	/**
	 * toggleAdvancedSection function
	 *
	 * @return function, displays/hide filter popover for mobiles
	 *
	 * Updates state of filter with popover visibility flag
	 * **/
	function setFilterPopoverVisibility(value) {
	    return function (dispatch) {
	        dispatch({
	            type: filterActions.SET_FILTER_POPOVER,
	            value: value
	        });
	    };
	}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DATA_REQUEST = exports.DATA_REQUEST = 'STALLION_DATA_REQUEST';
	var DATA_SUCCESS = exports.DATA_SUCCESS = 'STALLION_DATA_SUCCESS';
	var DATA_FAILURE = exports.DATA_FAILURE = 'STALLION_DATA_FAILURE';
	var RAW_DATA_SUCCESS = exports.RAW_DATA_SUCCESS = 'STALLION_RAW_DATA_SUCCESS';
	var RAW_DATA_REQUEST = exports.RAW_DATA_REQUEST = 'STALLION_RAW_DATA_REQUEST';
	var MOST_FEATURED_REQUEST = exports.MOST_FEATURED_REQUEST = 'MOST_FEATURED_REQUEST';
	var MOST_FEATURED_SUCCESS = exports.MOST_FEATURED_SUCCESS = 'MOST_FEATURED_SUCCESS';
	var MOST_FEATURED_FAILURE = exports.MOST_FEATURED_FAILURE = 'MOST_FEATURED_FAILURE';

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.shouldUpdate = exports.initState = exports.filterValuesInitState = exports.stateHelperObj = exports.multipleFieldsStudCountryCode = exports.multipleFields = undefined;
	exports.default = filter;
	
	var _filter = __webpack_require__(142);
	
	var filterActions = _interopRequireWildcard(_filter);
	
	var _stallion = __webpack_require__(189);
	
	var stallionActions = _interopRequireWildcard(_stallion);
	
	var _localStorageHelper = __webpack_require__(112);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var searchableFields = {
	    stallion: null,
	    sire: null,
	    sireLine: null,
	    studFarm: null
	};
	
	var singleFields = {
	    sireFlag: null,
	    sireType: 'all',
	    studCountryCode: '',
	    yearToStud: '',
	    distance: '',
	    studFee: '/'
	};
	
	var switcherFields = {
	    sireLineFlag: null,
	    type: 'weatherbys'
	};
	
	var multipleFields = exports.multipleFields = {
	    allWeatherWinners: null,
	    turfWinners: null,
	    hurdleWinners: null,
	    chaseWinners: null,
	    g1Winner: null,
	    g2Winner: null,
	    g3Winner: null,
	    gradeWinners: null,
	    blackTypeWinners: null
	};
	var multipleFieldsStudCountryCode = exports.multipleFieldsStudCountryCode = {
	    'GB,IRE': null,
	    'GB': null,
	    'IRE': null,
	    'FR': null,
	    'GB,IRE,FR': null,
	    'USA': null
	};
	
	var stateHelperObj = exports.stateHelperObj = {
	    touched: true,
	    rawData: {
	        stallionNames: [],
	        sireNames: [],
	        sireLine: [],
	        studFarms: []
	    },
	    isFetching: false
	};
	
	var dynamicFields = Object.assign({}, searchableFields, stateHelperObj);
	
	var filterValuesInitState = exports.filterValuesInitState = Object.assign({}, searchableFields, singleFields, multipleFields, multipleFieldsStudCountryCode, stateHelperObj, switcherFields);
	
	var initState = exports.initState = Object.assign({
	    isFilterVisible: false,
	    isAdvancedSectionExpanded: false
	}, filterValuesInitState);
	
	var shouldUpdate = exports.shouldUpdate = function shouldUpdate(filterObj) {
	    var originState = Object.assign({}, searchableFields, singleFields, multipleFields, multipleFieldsStudCountryCode);
	
	    return Object.keys(originState).some(function (key) {
	        return originState[key] !== filterObj[key];
	    });
	};
	
	function filter() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case filterActions.STATE_PRISTINE:
	            return Object.assign({}, state, {
	                isFilterVisible: false,
	                touched: action.initial
	            });
	        case filterActions.TYPE:
	            return Object.assign({}, state, dynamicFields, {
	                type: action.value,
	                touched: true
	            });
	        case filterActions.SIRE:
	            {
	                return Object.assign({}, state, {
	                    sire: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.SIRE_LINE:
	            {
	                return Object.assign({}, state, {
	                    sireLine: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.SIRE_LINE_FLAG:
	            {
	                return Object.assign({}, state, {
	                    sireLineFlag: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.STALLION:
	            {
	                return Object.assign({}, state, {
	                    stallion: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.SIRE_TYPE:
	            {
	                return Object.assign({}, state, {
	                    sireType: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.WIN_DIST:
	            {
	                return Object.assign({}, state, {
	                    distance: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.YEAR_TO_STUD:
	            {
	                return Object.assign({}, state, {
	                    yearToStud: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.COUNTRY:
	            {
	                var _Object$assign;
	
	                var value = action.value;
	
	
	                if (Array.isArray(value)) {
	                    var countries = Object.assign({}, multipleFieldsStudCountryCode);
	
	                    if (value.indexOf('all') === -1) {
	                        value.forEach(function (v) {
	                            countries[v] = '1';
	                        });
	                    }
	
	                    return Object.assign({}, state, countries, {
	                        touched: true,
	                        studCountryCode: value.join(',')
	                    });
	                }
	                return Object.assign({}, state, (_Object$assign = {}, _defineProperty(_Object$assign, value, state[value] ? null : '1'), _defineProperty(_Object$assign, 'studCountryCode', state.studCountryCode.length > 0 ? state.studCountryCode + ',' + value : value), _defineProperty(_Object$assign, 'touched', true), _Object$assign));
	            }
	        case filterActions.STUD_FARM:
	            {
	                return Object.assign({}, state, {
	                    studFarm: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.STUD_FEE:
	            {
	                return Object.assign({}, state, {
	                    studFee: action.value,
	                    touched: true
	                });
	            }
	        case filterActions.PROGENY_SUCCESS:
	            {
	                var _Object$assign2;
	
	                var _value = action.value;
	
	                if (Array.isArray(_value)) {
	                    var winners = Object.assign({}, multipleFields);
	
	                    _value.forEach(function (v) {
	                        winners[v] = '1';
	                    });
	
	                    return Object.assign({}, state, winners, {
	                        touched: true
	                    });
	                }
	                return Object.assign({}, state, (_Object$assign2 = {}, _defineProperty(_Object$assign2, _value, state[_value] ? null : '1'), _defineProperty(_Object$assign2, 'touched', true), _Object$assign2));
	            }
	        case filterActions.SET_ADVANCED_SECTION:
	            {
	                var _value2 = action.value;
	
	
	                return Object.assign({}, state, {
	                    isAdvancedSectionExpanded: _value2,
	                    touched: true
	                });
	            }
	        case filterActions.SET_FILTER_POPOVER:
	            {
	                var _value3 = action.value;
	
	
	                return Object.assign({}, state, {
	                    isFilterVisible: _value3,
	                    touched: true
	                });
	            }
	        case filterActions.CLEAR:
	            {
	                return Object.assign({}, state, Object.assign(initState, {
	                    isFilterVisible: true,
	                    isAdvancedSectionExpanded: state.isAdvancedSectionExpanded
	                }));
	            }
	        case stallionActions.RAW_DATA_SUCCESS:
	            (0, _localStorageHelper.putToStorage)('type-' + action.filterType, action.payload);
	            return Object.assign({}, state, {
	                rawData: action.payload,
	                isFetching: false
	            });
	        default:
	            {
	                return state;
	            }
	    }
	}

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1032),
	    mapCacheDelete = __webpack_require__(1033),
	    mapCacheGet = __webpack_require__(1034),
	    mapCacheHas = __webpack_require__(1035),
	    mapCacheSet = __webpack_require__(1036);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(167),
	    stackClear = __webpack_require__(1047),
	    stackDelete = __webpack_require__(1048),
	    stackGet = __webpack_require__(1049),
	    stackHas = __webpack_require__(1050),
	    stackSet = __webpack_require__(1051);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(968),
	    createBaseEach = __webpack_require__(1006);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(241),
	    isFlattenable = __webpack_require__(1024);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(368);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(370),
	    stubArray = __webpack_require__(405);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(129),
	    isArrayLike = __webpack_require__(56),
	    isIndex = __webpack_require__(171),
	    isObject = __webpack_require__(42);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(26),
	    isSymbol = __webpack_require__(131);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(386);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)(module)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1008),
	    findIndex = __webpack_require__(1061);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(976),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(249);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Default CellMeasurer `cellSizeCache` implementation.
	 * Permanently caches all cell sizes (identified by column and row index) unless explicitly cleared.
	 * Can be configured to handle uniform cell widths and/or heights as a way of optimizing certain use cases.
	 */
	var DefaultCellSizeCache = function () {
	  function DefaultCellSizeCache() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref$uniformRowHeight = _ref.uniformRowHeight;
	    var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
	    var _ref$uniformColumnWid = _ref.uniformColumnWidth;
	    var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
	
	    _classCallCheck(this, DefaultCellSizeCache);
	
	    this._uniformRowHeight = uniformRowHeight;
	    this._uniformColumnWidth = uniformColumnWidth;
	
	    this._cachedColumnWidth = undefined;
	    this._cachedRowHeight = undefined;
	
	    this._cachedColumnWidths = {};
	    this._cachedRowHeights = {};
	  }
	
	  _createClass(DefaultCellSizeCache, [{
	    key: "clearAllColumnWidths",
	    value: function clearAllColumnWidths() {
	      this._cachedColumnWidth = undefined;
	      this._cachedColumnWidths = {};
	    }
	  }, {
	    key: "clearAllRowHeights",
	    value: function clearAllRowHeights() {
	      this._cachedRowHeight = undefined;
	      this._cachedRowHeights = {};
	    }
	  }, {
	    key: "clearColumnWidth",
	    value: function clearColumnWidth(index) {
	      this._cachedColumnWidth = undefined;
	
	      delete this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "clearRowHeight",
	    value: function clearRowHeight(index) {
	      this._cachedRowHeight = undefined;
	
	      delete this._cachedRowHeights[index];
	    }
	  }, {
	    key: "getColumnWidth",
	    value: function getColumnWidth(index) {
	      return this._uniformColumnWidth ? this._cachedColumnWidth : this._cachedColumnWidths[index];
	    }
	  }, {
	    key: "getRowHeight",
	    value: function getRowHeight(index) {
	      return this._uniformRowHeight ? this._cachedRowHeight : this._cachedRowHeights[index];
	    }
	  }, {
	    key: "setColumnWidth",
	    value: function setColumnWidth(index, width) {
	      this._cachedColumnWidth = width;
	      this._cachedColumnWidths[index] = width;
	    }
	  }, {
	    key: "setRowHeight",
	    value: function setRowHeight(index, height) {
	      this._cachedRowHeight = height;
	      this._cachedRowHeights[index] = height;
	    }
	  }]);
	
	  return DefaultCellSizeCache;
	}();
	
	exports.default = DefaultCellSizeCache;

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCallbackMemoizer;
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback;
	    var indices = _ref.indices;
	
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(props) {
	    return _react2.default.createElement(
	        'span',
	        {
	            className: props.className + ' ' + (props.disabled ? 'disabled' : ''),
	            onClick: props.onClick
	        },
	        props.children
	    );
	};
	
	Button.propTypes = {
	    children: _propTypes2.default.node.isRequired,
	    className: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    disabled: _propTypes2.default.bool
	};
	
	exports.default = Button;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapse = function (_Component) {
	    _inherits(Collapse, _Component);
	
	    function Collapse(props) {
	        _classCallCheck(this, Collapse);
	
	        var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	        _this.state = { childHeight: 0 };
	        return _this;
	    }
	
	    _createClass(Collapse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var childHeightRaw = this.content.clientHeight;
	            var childHeight = this.props.isMobile ? childHeightRaw + 'rem' : childHeightRaw / 16 + 'rem';
	
	            this.setState({ childHeight: childHeight });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                isOpen = _props.isOpen,
	                className = _props.className,
	                useHeightCalcs = _props.useHeightCalcs;
	            var childHeight = this.state.childHeight;
	
	
	            var heightCalcs = useHeightCalcs ? {
	                maxHeight: isOpen ? childHeight : 0
	            } : {};
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className + ' animate_collapse_' + (isOpen ? 'open' : 'close'),
	                    style: heightCalcs,
	                    ref: function ref(content) {
	                        return _this2.content = content;
	                    }
	                },
	                children
	            );
	        }
	    }]);
	
	    return Collapse;
	}(_react.Component);
	
	Collapse.defaultProps = {
	    isOpen: false,
	    useHeightCalcs: true,
	    className: ''
	};
	
	Collapse.propTypes = {
	    children: _propTypes2.default.shape,
	    isOpen: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    useHeightCalcs: _propTypes2.default.bool,
	    isMobile: _propTypes2.default.bool
	};
	exports.default = Collapse;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STALLION = exports.SIRE_LINE = undefined;
	
	var _rpGuiGuide = __webpack_require__(110);
	
	var SIRE_LINE = exports.SIRE_LINE = {
	    items: [{
	        caption: 'All',
	        value: ''
	    }, {
	        caption: 'Return only',
	        value: 'include'
	    }, {
	        caption: 'Exclude',
	        value: 'exclude'
	    }],
	    name: 'sireLineFlag',
	    value: ''
	};
	
	var items = [{
	    caption: 'Weatherbys Stallions',
	    captionResponsive: 'Weatherbys',
	    iconName: 'weatherby',
	    className: 'ui-switcher__btn_weatherbys',
	    value: 'weatherbys'
	}, {
	    caption: 'All active',
	    value: 'active'
	}, {
	    caption: 'All inactive',
	    value: 'inactive'
	}];
	
	var STALLION = exports.STALLION = {
	    items: items,
	    name: 'type',
	    value: 'weatherbys'
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(140);
	
	var _stallion = __webpack_require__(634);
	
	var _stallion2 = _interopRequireDefault(_stallion);
	
	var _switchers = __webpack_require__(635);
	
	var _switchers2 = _interopRequireDefault(_switchers);
	
	var _filter = __webpack_require__(190);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    stallion: _stallion2.default,
	    switchers: _switchers2.default,
	    filter: _filter2.default
	});
	
	exports.default = rootReducer;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mapCountryCodeToCountry = mapCountryCodeToCountry;
	exports.mapCurrencyCodeToSymbol = mapCurrencyCodeToSymbol;
	function mapCountryCodeToCountry(code) {
	    var countries = {
	        FR: 'France',
	        IRE: 'Ireland',
	        CAN: 'Canada',
	        AUS: 'Australia',
	        NZ: 'New Zealand',
	        JPN: 'Japan',
	        GB: 'Great Britain'
	    };
	
	    return countries[code] ? countries[code] : code;
	}
	
	function mapCurrencyCodeToSymbol(code) {
	    var currencies = {
	        "GBP": "£",
	        "EUR": '€',
	        "USD": "$",
	        "JPY": "¥"
	    };
	
	    return currencies[code] ? currencies[code] : code;
	}
	
	/**
	 *
	 * @param input array
	 * @param seed must be unique number, can use new Date().getTime()
	 * @returns shuffled array
	 */
	var shuffleArray = exports.shuffleArray = function shuffleArray(input, seed) {
	    var arr = input;
	    var currentIndex = arr.length;
	    var temporaryValue = void 0;
	    var randomIndex = void 0;
	
	    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
	    // A simple formula used to generate a sequence of pseudo-random numbers.
	    var random = function random(max) {
	        var s = (seed * 9301 + 49297) % 233280;
	        return Math.floor(s / 233280 * max);
	    };
	
	    while (0 !== currentIndex) {
	        randomIndex = random(currentIndex);
	        currentIndex -= 1;
	        temporaryValue = arr[currentIndex];
	        arr[currentIndex] = arr[randomIndex];
	        arr[randomIndex] = temporaryValue;
	    }
	    return arr;
	};

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(280);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(897));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(399);
	var isObject = __webpack_require__(42);
	var isArray = __webpack_require__(26);
	var isFunction = __webpack_require__(176);
	
	// Credits: https://github.com/documentcloud/underscore-contrib
	// Sub module: underscore.object.selectors
	// License: MIT (https://github.com/documentcloud/underscore-contrib/blob/master/LICENSE)
	// https://github.com/documentcloud/underscore-contrib/blob/master/underscore.object.selectors.js
	
	// Will take a path like 'element[0][1].subElement["Hey!.What?"]["[hey]"]'
	// and return ["element", "0", "1", "subElement", "Hey!.What?", "[hey]"]
	function keysFromPath(path) {
	  // from http://codereview.stackexchange.com/a/63010/8176
	  /**
	   * Repeatedly capture either:
	   * - a bracketed expression, discarding optional matching quotes inside, or
	   * - an unbracketed expression, delimited by a dot or a bracket.
	   */
	  var re = /\[("|')(.+)\1\]|([^.\[\]]+)/g;
	
	  var elements = [];
	  var result;
	  while ((result = re.exec(path)) !== null) {
	    elements.push(result[2] || result[3]);
	  }
	  return elements;
	}
	
	// Gets the value at any depth in a nested object based on the
	// path described by the keys given. Keys may be given as an array
	// or as a dot-separated string.
	function getPath(obj, ks) {
	  if (typeof ks == "string") {
	    if (obj[ks] !== undefined) {
	      return obj[ks];
	    }
	    ks = keysFromPath(ks);
	  }
	
	  var i = -1,
	      length = ks.length;
	
	  // If the obj is null or undefined we have to break as
	  // a TypeError will result trying to access any property
	  // Otherwise keep incrementally access the next property in
	  // ks until complete
	  while (++i < length && obj != null) {
	    obj = obj[ks[i]];
	  }
	  return i === length ? obj : void 0;
	}
	
	// Based on the origin underscore _.pick function
	// Credit: https://github.com/jashkenas/underscore/blob/master/underscore.js
	function powerPick(object, keys) {
	  var result = {},
	      obj = object,
	      iteratee;
	  iteratee = function (key, obj) {
	    return key in obj;
	  };
	
	  obj = Object(obj);
	
	  for (var i = 0, length = keys.length; i < length; i++) {
	    var key = keys[i];
	    if (iteratee(key, obj)) result[key] = getPath(obj, key);
	  }
	
	  return result;
	}
	
	// Gets all the keys for a flattened object structure.
	// Doesn't flatten arrays.
	// Input:
	// {
	//  a: {
	//    x: 1,
	//    y: 2
	//  },
	//  b: [3, 4],
	//  c: 5
	// }
	// Output:
	// [
	//  "a.x",
	//  "a.y",
	//  "b",
	//  "c"
	// ]
	function getKeys(obj, prefix) {
	  var keys = [];
	
	  forEach(obj, function (value, key) {
	    var fullKey = prefix ? prefix + "." + key : key;
	    if (isObject(value) && !isArray(value) && !isFunction(value)) {
	      keys = keys.concat(getKeys(value, fullKey));
	    } else {
	      keys.push(fullKey);
	    }
	  });
	
	  return keys;
	}
	
	module.exports = {
	  pick: powerPick,
	  getAt: getPath,
	  keys: getKeys
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(4);
	var ColumnProperties = __webpack_require__(121);
	var pick = __webpack_require__(1078);
	
	var GridRowContainer = React.createClass({
	  displayName: 'GridRowContainer',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "columnSettings": null,
	      "rowSettings": null,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "onRowClick": null,
	      "multipleSelectionSettings": null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      "data": {},
	      "showChildren": false
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setShowChildren(false);
	  },
	  toggleChildren: function toggleChildren() {
	    this.setShowChildren(this.state.showChildren === false);
	  },
	  setShowChildren: function setShowChildren(visible) {
	    this.setState({
	      showChildren: visible
	    });
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridRowContainer: The columnSettings prop is null and it shouldn't be");
	    }
	  },
	  render: function render() {
	    this.verifyProps();
	    var that = this;
	    if (typeof this.props.data === "undefined") {
	      return React.createElement('tbody', null);
	    }
	    var arr = [];
	
	    var columns = this.props.columnSettings.getColumns();
	
	    arr.push(React.createElement(this.props.rowSettings.rowComponent, {
	      useGriddleStyles: this.props.useGriddleStyles,
	      isSubGriddle: this.props.isSubGriddle,
	      data: this.props.rowSettings.isCustom ? pick(this.props.data, columns) : this.props.data,
	      rowData: this.props.rowSettings.isCustom ? this.props.data : null,
	      columnSettings: this.props.columnSettings,
	      rowSettings: this.props.rowSettings,
	      hasChildren: that.props.hasChildren,
	      toggleChildren: that.toggleChildren,
	      showChildren: that.state.showChildren,
	      key: that.props.uniqueId + '_base_row',
	      useGriddleIcons: that.props.useGriddleIcons,
	      parentRowExpandedClassName: this.props.parentRowExpandedClassName,
	      parentRowCollapsedClassName: this.props.parentRowCollapsedClassName,
	      parentRowExpandedComponent: this.props.parentRowExpandedComponent,
	      parentRowCollapsedComponent: this.props.parentRowCollapsedComponent,
	      paddingHeight: that.props.paddingHeight,
	      rowHeight: that.props.rowHeight,
	      onRowClick: that.props.onRowClick,
	      multipleSelectionSettings: this.props.multipleSelectionSettings }));
	
	    var children = null;
	
	    if (that.state.showChildren) {
	      children = that.props.hasChildren && this.props.data["children"].map(function (row, index) {
	        var key = that.props.rowSettings.getRowKey(row, index);
	
	        if (typeof row["children"] !== "undefined") {
	          var Griddle = that.constructor.Griddle;
	          return React.createElement('tr', { key: key, style: { paddingLeft: 5 } }, React.createElement('td', { colSpan: that.props.columnSettings.getVisibleColumnCount(), className: 'griddle-parent', style: that.props.useGriddleStyles ? { border: "none", "padding": "0 0 0 5px" } : null }, React.createElement(Griddle, {
	            rowMetadata: { key: 'id' },
	            isSubGriddle: true,
	            results: [row],
	            columns: that.props.columnSettings.getColumns(),
	            tableClassName: that.props.tableClassName,
	            parentRowExpandedClassName: that.props.parentRowExpandedClassName,
	            parentRowCollapsedClassName: that.props.parentRowCollapsedClassName,
	            showTableHeading: false,
	            showPager: false,
	            columnMetadata: that.props.columnSettings.columnMetadata,
	            parentRowExpandedComponent: that.props.parentRowExpandedComponent,
	            parentRowCollapsedComponent: that.props.parentRowCollapsedComponent,
	            paddingHeight: that.props.paddingHeight,
	            rowHeight: that.props.rowHeight
	          })));
	        }
	
	        return React.createElement(that.props.rowSettings.rowComponent, {
	          useGriddleStyles: that.props.useGriddleStyles,
	          isSubGriddle: that.props.isSubGriddle,
	          data: row,
	          columnSettings: that.props.columnSettings,
	          isChildRow: true,
	          columnMetadata: that.props.columnSettings.columnMetadata,
	          key: key
	        });
	      });
	    }
	
	    return that.props.hasChildren === false ? arr[0] : React.createElement('tbody', null, that.state.showChildren ? arr.concat(children) : arr);
	  }
	});
	
	module.exports = GridRowContainer;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _uniqueId = __webpack_require__(1085);
	
	var RowProperties = (function () {
	  function RowProperties() {
	    var rowMetadata = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var rowComponent = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	    var isCustom = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    _classCallCheck(this, RowProperties);
	
	    this.rowMetadata = rowMetadata;
	    this.rowComponent = rowComponent;
	    this.isCustom = isCustom;
	    // assign unique Id to each griddle instance
	  }
	
	  _createClass(RowProperties, [{
	    key: 'getRowKey',
	    value: function getRowKey(row, key) {
	      var uniqueId;
	
	      if (this.hasRowMetadataKey()) {
	        uniqueId = row[this.rowMetadata.key];
	      } else {
	        uniqueId = _uniqueId("grid_row");
	      }
	
	      //todo: add error handling
	
	      return uniqueId;
	    }
	  }, {
	    key: 'hasRowMetadataKey',
	    value: function hasRowMetadataKey() {
	      return this.hasRowMetadata() && this.rowMetadata.key !== null && this.rowMetadata.key !== undefined;
	    }
	  }, {
	    key: 'getBodyRowMetadataClass',
	    value: function getBodyRowMetadataClass(rowData) {
	      if (this.hasRowMetadata() && this.rowMetadata.bodyCssClassName !== null && this.rowMetadata.bodyCssClassName !== undefined) {
	        if (typeof this.rowMetadata.bodyCssClassName === 'function') {
	          return this.rowMetadata.bodyCssClassName(rowData);
	        } else {
	          return this.rowMetadata.bodyCssClassName;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getHeaderRowMetadataClass',
	    value: function getHeaderRowMetadataClass() {
	      return this.hasRowMetadata() && this.rowMetadata.headerCssClassName !== null && this.rowMetadata.headerCssClassName !== undefined ? this.rowMetadata.headerCssClassName : null;
	    }
	  }, {
	    key: 'hasRowMetadata',
	    value: function hasRowMetadata() {
	      return this.rowMetadata !== null;
	    }
	  }]);
	
	  return RowProperties;
	})();
	
	module.exports = RowProperties;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(239),
	    setCacheAdd = __webpack_require__(1042),
	    setCacheHas = __webpack_require__(1043);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(987),
	    isArguments = __webpack_require__(174),
	    isArray = __webpack_require__(26),
	    isBuffer = __webpack_require__(175),
	    isIndex = __webpack_require__(171),
	    isTypedArray = __webpack_require__(252);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(383);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(367),
	    arrayIncludes = __webpack_require__(959),
	    arrayIncludesWith = __webpack_require__(960),
	    arrayMap = __webpack_require__(85),
	    baseUnary = __webpack_require__(127),
	    cacheHas = __webpack_require__(382);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(241),
	    isArray = __webpack_require__(26);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(374),
	    baseIsNaN = __webpack_require__(973),
	    strictIndexOf = __webpack_require__(1052);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(971),
	    isObjectLike = __webpack_require__(57);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(240),
	    baseIsEqual = __webpack_require__(377);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(128),
	    nativeKeys = __webpack_require__(1038);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(242),
	    isArrayLike = __webpack_require__(56);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85),
	    baseGet = __webpack_require__(123),
	    baseIteratee = __webpack_require__(124),
	    baseMap = __webpack_require__(380),
	    baseSortBy = __webpack_require__(986),
	    baseUnary = __webpack_require__(127),
	    compareMultiple = __webpack_require__(1000),
	    identity = __webpack_require__(130),
	    isArray = __webpack_require__(26);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(367),
	    arraySome = __webpack_require__(961),
	    cacheHas = __webpack_require__(382);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1062),
	    overRest = __webpack_require__(395),
	    setToString = __webpack_require__(396);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(375),
	    getSymbols = __webpack_require__(246),
	    keys = __webpack_require__(62);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(375),
	    getSymbolsIn = __webpack_require__(390),
	    keysIn = __webpack_require__(178);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(391),
	    keys = __webpack_require__(62);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(241),
	    getPrototype = __webpack_require__(245),
	    getSymbols = __webpack_require__(246),
	    stubArray = __webpack_require__(405);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 394 */,
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(958);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(985),
	    shortOut = __webpack_require__(1046);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(370),
	    baseFilter = __webpack_require__(966),
	    baseIteratee = __webpack_require__(124),
	    isArray = __webpack_require__(26);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(369),
	    baseEach = __webpack_require__(242),
	    castFunction = __webpack_require__(993),
	    isArray = __webpack_require__(26);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(123);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(969),
	    hasPath = __webpack_require__(1015);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(56),
	    isObjectLike = __webpack_require__(57);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85),
	    baseIteratee = __webpack_require__(124),
	    baseMap = __webpack_require__(380),
	    isArray = __webpack_require__(26);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(982),
	    basePropertyDeep = __webpack_require__(983),
	    isKey = __webpack_require__(248),
	    toKey = __webpack_require__(102);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(990),
	    isObject = __webpack_require__(42),
	    isSymbol = __webpack_require__(131);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(989);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(373),
	    baseRest = __webpack_require__(125),
	    isArrayLikeObject = __webpack_require__(402);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function() {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        VERSION = '1.5.6',
	        // internal storage for language config files
	        languages = {},
	        defaults = {
	            currentLanguage: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0'
	        },
	        options = {
	            currentLanguage: defaults.currentLanguage,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat
	        },
	        byteSuffixes = {
	            bytes: ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            iec: ['B','KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed (value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	          boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	
	        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((abbr) ? abbr : '') + ((negP && neg) ? ')' : '');
	    }
	
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = ((string.indexOf(byteSuffixes.bytes[power]) > -1) || (string.indexOf(byteSuffixes.iec[power]) > -1))? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numeral = function(input) {
	        if (numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    numeral.language = function(key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return numeral;
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    numeral.languageData = function(key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            languageData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if ( !! val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = numeral.languageData(culture);
	        } catch (e) {
	            languageData = numeral.languageData(numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function(callback /*, initialValue*/) {
	            'use strict';
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this), len = t.length >>> 0, k = 0, value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function(prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	
	    numeral.fn = Numeral.prototype = {
	
	        clone: function() {
	            return numeral(this);
	        },
	
	        format: function (inputString, roundingFunction) {
	            return formatNumeral(this,
	                inputString ? inputString : options.defaultFormat,
	                roundingFunction !== undefined ? roundingFunction : Math.round
	            );
	        },
	
	        unformat: function (inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function() {
	            return this._value;
	        },
	
	        valueOf: function() {
	            return this._value;
	        },
	
	        set: function(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) * (curr * corrFactor) /
	                    (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(this);


/***/ }),
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache;
	  var cellRenderer = _ref.cellRenderer;
	  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
	  var columnStartIndex = _ref.columnStartIndex;
	  var columnStopIndex = _ref.columnStopIndex;
	  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
	  var isScrolling = _ref.isScrolling;
	  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
	  var rowStartIndex = _ref.rowStartIndex;
	  var rowStopIndex = _ref.rowStopIndex;
	  var scrollLeft = _ref.scrollLeft;
	  var scrollTop = _ref.scrollTop;
	  var styleCache = _ref.styleCache;
	  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
	  var visibleColumnIndices = _ref.visibleColumnIndices;
	  var visibleRowIndices = _ref.visibleRowIndices;
	
	  var renderedCells = [];
	  var offsetAdjusted = verticalOffsetAdjustment || horizontalOffsetAdjustment;
	  var canCacheStyle = !isScrolling || !offsetAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = void 0;
	
	      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        style = {
	          height: rowDatum.size,
	          left: columnDatum.offset + horizontalOffsetAdjustment,
	          position: 'absolute',
	          top: rowDatum.offset + verticalOffsetAdjustment,
	          width: columnDatum.size
	        };
	
	        styleCache[key] = style;
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key];
	
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _defaultHeaderRenderer = __webpack_require__(583);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(582);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(581);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	exports.default = Column;
	 false ? Column.propTypes = {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _react.PropTypes.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _react.PropTypes.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _react.PropTypes.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _react.PropTypes.object,
	
	  /** Uniquely identifies the row-data attribute correspnding to this cell */
	  dataKey: _react.PropTypes.any.isRequired,
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _react.PropTypes.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _react.PropTypes.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _react.PropTypes.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _react.PropTypes.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _react.PropTypes.func.isRequired,
	
	  /** Header label for this column */
	  label: _react.PropTypes.string,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _react.PropTypes.number,
	
	  /** Minimum width of column. */
	  minWidth: _react.PropTypes.number,
	
	  /** Optional inline style to apply to cell */
	  style: _react.PropTypes.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SortDirection = __webpack_require__(271);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a Table is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
	    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: classNames,
	      width: 18,
	      height: 18,
	      viewBox: '0 0 24 24'
	    },
	    sortDirection === _SortDirection2.default.ASC ? _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' }) : _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	
	 false ? SortIndicator.propTypes = {
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	} : void 0;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	function defaultCellDataGetter(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var rowData = _ref.rowData;
	
	  if (rowData.get instanceof Function) {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData;
	  var cellDataKey = _ref.cellDataKey;
	  var columnData = _ref.columnData;
	  var rowData = _ref.rowData;
	  var rowIndex = _ref.rowIndex;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortIndicator = __webpack_require__(580);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default table header renderer.
	 */
	function defaultHeaderRenderer(_ref) {
	  var columnData = _ref.columnData;
	  var dataKey = _ref.dataKey;
	  var disableSort = _ref.disableSort;
	  var label = _ref.label;
	  var sortBy = _ref.sortBy;
	  var sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [_react2.default.createElement(
	    'span',
	    {
	      className: 'ReactVirtualized__Table__headerTruncatedText',
	      key: 'label',
	      title: label
	    },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(_react2.default.createElement(_SortIndicator2.default, {
	      key: 'SortIndicator',
	      sortDirection: sortDirection
	    }));
	  }
	
	  return children;
	}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for Table.
	 */
	function defaultRowRenderer(_ref) {
	  var className = _ref.className;
	  var columns = _ref.columns;
	  var index = _ref.index;
	  var isScrolling = _ref.isScrolling;
	  var key = _ref.key;
	  var onRowClick = _ref.onRowClick;
	  var onRowDoubleClick = _ref.onRowDoubleClick;
	  var onRowMouseOver = _ref.onRowMouseOver;
	  var onRowMouseOut = _ref.onRowMouseOut;
	  var rowData = _ref.rowData;
	  var style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.role = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function () {
	        return onRowClick({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function () {
	        return onRowDoubleClick({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function () {
	        return onRowMouseOut({ index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function () {
	        return onRowMouseOver({ index: index, rowData: rowData });
	      };
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, a11yProps, {
	      className: className,
	      key: key,
	      style: style
	    }),
	    columns
	  );
	}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	var mountedInstances = [];
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    document.body.style.pointerEvents = originalBodyPointerEvents;
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (instance) {
	    return instance.__resetIsScrolling();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    clearTimeout(disablePointerEventsTimeoutId);
	  }
	
	  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
	}
	
	function onScrollWindow(event) {
	  if (event.currentTarget === window && originalBodyPointerEvents == null) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	  }
	  enablePointerEventsAfterDelay();
	  mountedInstances.forEach(function (instance) {
	    if (instance.scrollElement === event.currentTarget) {
	      instance.__handleWindowScrollEvent(event);
	    }
	  });
	}
	
	function registerScrollListener(component, element) {
	  if (!mountedInstances.some(function (instance) {
	    return instance.scrollElement === element;
	  })) {
	    element.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component, element) {
	  mountedInstances = mountedInstances.filter(function (instance) {
	    return instance !== component;
	  });
	  if (!mountedInstances.length) {
	    element.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      clearTimeout(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setSwitcherValue = setSwitcherValue;
	function setSwitcherValue(name, value) {
	    return function (dispatch) {
	        dispatch({
	            type: 'SET_SWITCHER_VALUE',
	            name: name,
	            value: value
	        });
	    };
	}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = analyticsPage;
	
	var _rpAnalytics = __webpack_require__(84);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function analyticsPage() {
	    var _segmentio$setCommonT;
	
	    segmentio.setCommonTraits((_segmentio$setCommonT = {}, _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, 'Bloodstock'), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, 'Stallion Book'), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, null), _segmentio$setCommonT));
	
	    segmentio.page();
	}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(282);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedSection = function AdvancedSection(props) {
	  return _react2.default.createElement(
	    'section',
	    {
	      className: '' + (props.isOpen ? 'advanced_section no-padding' : 'advanced_section__hide')
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'sb-filter__section' },
	      _react2.default.createElement(
	        _Collapse2.default,
	        { useHeightCalcs: false, isOpen: props.isOpen },
	        props.children
	      )
	    )
	  );
	};
	
	AdvancedSection.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  isOpen: _propTypes2.default.bool
	};
	
	exports.default = AdvancedSection;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarouselArrow = function (_PureComponent) {
	    _inherits(CarouselArrow, _PureComponent);
	
	    function CarouselArrow() {
	        _classCallCheck(this, CarouselArrow);
	
	        return _possibleConstructorReturn(this, (CarouselArrow.__proto__ || Object.getPrototypeOf(CarouselArrow)).apply(this, arguments));
	    }
	
	    _createClass(CarouselArrow, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                currentSlide = _props.currentSlide,
	                totalSlides = _props.totalSlides,
	                slidesToShow = _props.slidesToShow,
	                className = _props.className,
	                onClick = _props.onClick,
	                arrowSide = _props.arrowSide;
	
	
	            var isLastSlideSection = totalSlides - currentSlide <= slidesToShow;
	
	            if (arrowSide === 'right' && isLastSlideSection || arrowSide === 'left' && currentSlide === 0) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, onClick: onClick },
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    iconName: arrowSide,
	                    size: 'Small'
	                })
	            );
	        }
	    }]);
	
	    return CarouselArrow;
	}(_react.PureComponent);
	
	CarouselArrow.propTypes = {
	    currentSlide: _propTypes2.default.number,
	    totalSlides: _propTypes2.default.number,
	    slidesToShow: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    arrowSide: _propTypes2.default.string
	};
	
	exports.default = CarouselArrow;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(544);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _urlBuilder = __webpack_require__(143);
	
	var _urlBuilder2 = _interopRequireDefault(_urlBuilder);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _dataHelper = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CarouselItem = function (_PureComponent) {
	    _inherits(CarouselItem, _PureComponent);
	
	    function CarouselItem() {
	        _classCallCheck(this, CarouselItem);
	
	        return _possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).apply(this, arguments));
	    }
	
	    _createClass(CarouselItem, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                item = _props.item,
	                isCarouselDragging = _props.isCarouselDragging;
	
	            var carouselLink = (0, _urlBuilder2.default)(item.horseUid, item.styleName);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'carousel-item' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'carousel-item__img-wrapper' },
	                    _react2.default.createElement('img', {
	                        className: 'carousel-item__img',
	                        src: item.stallionImage, alt: '',
	                        onClick: function onClick(e) {
	                            if (isCarouselDragging) {
	                                e.preventDefault();
	                                return;
	                            }
	                            var windowWidth = window.innerWidth;
	
	                            if (windowWidth >= 990) {
	                                window.open(carouselLink, 'popUpWindow', 'width=750,height=800');
	                            } else if (windowWidth < 990 && windowWidth >= 720) {
	                                window.open(carouselLink, '_blank');
	                            } else {
	                                window.open(carouselLink, '_self');
	                            }
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'carousel-item_info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'carousel-item_info-title' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'carousel-item_info-title-text' },
	                            item.styleName,
	                            ' (',
	                            item.countryOriginCode,
	                            ')'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'carousel-item_info-title-fee-box' },
	                            (0, _dataHelper.mapCurrencyCodeToSymbol)(item.feeCurCode),
	                            ' ',
	                            (0, _numeral2.default)(item.studFee).format('0,0')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'carousel-item_info-stud' },
	                        _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'pin', size: 'Small' }),
	                        item.studName,
	                        ', ',
	                        (0, _dataHelper.mapCountryCodeToCountry)(item.studCountryCode)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CarouselItem;
	}(_react.PureComponent);
	
	CarouselItem.propTypes = {
	    isCarouselDragging: _propTypes2.default.bool,
	    item: {
	        horseUid: _propTypes2.default.number,
	        styleName: _propTypes2.default.string,
	        countryOriginCode: _propTypes2.default.string,
	        studFee: _propTypes2.default.number,
	        studFeeCondition: _propTypes2.default.string,
	        studName: _propTypes2.default.string,
	        studCountryCode: _propTypes2.default.string,
	        feeCurCode: _propTypes2.default.string,
	        stallionImage: _propTypes2.default.string
	    }
	};
	
	exports.default = CarouselItem;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterSection = function FilterSection(props) {
	    return _react2.default.createElement(
	        'section',
	        { className: 'sb-filter__section__wrapper' },
	        _react2.default.createElement(
	            'div',
	            { className: 'sb-filter__section' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'sb-filter__header' },
	                props.sectionName
	            ),
	            props.children
	        )
	    );
	};
	
	FilterSection.propTypes = {
	    sectionName: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.node.isRequired
	};
	
	exports.default = FilterSection;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(544);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnPrice = function ColumnPrice(props) {
	    if (!props.data) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            '\u2014'
	        );
	    }
	    var td = props.rowData.private_flag ? 'Private' : props.rowData.fee_cur_code + ' ' + (0, _numeral2.default)(props.data * (props.rowData.exchange_rate || 1)).format('0,0');
	    return _react2.default.createElement(
	        'span',
	        null,
	        td
	    );
	};
	
	ColumnPrice.propTypes = {
	    rowData: _propTypes2.default.object,
	    data: _propTypes2.default.number
	};
	
	exports.default = ColumnPrice;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnShared = function ColumnShared(props) {
	    if (props.data) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            props.data
	        );
	    }
	    return _react2.default.createElement(
	        'span',
	        null,
	        '\u2014'
	    );
	};
	
	ColumnShared.propTypes = {
	    data: _propTypes2.default.any
	};
	
	exports.default = ColumnShared;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _urlBuilder = __webpack_require__(143);
	
	var _urlBuilder2 = _interopRequireDefault(_urlBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnSireLine = function ColumnSireLine(_ref) {
	    var data = _ref.data,
	        rowData = _ref.rowData;
	    return data === '—' ? _react2.default.createElement(
	        'span',
	        null,
	        '\u2014'
	    ) : _react2.default.createElement(
	        'a',
	        {
	            href: (0, _urlBuilder2.default)(rowData.sire_line_uid, rowData.sire_line_style_name),
	            className: 'js-popupLink ui-link ui-link_table'
	        },
	        data,
	        _react2.default.createElement(_rpReactSvgIcon2.default, {
	            iconName: 'right',
	            size: 'XSmall'
	        })
	    );
	};
	
	ColumnSireLine.propTypes = {
	    rowData: _propTypes2.default.object,
	    data: _propTypes2.default.string
	};
	
	exports.default = ColumnSireLine;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _urlBuilder = __webpack_require__(143);
	
	var _urlBuilder2 = _interopRequireDefault(_urlBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnSireName = function ColumnSireName(_ref) {
	    var data = _ref.data,
	        rowData = _ref.rowData;
	    return data === '—' ? _react2.default.createElement(
	        'span',
	        null,
	        '\u2014'
	    ) : _react2.default.createElement(
	        'a',
	        {
	            href: (0, _urlBuilder2.default)(rowData.sire_uid, rowData.sire_style_name),
	            className: 'js-popupLink ui-link ui-link_table'
	        },
	        data,
	        _react2.default.createElement(_rpReactSvgIcon2.default, {
	            iconName: 'right',
	            size: 'XSmall'
	        })
	    );
	};
	
	ColumnSireName.propTypes = {
	    rowData: _propTypes2.default.object,
	    data: _propTypes2.default.string
	};
	
	exports.default = ColumnSireName;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var mapSortColumn = function mapSortColumn(data) {
	    return data.map(function (item) {
	        var studFeeValue = void 0;
	        if (item.private_flag) {
	            studFeeValue = 0.1;
	        } else {
	            studFeeValue = item.stud_fee !== null ? item.stud_fee : 0;
	        }
	
	        var studFee = item.exchange_rate !== null ? studFeeValue / item.exchange_rate : item.stud_fee;
	        var yearToStud = parseInt(item.year_to_stud, 10) ? item.year_to_stud : 0;
	
	        return Object.assign({}, item, {
	            stud_fee: studFee,
	            year_to_stud: yearToStud
	        });
	    });
	};
	
	exports.default = mapSortColumn;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _urlBuilder = __webpack_require__(143);
	
	var _urlBuilder2 = _interopRequireDefault(_urlBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnStallionName = function ColumnStallionName(props) {
	    if (props.data) {
	        var shouldBreakWord = !/\s/.test(props.data);
	        return _react2.default.createElement(
	            'span',
	            { className: 'sb-stallionName ' + (shouldBreakWord ? 'word-break' : '') },
	            _react2.default.createElement(
	                'a',
	                {
	                    href: (0, _urlBuilder2.default)(props.rowData.horse_uid, props.rowData.style_name),
	                    className: 'js-popupLink ui-link ui-link_table'
	                },
	                props.data,
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    iconName: 'right',
	                    size: 'XSmall'
	                })
	            ),
	            function () {
	                if (props.rowData.weatherbys_uid) {
	                    return _react2.default.createElement(_rpReactSvgIcon2.default, {
	                        size: 'Medium',
	                        iconName: 'weatherby',
	                        className: 'sb-stallionName__icon hidden-sm-down'
	                    });
	                }
	                return false;
	            }()
	        );
	    }
	    return _react2.default.createElement(
	        'span',
	        null,
	        '\u2014'
	    );
	};
	
	ColumnStallionName.propTypes = {
	    rowData: _propTypes2.default.object,
	    data: _propTypes2.default.string
	};
	
	exports.default = ColumnStallionName;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failedRequestComponent = function failedRequestComponent() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'ui-errorMessage' },
	        _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'ui-errorMessage__text' },
	            _react2.default.createElement(
	                'div',
	                null,
	                'Search failed.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'ui-errorMessage__text_error' },
	                'Error loading data, please try again.'
	            )
	        )
	    );
	};
	
	exports.default = failedRequestComponent;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	            "span",
	            { className: "hidden-xs-down" },
	            "YEAR"
	        ),
	        " TO STUD"
	    );
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoDataComponent = function NoDataComponent() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'ui-errorMessage' },
	        _react2.default.createElement(
	            'div',
	            { className: 'ui-errorMessage__text' },
	            _react2.default.createElement(
	                'b',
	                null,
	                '0'
	            ),
	            '  Stallions found'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'ui-errorMessage__text' },
	            'No stallions match your search criteria. Please amend your filters and try again.'
	        )
	    );
	};
	
	exports.default = NoDataComponent;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DOTS = '...';
	
	var range = function range(start, end) {
	    var length = end - start + 1;
	    return Array.from({ length: length }, function (_, idx) {
	        return idx + start;
	    });
	};
	
	var GriddlePagingRP = function GriddlePagingRP(props) {
	    var onPageChange = props.onPageChange,
	        totalCount = props.totalCount,
	        _props$siblingCount = props.siblingCount,
	        siblingCount = _props$siblingCount === undefined ? 1 : _props$siblingCount,
	        currentPage = props.currentPage,
	        pageSize = props.pageSize,
	        className = props.className;
	
	    var totalPageCount = Math.ceil(totalCount / pageSize);
	
	    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
	    var totalPageNumbers = siblingCount + 5;
	
	    /*
	    	Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
	    */
	    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
	    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
	
	    var paginationRange = [];
	    /*
	      We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2
	    */
	    var shouldShowLeftDots = leftSiblingIndex > 2;
	    var shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;
	
	    var firstPageIndex = 1;
	    var lastPageIndex = totalPageCount;
	
	    var leftRange = [];
	    var middleRange = [];
	    var rightRange = [];
	    /*
	        Case 1:
	        If the number of pages is less than the page numbers we want to show in our
	        paginationComponent, we return the range [1..totalPageCount]
	        */
	    if (totalPageNumbers >= totalPageCount) {
	        paginationRange = range(1, totalPageCount);
	    }
	
	    /*
	    	Case 2: No left dots to show, but rights dots to be shown
	    */
	    if (!shouldShowLeftDots && shouldShowRightDots) {
	        leftRange = range(1, 4);
	
	        paginationRange = [].concat(_toConsumableArray(leftRange), [DOTS]);
	    }
	
	    /*
	    	Case 3: No right dots to show, but left dots to be shown
	    */
	    if (shouldShowLeftDots && !shouldShowRightDots) {
	        rightRange = range(totalPageCount - 3, totalPageCount);
	        paginationRange = [DOTS].concat(_toConsumableArray(rightRange));
	    }
	
	    /*
	    	Case 4: Both left and right dots to be shown
	    */
	    if (shouldShowLeftDots && shouldShowRightDots) {
	        middleRange = range(leftSiblingIndex, rightSiblingIndex);
	        paginationRange = [DOTS].concat(_toConsumableArray(middleRange), [DOTS]);
	    }
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'pager ui-content ui-btnGroup ui-btnGroup_pagination ' + className
	        },
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'pager-total_count'
	            },
	            _react2.default.createElement(
	                'b',
	                null,
	                totalCount
	            ),
	            '  Stallions found'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'pager__controls' },
	            currentPage !== firstPageIndex ? _react2.default.createElement(
	                'div',
	                {
	                    onClick: function onClick() {
	                        return onPageChange(firstPageIndex);
	                    },
	                    className: 'pager-control__left ui-btn'
	                },
	                _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Small', iconName: 'left' })
	            ) : null,
	            paginationRange.map(function (pageNumber) {
	                if (pageNumber === DOTS) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'pagination-item pager_dots' },
	                        '\u2026'
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'ui-btn_paginationItem' + (currentPage === pageNumber ? '__selected' : '') + ' ui-btn',
	                        key: pageNumber,
	                        'data-value': pageNumber,
	                        onClick: function onClick() {
	                            return onPageChange(pageNumber);
	                        }
	                    },
	                    pageNumber
	                );
	            }),
	            currentPage !== lastPageIndex ? _react2.default.createElement(
	                'div',
	                {
	                    onClick: function onClick() {
	                        return onPageChange(lastPageIndex);
	                    },
	                    className: 'pager-control__left ui-btn'
	                },
	                _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Small', iconName: 'right' })
	            ) : null
	        )
	    );
	};
	
	GriddlePagingRP.propTypes = {
	    className: _propTypes2.default.string,
	    currentPage: _propTypes2.default.number,
	    totalCount: _propTypes2.default.number,
	    pageSize: _propTypes2.default.number,
	    siblingCount: _propTypes2.default.number,
	    onPageChange: _propTypes2.default.func
	};
	
	GriddlePagingRP.defaultProps = {
	    currentPage: 0,
	    pageSize: 36,
	    siblingCount: 1
	};
	
	exports.default = GriddlePagingRP;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _griddleReact = __webpack_require__(937);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _Pagination = __webpack_require__(621);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _ColumnPrice = __webpack_require__(612);
	
	var _ColumnPrice2 = _interopRequireDefault(_ColumnPrice);
	
	var _ColumnStallionName = __webpack_require__(617);
	
	var _ColumnStallionName2 = _interopRequireDefault(_ColumnStallionName);
	
	var _ColumnSireName = __webpack_require__(615);
	
	var _ColumnSireName2 = _interopRequireDefault(_ColumnSireName);
	
	var _ColumnSireLine = __webpack_require__(614);
	
	var _ColumnSireLine2 = _interopRequireDefault(_ColumnSireLine);
	
	var _HeaderYearToStud = __webpack_require__(619);
	
	var _HeaderYearToStud2 = _interopRequireDefault(_HeaderYearToStud);
	
	var _NoDataComponent = __webpack_require__(620);
	
	var _NoDataComponent2 = _interopRequireDefault(_NoDataComponent);
	
	var _FailedRequestComponent = __webpack_require__(618);
	
	var _FailedRequestComponent2 = _interopRequireDefault(_FailedRequestComponent);
	
	var _ColumnShared = __webpack_require__(613);
	
	var _ColumnShared2 = _interopRequireDefault(_ColumnShared);
	
	var _Spinner = __webpack_require__(626);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ColumnSortMapper = __webpack_require__(616);
	
	var _ColumnSortMapper2 = _interopRequireDefault(_ColumnSortMapper);
	
	var _scrollHelper = __webpack_require__(640);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var columnsData = [{
	    columnName: 'style_name',
	    displayName: 'STALLION NAME',
	    customComponent: _ColumnStallionName2.default,
	    sortDirectionCycle: ['asc']
	}, {
	    columnName: 'stud_name',
	    displayName: 'STANDING',
	    customComponent: _ColumnShared2.default,
	    sortDirectionCycle: ['asc']
	}, {
	    columnName: 'stud_country_code',
	    displayName: 'CTRY',
	    customComponent: _ColumnShared2.default,
	    sortDirectionCycle: ['asc'],
	    cssClassName: 'hidden-sm-down'
	}, {
	    columnName: 'stud_fee',
	    displayName: 'STUD FEE',
	    customComponent: _ColumnPrice2.default,
	    sortDirectionCycle: ['desc']
	}, {
	    columnName: 'sire_style_name',
	    displayName: 'SIRE',
	    customComponent: _ColumnSireName2.default,
	    sortDirectionCycle: ['asc'],
	    cssClassName: 'hidden-sm-down'
	}, {
	    columnName: 'sire_line_style_name',
	    displayName: 'SIRE LINE',
	    customComponent: _ColumnSireLine2.default,
	    sortDirectionCycle: ['asc'],
	    cssClassName: 'hidden-sm-down'
	}, {
	    columnName: 'year_to_stud',
	    displayName: 'YEAR TO STUD',
	    customHeaderComponent: _HeaderYearToStud2.default,
	    customComponent: _ColumnShared2.default,
	    sortDirectionCycle: ['desc']
	}].map(function (col, i) {
	    return Object.assign({}, col, {
	        order: i + 1,
	        locked: false,
	        visible: true,
	        multiSort: { columns: ['style_name'], orders: ['asc'] },
	        cssClassName: 'ui-table__cell ' + (col.cssClassName ? col.cssClassName : '')
	    });
	});
	
	var columns = columnsData.map(function (c) {
	    return c.columnName;
	});
	
	var rowMetaData = { bodyCssClassName: 'ui-table__row' };
	
	var RESULTS_PER_PAGE = 36;
	
	var GriddleRP = function (_PureComponent) {
	    _inherits(GriddleRP, _PureComponent);
	
	    function GriddleRP() {
	        _classCallCheck(this, GriddleRP);
	
	        return _possibleConstructorReturn(this, (GriddleRP.__proto__ || Object.getPrototypeOf(GriddleRP)).apply(this, arguments));
	    }
	
	    _createClass(GriddleRP, [{
	        key: 'render',
	        value: function render() {
	            var results = (0, _ColumnSortMapper2.default)(this.props.results);
	
	            var tableClassName = 'ui-table ui-table_sortable ui-table_type1 ' + (this.props.isFetching ? 'fetching' : '');
	
	            var enableSort = true;
	            var sortAscendingClassName = 'ui-table__cell_sorted';
	            var sortDescendingClassName = 'ui-table__cell_sorted';
	
	            if (!(results.length > 1) && !this.props.isFetching) {
	                sortAscendingClassName = '';
	                sortDescendingClassName = '';
	            }
	
	            var visibleColumns = results.length ? columns : [];
	            var visibleColumnsMeta = results.length ? columnsData : {};
	
	            return _react2.default.createElement(_griddleReact2.default, {
	                sortAscendingClassName: sortAscendingClassName,
	                sortDescendingClassName: sortDescendingClassName,
	                rowMetadata: rowMetaData,
	                useGriddleStyles: false,
	                tableClassName: tableClassName,
	                results: results,
	                resultsPerPage: RESULTS_PER_PAGE,
	                columns: visibleColumns,
	                columnMetadata: visibleColumnsMeta,
	                initialSort: 'style_name',
	                useCustomPagerComponent: true,
	                customPagerComponent: function customPagerComponent(pager) {
	                    return _react2.default.createElement(_Pagination2.default, {
	                        className: 'pager__controls',
	                        currentPage: pager.currentPage + 1,
	                        totalCount: results.length,
	                        pageSize: RESULTS_PER_PAGE,
	                        onPageChange: function onPageChange(index) {
	                            return pager.setPage(index - 1);
	                        }
	                    });
	                },
	                customNoDataComponent: this.props.requestFailed ? _FailedRequestComponent2.default : _NoDataComponent2.default,
	                externalLoadingComponent: _Spinner2.default,
	                externalIsLoading: this.props.isFetching,
	                enableSort: enableSort,
	                sortAscendingComponent: _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'upArrowStandard', style: { marginLeft: '4px' }, size: 'XSmall' }),
	                sortDescendingComponent: _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'upArrowStandard', style: { marginLeft: '4px' }, size: 'XSmall', className: 'arrow180' })
	            });
	        }
	    }]);
	
	    return GriddleRP;
	}(_react.PureComponent);
	
	GriddleRP.propTypes = {
	    results: _propTypes2.default.array,
	    isFetching: _propTypes2.default.bool,
	    requestFailed: _propTypes2.default.bool
	};
	exports.default = GriddleRP;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    var headingClassName = 'sb-header__title ' + (props.mobileType === 'mobile' ? 'sb-header__title_mobile' : '');
	
	    var rpLogoClassName = 'sb-header__rp-logo ' + (props.mobileType === 'mobile' ? 'sb-header__rp-logo_mobile' : '');
	
	    var wbLogoClassName = 'sb-header__wb-logo ' + (props.mobileType === 'mobile' ? 'sb-header__wb-logo_mobile' : '');
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'sb-header' },
	        _react2.default.createElement(
	            'div',
	            { className: 'sb-header__wrapper' },
	            _react2.default.createElement(
	                'div',
	                {
	                    className: headingClassName
	                },
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    iconName: 'rpLogo',
	                    className: rpLogoClassName
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'sb-header__logo' },
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    iconName: 'WBLogoV',
	                    className: wbLogoClassName
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'sb-header__description content container' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'The Racing Post Stallion Book contains individual profiles for over 2000 stallions including comprehensive Racing Post data for all stallions',
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sb-header__description_ext' },
	                    '\xA0plus additional Weatherbys data for those included within the ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Weatherbys Stallion Book'
	                    )
	                ),
	                '.'
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    mobileType: _propTypes2.default.string
	};
	
	exports.default = Header;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondarySection = function SecondarySection(props) {
	    return _react2.default.createElement(
	        'section',
	        {
	            className: 'sb-filter__section__wrapper',
	            style: {
	                display: 'flex',
	                flexWrap: 'wrap'
	            }
	        },
	        props.sectionName && _react2.default.createElement(
	            'h4',
	            { className: 'sb-filter__header__advanced__label' },
	            props.sectionName
	        ),
	        props.children
	    );
	};
	
	SecondarySection.propTypes = {
	    sectionName: _propTypes2.default.string,
	    children: _propTypes2.default.node.isRequired
	};
	
	exports.default = SecondarySection;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectBox = function SelectBox(_ref) {
	    var disabledClass = _ref.disabledClass,
	        selectTitle = _ref.selectTitle,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'sb-filter__selectBox col-xs-12 ' + disabledClass },
	        _react2.default.createElement(
	            'label',
	            { className: 'sb-filter__selectBox__label', htmlFor: '' },
	            selectTitle
	        ),
	        children
	    );
	};
	
	SelectBox.propTypes = {
	    selectTitle: _propTypes2.default.string.isRequired,
	    disabledClass: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.node.isRequired
	};
	
	exports.default = SelectBox;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'sb-results__spinner col-md-12' },
	        _react2.default.createElement(_rpReactSvgIcon2.default, {
	            iconName: 'spinner',
	            size: '2XL',
	            className: 'loading-icon'
	        })
	    );
	};
	
	exports.default = Spinner;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwitcherButton = function SwitcherButton(_ref) {
	    var iconName = _ref.iconName,
	        onClick = _ref.onClick,
	        value = _ref.value,
	        label = _ref.label,
	        labelResponsive = _ref.labelResponsive,
	        isSelected = _ref.isSelected,
	        className = _ref.className,
	        displayType = _ref.displayType;
	
	    var RadioSwitcher = function RadioSwitcher() {
	        return _react2.default.createElement(
	            'span',
	            { onClick: isSelected ? null : function () {
	                    return onClick(value);
	                }, className: 'radio' },
	            _react2.default.createElement('input', {
	                id: value,
	                name: 'radio',
	                type: 'radio',
	                onChange: function onChange() {
	                    return null;
	                },
	                defaultChecked: isSelected
	            }),
	            _react2.default.createElement(
	                'label',
	                { htmlFor: value, className: 'radio-label' },
	                label,
	                " ",
	                iconName ? _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: iconName, size: 'Small', className: 'ui-switcher__logo' }) : null
	            )
	        );
	    };
	
	    var BoxSwitcher = function BoxSwitcher() {
	        return _react2.default.createElement(
	            'span',
	            {
	                className: 'ui-switcher__btn ui-btn \n                ' + className + ' ' + (isSelected ? 'ui-btn_primary' : 'ui-btn_secondary'),
	                onClick: isSelected ? null : function () {
	                    return onClick(value);
	                }
	            },
	            _react2.default.createElement(
	                'span',
	                { className: 'ui-switcher__title' },
	                label
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'ui-switcher__title_responsive' },
	                labelResponsive
	            ),
	            iconName && _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: iconName, size: 'Small', className: 'ui-switcher__logo' })
	        );
	    };
	
	    switch (displayType) {
	        case 'radio':
	            return _react2.default.createElement(RadioSwitcher, null);
	        case 'box':
	        default:
	            return _react2.default.createElement(BoxSwitcher, null);
	    }
	};
	
	SwitcherButton.propTypes = {
	    isSelected: _propTypes2.default.bool.isRequired,
	    iconName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    label: _propTypes2.default.string.isRequired,
	    labelResponsive: _propTypes2.default.string,
	    value: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    displayType: _propTypes2.default.string
	};
	
	exports.default = SwitcherButton;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(107);
	
	var _actions = __webpack_require__(188);
	
	var filterActions = _interopRequireWildcard(_actions);
	
	var _Header = __webpack_require__(623);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _GriddleRP = __webpack_require__(622);
	
	var _GriddleRP2 = _interopRequireDefault(_GriddleRP);
	
	var _rpGuiGuide = __webpack_require__(110);
	
	var _Filter = __webpack_require__(629);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _MostFeatured = __webpack_require__(630);
	
	var _MostFeatured2 = _interopRequireDefault(_MostFeatured);
	
	var _Button = __webpack_require__(281);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Collapse = __webpack_require__(282);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_PureComponent) {
	    _inherits(App, _PureComponent);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.props.fetchMostFeatured();
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$stallion = this.props.stallion,
	                isFetching = _props$stallion.isFetching,
	                requestFailed = _props$stallion.requestFailed,
	                data = _props$stallion.data,
	                isFetchingMostFeatured = _props$stallion.isFetchingMostFeatured;
	
	
	            var mobileType = void 0;
	            if (_rpGuiGuide.mobileDetect.mobile()) {
	                mobileType = 'mobile';
	
	                if (_rpGuiGuide.mobileDetect.tablet()) {
	                    mobileType = 'tablet';
	                }
	            }
	
	            var transformedData = data.map(function (item) {
	                return item.sire_line_style_name && item.sire_style_name ? item : Object.assign({}, item, {
	                    sire_line_style_name: item.sire_line_style_name || '—',
	                    sire_style_name: item.sire_style_name || '—'
	                });
	            });
	
	            var toggleMobilePopover = function toggleMobilePopover() {
	                _this2.props.setFilterPopoverVisibility(!_this2.props.isFilterVisible);
	            };
	
	            var MobileFilterButton = function MobileFilterButton() {
	                return _react2.default.createElement(
	                    _Button2.default,
	                    {
	                        className: 'ui-btn ui-btn_large col-md-12 col-sm-12 ui-btn_secondary btn_filter' + (_this2.props.isFilterVisible ? '__active' : ''),
	                        onClick: toggleMobilePopover
	                    },
	                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: "filter", className: "icon_filter" }),
	                    _react2.default.createElement(
	                        'span',
	                        {
	                            className: "title"
	                        },
	                        'Filter Stallions'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'no-padding ' },
	                _react2.default.createElement(_Header2.default, { mobileType: mobileType }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rn-canvas' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container ' },
	                        !this.props.mostFeaturedRequestFailed && !this.props.isFetchingMostFeatured && _react2.default.createElement(
	                            'section',
	                            { className: 'sb-filter__most_featured' },
	                            _react2.default.createElement(_MostFeatured2.default, null)
	                        ),
	                        _react2.default.createElement(
	                            'section',
	                            { className: 'sb-filter__heading_wrapper' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'sb-filter__heading_wrapper_label' },
	                                'Stallion Book'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'button-container button-container__mobile-filter' },
	                                _react2.default.createElement(MobileFilterButton, null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'section',
	                            {
	                                style: {
	                                    display: 'flex',
	                                    flexDirection: 'row',
	                                    justifyContent: 'space-between',
	                                    alignItems: 'flex-start'
	                                },
	                                className: 'sb-page-section row_nospace filter-collapse'
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'filter-left' },
	                                _react2.default.createElement(_Filter2.default, {
	                                    className: '',
	                                    mobileType: mobileType,
	                                    isOpen: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _Collapse2.default,
	                                {
	                                    useHeightCalcs: false,
	                                    className: 'ui-popover collapse collapse-wrapper' + (this.props.isAdvancedSectionExpanded ? '__expanded' : '') + '\n                                    ',
	                                    isOpen: this.props.isFilterVisible
	                                },
	                                _react2.default.createElement(_Filter2.default, {
	                                    mobileType: mobileType,
	                                    isOpen: this.props.isFilterVisible
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'sb-results' },
	                                _react2.default.createElement(_GriddleRP2.default, {
	                                    isFetching: isFetching,
	                                    results: transformedData,
	                                    requestFailed: requestFailed
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.PureComponent);
	
	App.propTypes = {
	    // Injected by React Redux
	    stallion: _propTypes2.default.object.isRequired,
	    // Injected by React Router
	    children: _propTypes2.default.node,
	    isFilterVisible: _propTypes2.default.bool,
	    isAdvancedSectionExpanded: _propTypes2.default.bool,
	    setFilterPopoverVisibility: _propTypes2.default.func,
	    setAdvancedSectionVisibility: _propTypes2.default.func,
	    fetchMostFeatured: _propTypes2.default.func
	};
	
	function mapStateToProps(state) {
	    return {
	        stallion: state.stallion,
	        isFilterVisible: state.filter.isFilterVisible,
	        isAdvancedSectionExpanded: state.filter.isAdvancedSectionExpanded,
	        mostFeaturedItems: state.stallion.mostFeaturedItems,
	        isFetchingMostFeatured: state.stallion.isFetchingMostFeatured,
	        mostFeaturedRequestFailed: state.stallion.mostFeaturedRequestFailed
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, filterActions)(App);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Filter = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(107);
	
	var _lodash = __webpack_require__(103);
	
	var _rpReactSelect = __webpack_require__(1346);
	
	var _rpReactSelect2 = _interopRequireDefault(_rpReactSelect);
	
	var _actions = __webpack_require__(188);
	
	var filterActions = _interopRequireWildcard(_actions);
	
	var _filter = __webpack_require__(142);
	
	var actionTypes = _interopRequireWildcard(_filter);
	
	var _filter2 = __webpack_require__(190);
	
	var _options = __webpack_require__(633);
	
	var filterConfig = _interopRequireWildcard(_options);
	
	var _switchers = __webpack_require__(283);
	
	var switcherConfig = _interopRequireWildcard(_switchers);
	
	var _constructorHelper = __webpack_require__(639);
	
	var _localStorageHelper = __webpack_require__(112);
	
	var _trackHelper = __webpack_require__(641);
	
	var _Button = __webpack_require__(281);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SelectBox = __webpack_require__(625);
	
	var _SelectBox2 = _interopRequireDefault(_SelectBox);
	
	var _Switcher = __webpack_require__(632);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _FilterSection = __webpack_require__(611);
	
	var _FilterSection2 = _interopRequireDefault(_FilterSection);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _AdvanceSection = __webpack_require__(608);
	
	var _AdvanceSection2 = _interopRequireDefault(_AdvanceSection);
	
	var _SecondarySection = __webpack_require__(624);
	
	var _SecondarySection2 = _interopRequireDefault(_SecondarySection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var optionsQueryComparator = function optionsQueryComparator(optionLabel, query) {
	    return (0, _lodash.toLower)(optionLabel).startsWith((0, _lodash.toLower)(query));
	};
	var DEFAULT_PLACEHOLDER = 'Select..';
	
	var Filter = exports.Filter = function (_PureComponent) {
	    _inherits(Filter, _PureComponent);
	
	    function Filter(props) {
	        _classCallCheck(this, Filter);
	
	        var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));
	
	        _constructorHelper.bindAll.call(_this, (0, _constructorHelper.getRegisteredMethods)(Filter));
	        _this.selectOptionRowHeight = 48;
	        _this.getStallionRawData();
	        return _this;
	    }
	
	    _createClass(Filter, [{
	        key: 'getStallionRawData',
	        value: function getStallionRawData() {
	            this.props.fetchFilterData();
	            this.props.fetchStallion(true);
	        }
	    }, {
	        key: 'searchStallions',
	        value: function searchStallions() {
	            (0, _trackHelper.trackSearchClick)();
	            var _props = this.props,
	                filter = _props.filter,
	                stallion = _props.stallion;
	
	            if (!stallion.isFetching && !filter.isFetching && (filter.touched || !stallion.data.length)) {
	                this.props.fetchStallion();
	            }
	        }
	    }, {
	        key: 'toggleFilter',
	        value: function toggleFilter(name, value) {
	            this.props.toggleFilter(actionTypes[name], value || filterConfig[name].defaultValue);
	        }
	    }, {
	        key: 'toggleStudFeeFilter',
	        value: function toggleStudFeeFilter(option) {
	            var prices = ['', ''];
	            if (option) {
	                prices = option.split('/');
	            }
	            this.props.toggleFilter(actionTypes.MIN_PRICE, prices[0]);
	            this.props.toggleFilter(actionTypes.MAX_PRICE, prices[1]);
	        }
	    }, {
	        key: 'toggleMainSwitcher',
	        value: function toggleMainSwitcher(value) {
	            var _props2 = this.props,
	                filter = _props2.filter,
	                stallion = _props2.stallion;
	
	            if (!stallion.isFetching && !filter.isFetching) {
	                this.props.updateFilterType(value);
	                this.props.fetchFilterData();
	            }
	            if (!(0, _localStorageHelper.hasLocalData)('results-' + value)) {
	                this.props.fetchStallion(false, true);
	            }
	        }
	    }, {
	        key: 'toggleSireLineFlag',
	        value: function toggleSireLineFlag(value) {
	            this.props.updateSireLineFlag(value);
	            if (!value) {
	                this.props.toggleFilter(actionTypes.SIRE_LINE, null);
	            }
	        }
	    }, {
	        key: 'toggleAdvancedSection',
	        value: function toggleAdvancedSection() {
	            this.props.setAdvancedSectionVisibility(!this.props.isAdvancedSectionExpanded);
	        }
	    }, {
	        key: 'resetFilter',
	        value: function resetFilter() {
	            var _props3 = this.props,
	                filter = _props3.filter,
	                stallion = _props3.stallion;
	
	
	            if (!stallion.isFetching && !filter.isFetching) {
	                this.props.updateFilterType('weatherbys');
	                this.props.dropFilter();
	                this.props.fetchFilterData();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$filter = this.props.filter,
	                _props$filter$rawData = _props$filter.rawData,
	                stallionNames = _props$filter$rawData.stallionNames,
	                sireNames = _props$filter$rawData.sireNames,
	                sireLines = _props$filter$rawData.sireLine,
	                studFarms = _props$filter$rawData.studFarms,
	                sireLineFlag = _props$filter.sireLineFlag,
	                stallion = _props$filter.stallion,
	                sire = _props$filter.sire,
	                sireType = _props$filter.sireType,
	                sireLine = _props$filter.sireLine,
	                yearToStud = _props$filter.yearToStud,
	                studFee = _props$filter.studFee,
	                studFarm = _props$filter.studFarm,
	                distance = _props$filter.distance,
	                isAdvancedSectionExpanded = _props$filter.isAdvancedSectionExpanded;
	
	            var progenySuccess = Object.keys(_filter2.multipleFields).filter(function (f) {
	                return _this2.props.filter[f];
	            });
	
	            var countryCodes = Object.keys(_filter2.multipleFieldsStudCountryCode).filter(function (f) {
	                return _this2.props.filter[f];
	            });
	
	            var arrowDirectionClassName = isAdvancedSectionExpanded ? 'arrow_display' : 'arrow_hide';
	
	            var filterLocked = this.props.stallion.isFetching || this.props.filter.isFetching;
	            var disabledClass = filterLocked ? 'disabled' : '';
	            var sireLineDisabledClass = !sireLineFlag || filterLocked ? 'disabled' : '';
	
	            var containerClassName = 'sb-filter ';
	
	            return _react2.default.createElement(
	                'div',
	                { className: containerClassName },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sections' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sb-filter__selectBox ' + disabledClass },
	                        _react2.default.createElement(
	                            _FilterSection2.default,
	                            {
	                                sectionName: '' + (this.props.mobileType ? '' : 'Filter Stallions')
	                            },
	                            _react2.default.createElement(_Switcher2.default, {
	                                config: switcherConfig.STALLION,
	                                onButtonClick: this.toggleMainSwitcher,
	                                displayType: 'radio'
	                            }),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Stallion Name',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Stallion Name',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    alphabet: true,
	                                    showSearch: true,
	                                    value: stallion,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: stallionNames,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('STALLION', value);
	                                    },
	                                    optionsQueryComparator: optionsQueryComparator,
	                                    dropdownListHeight: 458
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Country',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Country',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    value: countryCodes.length > 0 ? countryCodes : ['all'],
	                                    optionsSorter: null,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: filterConfig.COUNTRY.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('COUNTRY', value === 'all' ? [] : value);
	                                    },
	                                    multiSelect: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Stallion\'s Sire',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Stallion\'s Sire',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    alphabet: true,
	                                    showSearch: true,
	                                    value: sire,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: sireNames,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('SIRE', value);
	                                    },
	                                    optionsQueryComparator: optionsQueryComparator,
	                                    dropdownListHeight: 458
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Sire Type',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Sire Type',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    value: sireType,
	                                    optionsSorter: null,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: filterConfig.SIRE_TYPE.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('SIRE_TYPE', value);
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                onClick: this.toggleAdvancedSection,
	                                className: 'sb-filter__header__advanced'
	                            },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'sb-filter__header__advanced__label' },
	                                'Advanced'
	                            ),
	                            _react2.default.createElement(_rpReactSvgIcon2.default, {
	                                iconName: 'downArrow',
	                                size: 'Small',
	                                className: arrowDirectionClassName
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _AdvanceSection2.default,
	                        {
	                            isOpen: isAdvancedSectionExpanded && this.props.isOpen,
	                            onClick: this.toggleAdvancedSection
	                        },
	                        _react2.default.createElement(
	                            _SecondarySection2.default,
	                            { sectionName: '' },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: 'sb-filter__selectBox col-xs-12 ' + disabledClass + ' }'
	                                },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'sb-filter__selectBox__label' },
	                                    'Sire Line'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'sb-filter__disclaimer' },
	                                    'Sire Line represents the paternal grandsire of their subject stallion'
	                                ),
	                                _react2.default.createElement(_Switcher2.default, {
	                                    config: switcherConfig.SIRE_LINE,
	                                    onButtonClick: this.toggleSireLineFlag,
	                                    displayType: 'box'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: '',
	                                    disabledClass: sireLineDisabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Sire Line',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    alphabet: true,
	                                    showSearch: true,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    disabled: !sireLineFlag,
	                                    value: sireLine,
	                                    options: sireLines,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('SIRE_LINE', value);
	                                    },
	                                    dropdownListHeight: 458
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _SecondarySection2.default,
	                            { sectionName: 'Stud Criteria' },
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Year to Stud',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Year to Stud',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    optionsSorter: null,
	                                    value: yearToStud,
	                                    options: filterConfig.YEAR_TO_STUD.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('YEAR_TO_STUD', value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Stud Farm',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Stud Farm',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    alphabet: true,
	                                    showSearch: true,
	                                    value: studFarm,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: studFarms,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('STUD_FARM', value);
	                                    },
	                                    dropdownListHeight: 458
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Stud Fee',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Stud Fee',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    optionsSorter: null,
	                                    value: studFee,
	                                    options: filterConfig.STUD_FEE.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('STUD_FEE', value);
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _SecondarySection2.default,
	                            { sectionName: 'Progeny Criteria' },
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Progeny Win Distance',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Progeny Win Distance',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    value: distance,
	                                    optionsSorter: null,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: filterConfig.WIN_DIST.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('WIN_DIST', value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _SelectBox2.default,
	                                {
	                                    selectTitle: 'Progeny Success',
	                                    disabledClass: disabledClass
	                                },
	                                _react2.default.createElement(_rpReactSelect2.default, {
	                                    title: 'Progeny Success',
	                                    rowHeight: this.selectOptionRowHeight,
	                                    value: progenySuccess,
	                                    optionsSorter: null,
	                                    multiSelect: true,
	                                    placeholder: DEFAULT_PLACEHOLDER,
	                                    options: filterConfig.PROGENY_SUCCESS.options,
	                                    onChange: function onChange(value) {
	                                        return _this2.toggleFilter('PROGENY_SUCCESS', value);
	                                    }
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sb-filter__footer' },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            className: ' ui-btn ui-btn_large ui-btn_primary button-container_search',
	                            disabled: filterLocked,
	                            onClick: this.searchStallions
	                        },
	                        'APPLY'
	                    ),
	                    _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            className: 'ui-btn ui-btn_large ui-btn_secondary button-container_reset',
	                            disabled: filterLocked,
	                            onClick: function onClick() {
	                                _this2.resetFilter();
	                            }
	                        },
	                        'RESET'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Filter;
	}(_react.PureComponent);
	
	Filter.propTypes = {
	    stallion: _propTypes2.default.object,
	    filter: _propTypes2.default.object,
	    selects: _propTypes2.default.object,
	    fetchFilterData: _propTypes2.default.func,
	    fetchStallion: _propTypes2.default.func,
	    dropFilter: _propTypes2.default.func,
	    updateFilterType: _propTypes2.default.func,
	    updateSireLineFlag: _propTypes2.default.func,
	    toggleFilter: _propTypes2.default.func,
	    mobileType: _propTypes2.default.string
	};
	
	function mapStateToProps(state) {
	    return {
	        filter: state.filter,
	        stallion: state.stallion,
	        selects: state.selects,
	        isAdvancedSectionExpanded: state.filter.isAdvancedSectionExpanded
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, filterActions)(Filter);

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MostFeatured = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(107);
	
	var _actions = __webpack_require__(188);
	
	var mostFeaturedActions = _interopRequireWildcard(_actions);
	
	var _reactSlick = __webpack_require__(1169);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _CarouselItem = __webpack_require__(610);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _CarouselArrow = __webpack_require__(609);
	
	var _CarouselArrow2 = _interopRequireDefault(_CarouselArrow);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MostFeatured = exports.MostFeatured = function (_PureComponent) {
	    _inherits(MostFeatured, _PureComponent);
	
	    function MostFeatured(props) {
	        _classCallCheck(this, MostFeatured);
	
	        var _this = _possibleConstructorReturn(this, (MostFeatured.__proto__ || Object.getPrototypeOf(MostFeatured)).call(this, props));
	
	        _this.state = {
	            isCarouselDragging: false
	        };
	        return _this;
	    }
	
	    _createClass(MostFeatured, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var data = this.props.data;
	
	
	            var carouselSettings = {
	                dots: true,
	                infinite: false,
	                focusOnSelect: false,
	                lazyLoad: true,
	                swipeToSlide: true,
	                speed: 300,
	                slidesToShow: 4,
	                slidesToScroll: 4,
	                initialSlide: 0,
	                adaptiveHeight: false,
	                beforeChange: function beforeChange() {
	                    return _this2.setState({ isCarouselDragging: true });
	                },
	                afterChange: function afterChange() {
	                    return _this2.setState({ isCarouselDragging: false });
	                },
	                nextArrow: _react2.default.createElement(_CarouselArrow2.default, { slidesToShow: 4, totalSlides: data.length, arrowSide: 'right' }),
	                prevArrow: _react2.default.createElement(_CarouselArrow2.default, { slidesToShow: 4, totalSlides: data.length, arrowSide: 'left' }),
	                responsive: [{
	                    breakpoint: 1278,
	                    settings: {
	                        slidesToShow: 3,
	                        slidesToScroll: 1,
	                        initialSlide: 0,
	                        arrows: false,
	                        infinite: false
	                    }
	                }, {
	                    breakpoint: 720,
	                    settings: {
	                        slidesToShow: 2,
	                        slidesToScroll: 1,
	                        initialSlide: 0,
	                        arrows: false,
	                        infinite: false
	                    }
	                }, {
	                    breakpoint: 484,
	                    settings: {
	                        slidesToShow: 1,
	                        slidesToScroll: 1,
	                        initialSlide: 0,
	                        arrows: false,
	                        infinite: false
	                    }
	                }]
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'sb-featured' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sb-featured__heading_wrapper_label' },
	                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'WBLogoH', className: 'wb-logo-svg' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sb-featured__heading_text' },
	                        'Featured Stallions'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactSlick2.default,
	                    carouselSettings,
	                    data.map(function (item) {
	                        return _react2.default.createElement(_CarouselItem2.default, {
	                            key: item.horseUid,
	                            item: item,
	                            isCarouselDragging: _this2.state.isCarouselDragging
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MostFeatured;
	}(_react.PureComponent);
	
	function mapStateToProps(state) {
	    return {
	        data: state.stallion.mostFeaturedItems,
	        isFetchingMostFeatured: state.stallion.isFetchingMostFeatured,
	        error: state.stallion.mostFeaturedRequestFailed
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mostFeaturedActions)(MostFeatured);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(107);
	
	var _App = __webpack_require__(628);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = function Root(_ref) {
	    var store = _ref.store;
	    return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_App2.default, null)
	        )
	    );
	};
	
	Root.propTypes = {
	    store: _propTypes2.default.object.isRequired
	};
	
	exports.default = Root;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Switcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(107);
	
	var _immutable = __webpack_require__(366);
	
	var _switchers = __webpack_require__(606);
	
	var _SwitcherButton = __webpack_require__(627);
	
	var _SwitcherButton2 = _interopRequireDefault(_SwitcherButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switcher = exports.Switcher = function (_PureComponent) {
	    _inherits(Switcher, _PureComponent);
	
	    function Switcher(props) {
	        _classCallCheck(this, Switcher);
	
	        var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props));
	
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        _this.render = _this.render.bind(_this);
	        return _this;
	    }
	
	    _createClass(Switcher, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var config = this.props.config;
	            this.props.setSwitcherValue(config.name, config.value);
	        }
	    }, {
	        key: 'onButtonClick',
	        value: function onButtonClick(value) {
	            this.props.setSwitcherValue(this.props.config.name, value);
	            this.props.onButtonClick(value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                items = _props.config.items,
	                switcher = _props.switcher,
	                displayType = _props.displayType;
	
	
	            return _react2.default.createElement(
	                'form',
	                {
	                    onSubmit: this.onButtonClick,
	                    className: 'ui-switcher' + (displayType === 'radio' ? '__radio' : '')
	                },
	                items.map(function (item) {
	                    return _react2.default.createElement(_SwitcherButton2.default, {
	                        key: item.caption,
	                        isSelected: !!switcher && item.value === switcher.get('value'),
	                        label: item.caption,
	                        labelResponsive: item.captionResponsive,
	                        value: item.value,
	                        onClick: _this2.onButtonClick,
	                        iconName: item.iconName || null,
	                        className: item.className || null,
	                        displayType: displayType
	                    });
	                })
	            );
	        }
	    }]);
	
	    return Switcher;
	}(_react.PureComponent);
	
	/* eslint consistent-return: 0*/
	
	
	Switcher.propTypes = {
	    config: _propTypes2.default.shape({
	        items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            caption: _propTypes2.default.string,
	            value: _propTypes2.default.string
	        })),
	        value: _propTypes2.default.string,
	        name: _propTypes2.default.string
	    }),
	    onButtonClick: _propTypes2.default.func.isRequired,
	    setSwitcherValue: _propTypes2.default.func,
	    switcher: function switcher(props, propName, componentName) {
	        var propValue = props[propName];
	        if (propValue && !_immutable.Map.isMap(propValue)) {
	            return new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. ' + propName + ' must be a Map.');
	        }
	    }
	};
	function mapStateToProps(state, ownProps) {
	    return {
	        switcher: state.switchers.get(ownProps.config.name)
	    };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setSwitcherValue: function setSwitcherValue(name, value) {
	            dispatch((0, _switchers.setSwitcherValue)(name, value));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Switcher);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SIRE_LINE = exports.SIRE = exports.STALLION = exports.STUD_FARM = exports.PROGENY_SUCCESS = exports.COUNTRY = exports.STUD_FEE = exports.YEAR_TO_STUD = exports.WIN_DIST = exports.SIRE_TYPE = exports.composeConfig = undefined;
	
	var _lodash = __webpack_require__(103);
	
	var composeConfig = exports.composeConfig = function composeConfig() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var _ref = options.find(function (o) {
	        return o.isDefault;
	    }) || {},
	        value = _ref.value;
	
	    return {
	        options: options,
	        defaultValue: (0, _lodash.isUndefined)(value) ? null : value
	    };
	};
	
	var SIRE_TYPE = exports.SIRE_TYPE = composeConfig([{
	    label: 'All',
	    value: 'all',
	    isDefault: true
	}, {
	    label: 'First Crop',
	    value: 'firstCrop'
	}, {
	    label: 'Second Crop',
	    value: 'secondCrop'
	}, {
	    label: 'Third Crop',
	    value: 'thirdCrop'
	}]);
	
	var WIN_DIST = exports.WIN_DIST = composeConfig([{
	    label: 'All',
	    value: '',
	    isDefault: true
	}, {
	    label: '5f',
	    value: '5f'
	}, {
	    label: '6f',
	    value: '6f'
	}, {
	    label: '7f',
	    value: '7f'
	}, {
	    label: '1 mile',
	    value: '1m'
	}, {
	    label: '1m - 1m1f',
	    value: '1m-1m1f'
	}, {
	    label: '1m2f - 1m3f',
	    value: '1m2f-1m3f'
	}, {
	    label: '1m4f - 1m5f',
	    value: '1m4f-1m5f'
	}, {
	    label: '1m6f - 1m7f',
	    value: '1m6f-1m7f'
	}, {
	    label: '2m - plus',
	    value: '2m-null'
	}]);
	
	var yearsList = [{
	    label: 'All',
	    value: '',
	    isDefault: true
	}];
	
	for (var y = new Date().getFullYear(); y >= 1988; y--) {
	    yearsList.push({ label: '' + y, value: '' + y });
	}
	
	var YEAR_TO_STUD = exports.YEAR_TO_STUD = composeConfig(yearsList);
	
	var STUD_FEE = exports.STUD_FEE = composeConfig([{
	    label: 'All',
	    value: '/',
	    isDefault: true
	}, {
	    label: '£5,000 and under',
	    value: '0/5000'
	}, {
	    label: '£5,001 - £10,000',
	    value: '5001/10000'
	}, {
	    label: '£10,001 - £20,000',
	    value: '10001/20000'
	}, {
	    label: '£20,001 - £50,000',
	    value: '20001/50000'
	}, {
	    label: '£50,000+',
	    value: '50000/'
	}]);
	
	var COUNTRY = exports.COUNTRY = composeConfig([{
	    label: 'GB and IRE',
	    value: 'GB,IRE'
	}, {
	    label: 'Great Britain',
	    value: 'GB'
	}, {
	    label: 'Ireland',
	    value: 'IRE'
	}, {
	    label: 'France',
	    value: 'FR'
	}, {
	    label: 'GB, IRE and France',
	    value: 'GB,IRE,FR'
	}, {
	    label: 'USA',
	    value: 'USA'
	}, {
	    label: 'All',
	    value: 'all',
	    isDefault: true
	}]);
	
	var PROGENY_SUCCESS = exports.PROGENY_SUCCESS = composeConfig([{
	    isSelected: false,
	    label: 'Turf winners',
	    value: 'turfWinners'
	}, {
	    isSelected: false,
	    label: 'Hurdle winners',
	    value: 'hurdleWinners'
	}, {
	    isSelected: false,
	    label: 'Chase winners',
	    value: 'chaseWinners'
	}, {
	    isSelected: false,
	    label: 'AW winners',
	    value: 'allWeatherWinners'
	}, {
	    isSelected: false,
	    label: 'G1 winners',
	    value: 'g1Winner'
	}, {
	    isSelected: false,
	    label: 'G2 winners',
	    value: 'g2Winner'
	}, {
	    isSelected: false,
	    label: 'G3 winners',
	    value: 'g3Winner'
	}, {
	    isSelected: false,
	    label: 'Grade winners',
	    value: 'gradeWinners'
	}, {
	    isSelected: false,
	    label: 'Black-type winners',
	    value: 'blackTypeWinners'
	}]);
	
	var STUD_FARM = exports.STUD_FARM = composeConfig();
	var STALLION = exports.STALLION = composeConfig();
	var SIRE = exports.SIRE = composeConfig();
	var SIRE_LINE = exports.SIRE_LINE = composeConfig();

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stallion;
	
	var _stallion = __webpack_require__(189);
	
	var stallionActions = _interopRequireWildcard(_stallion);
	
	var _filter = __webpack_require__(142);
	
	var _localStorageHelper = __webpack_require__(112);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initState = {
	    isFetching: false,
	    data: [],
	    hideResults: true,
	    requestFailed: false,
	
	    isFetchingMostFeatured: false,
	    mostFeaturedItems: [],
	    mostFeaturedRequestFailed: false
	};
	
	function stallion() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case stallionActions.DATA_REQUEST:
	            return Object.assign({}, state, {
	                isFetching: !action.isSwitcherAction,
	                data: action.isSwitcherAction ? state.data : [],
	                hideResults: action.isSwitcherAction ? state.hideResults : action.initial,
	                requestFailed: false
	            });
	        case stallionActions.DATA_SUCCESS:
	            (0, _localStorageHelper.putToStorage)('results-' + action.filterType, action.payload.stallion_book);
	            return Object.assign({}, state, {
	                isFetching: false,
	                hideResults: action.isSwitcherAction ? state.hideResults : action.initial,
	                requestFailed: false,
	                data: action.isSwitcherAction ? state.data : action.payload.stallion_book || []
	            });
	        case stallionActions.DATA_FAILURE:
	            return Object.assign({}, state, {
	                isFetching: false,
	                data: [],
	                requestFailed: true
	            });
	
	        case stallionActions.MOST_FEATURED_REQUEST:
	            return Object.assign({}, state, {
	                isFetchingMostFeatured: true
	            });
	        case stallionActions.MOST_FEATURED_SUCCESS:
	            return Object.assign({}, state, {
	                isFetchingMostFeatured: false,
	                mostFeaturedItems: action.data,
	                requestFailed: false
	            });
	        case stallionActions.MOST_FEATURED_FAILURE:
	            return Object.assign({}, state, {
	                isFetchingMostFeatured: false,
	                mostFeaturedRequestFailed: action.error
	            });
	        case _filter.CLEAR:
	            return Object.assign({}, state, {
	                hideResults: true
	            });
	        default:
	            return state;
	    }
	}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = switchers;
	
	var _immutable = __webpack_require__(366);
	
	var _switchers = __webpack_require__(283);
	
	var switcherConfig = _interopRequireWildcard(_switchers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function switchers() {
	    var _state$mergeDeep2;
	
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_SWITCHER_VALUE':
	            return state.mergeDeep(_defineProperty({}, action.name, {
	                value: action.value
	            }));
	        case 'FILTER_CLEAR':
	            return state.mergeDeep((_state$mergeDeep2 = {}, _defineProperty(_state$mergeDeep2, switcherConfig.SIRE_LINE.name, {
	                value: switcherConfig.SIRE_LINE.value
	            }), _defineProperty(_state$mergeDeep2, switcherConfig.STALLION.name, {
	                value: switcherConfig.STALLION.value
	            }), _state$mergeDeep2));
	        default:
	            return state;
	    }
	}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(140);
	
	var _reduxThunk = __webpack_require__(592);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(284);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxLogger = __webpack_require__(1226);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	    var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reduxLogger2.default)())));
	
	    if (false) {
	        // Enable Webpack hot module replacement for reducers
	        module.hot.accept('../reducers', function () {
	            var nextRootReducer = _reducers.reducers.default;
	            store.replaceReducer(nextRootReducer);
	        });
	    }
	
	    return store;
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _configureStore = __webpack_require__(638);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _configureStore3 = __webpack_require__(636);
	
	var _configureStore4 = _interopRequireDefault(_configureStore3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = void 0;
	if (true) {
	    config = _configureStore2.default;
	} else {
	    config = _configureStore4.default;
	}
	
	exports.default = config;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(140);
	
	var _reduxThunk = __webpack_require__(592);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(284);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	    return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	}
	// import api from '../middleware/api'

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.bindAll = bindAll;
	exports.getRegisteredMethods = getRegisteredMethods;
	function bindAll(methods) {
	    var _this = this;
	
	    if (typeof this !== 'undefined') {
	        methods.forEach(function (methodName) {
	            _this[methodName] = _this[methodName].bind(_this);
	        });
	    }
	}
	
	function getRegisteredMethods(Class) {
	    var classProperties = Object.getOwnPropertyNames(Class.prototype);
	    var standardProps = ['constructor', 'render'];
	    return classProperties.filter(function (methodName) {
	        return standardProps.indexOf(methodName) < 0 && typeof Class.prototype[methodName] === 'function';
	    });
	}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.scroll = scroll;
	function scroll() {
	    var resultsSection = document.querySelector('.sb-results');
	    if (resultsSection) {
	        resultsSection.scrollIntoView(true);
	    }
	}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.trackSearchClick = undefined;
	
	var _rpAnalytics = __webpack_require__(84);
	
	var segment = _interopRequireWildcard(_rpAnalytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var trackSearchClick = exports.trackSearchClick = function trackSearchClick() {
	    segment.track('Stallion Book Search');
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.checkVersionChanges = undefined;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _package = __webpack_require__(950);
	
	var _localStorageHelper = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCurrentVersion = function getCurrentVersion() {
	    var currentDate = (0, _moment2.default)().format('DD.MM.YYYY');
	    return _package.version + ' ' + currentDate;
	};
	
	var checkVersionChanges = exports.checkVersionChanges = function checkVersionChanges() {
	    var savedVersion = (0, _localStorageHelper.getFromStorage)('version');
	    var currentVersion = getCurrentVersion();
	    if (savedVersion !== currentVersion) {
	        (0, _localStorageHelper.purge)();
	        (0, _localStorageHelper.putToStorage)('version', currentVersion);
	    }
	};

/***/ }),
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* Clamp.js 0.5.1
	*
	* Copyright 2011-2013, Joseph Schmitt http://joe.sh
	* Released under the WTFPL license
	* http://sam.zoy.org/wtfpl/
	*/
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	    /**
	     * Clamps a text node.
	     * @param {HTMLElement} element. Element containing the text node to clamp.
	     * @param {Object} options. Options to pass to the clamper.
	     */
	    function clamp(element, options) {
	        options = options || {};
	
	        var self = this,
	            win = window,
	            opt = {
	                clamp:              options.clamp || 2,
	                useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	                splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	                animate:            options.animate || false,
	                truncationChar:     options.truncationChar || '…',
	                truncationHTML:     options.truncationHTML
	            },
	
	            sty = element.style,
	            originalText = element.innerHTML,
	
	            supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	            clampValue = opt.clamp,
	            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	            truncationHTMLContainer;
	            
	        if (opt.truncationHTML) {
	            truncationHTMLContainer = document.createElement('span');
	            truncationHTMLContainer.innerHTML = opt.truncationHTML;
	        }
	
	
	// UTILITY FUNCTIONS __________________________________________________________
	
	        /**
	         * Return the current style for an element.
	         * @param {HTMLElement} elem The element to compute.
	         * @param {string} prop The style property.
	         * @returns {number}
	         */
	        function computeStyle(elem, prop) {
	            if (!win.getComputedStyle) {
	                win.getComputedStyle = function(el, pseudo) {
	                    this.el = el;
	                    this.getPropertyValue = function(prop) {
	                        var re = /(\-([a-z]){1})/g;
	                        if (prop == 'float') prop = 'styleFloat';
	                        if (re.test(prop)) {
	                            prop = prop.replace(re, function () {
	                                return arguments[2].toUpperCase();
	                            });
	                        }
	                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	                    }
	                    return this;
	                }
	            }
	
	            return win.getComputedStyle(elem, null).getPropertyValue(prop);
	        }
	
	        /**
	         * Returns the maximum number of lines of text that should be rendered based
	         * on the current height of the element and the line-height of the text.
	         */
	        function getMaxLines(height) {
	            var availHeight = height || element.clientHeight,
	                lineHeight = getLineHeight(element);
	
	            return Math.max(Math.floor(availHeight/lineHeight), 0);
	        }
	
	        /**
	         * Returns the maximum height a given element should have based on the line-
	         * height of the text and the given clamp value.
	         */
	        function getMaxHeight(clmp) {
	            var lineHeight = getLineHeight(element);
	            return lineHeight * clmp;
	        }
	
	        /**
	         * Returns the line-height of an element as an integer.
	         */
	        function getLineHeight(elem) {
	            var lh = computeStyle(elem, 'line-height');
	            if (lh == 'normal') {
	                // Normal line heights vary from browser to browser. The spec recommends
	                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
	            }
	            return parseInt(lh);
	        }
	
	
	// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	        var splitOnChars = opt.splitOnChars.slice(0),
	            splitChar = splitOnChars[0],
	            chunks,
	            lastChunk;
	        
	        /**
	         * Gets an element's last child. That may be another node or a node's contents.
	         */
	        function getLastChild(elem) {
	            //Current element has children, need to go deeper and get last child as a text node
	            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	                return getLastChild(Array.prototype.slice.call(elem.children).pop());
	            }
	            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
	            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
	                elem.lastChild.parentNode.removeChild(elem.lastChild);
	                return getLastChild(element);
	            }
	            //This is the last child we want, return it
	            else {
	                return elem.lastChild;
	            }
	        }
	        
	        /**
	         * Removes one character at a time from the text until its width or
	         * height is beneath the passed-in max param.
	         */
	        function truncate(target, maxHeight) {
	            if (!maxHeight) {return;}
	            
	            /**
	             * Resets global variables.
	             */
	            function reset() {
	                splitOnChars = opt.splitOnChars.slice(0);
	                splitChar = splitOnChars[0];
	                chunks = null;
	                lastChunk = null;
	            }
	            
	            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	            
	            //Grab the next chunks
	            if (!chunks) {
	                //If there are more characters to try, grab the next one
	                if (splitOnChars.length > 0) {
	                    splitChar = splitOnChars.shift();
	                }
	                //No characters to chunk by. Go character-by-character
	                else {
	                    splitChar = '';
	                }
	                
	                chunks = nodeValue.split(splitChar);
	            }
	            
	            //If there are chunks left to remove, remove the last one and see if
	            // the nodeValue fits.
	            if (chunks.length > 1) {
	                // console.log('chunks', chunks);
	                lastChunk = chunks.pop();
	                // console.log('lastChunk', lastChunk);
	                applyEllipsis(target, chunks.join(splitChar));
	            }
	            //No more chunks can be removed using this character
	            else {
	                chunks = null;
	            }
	            
	            //Insert the custom HTML before the truncation character
	            if (truncationHTMLContainer) {
	                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	            }
	
	            //Search produced valid chunks
	            if (chunks) {
	                //It fits
	                if (element.clientHeight <= maxHeight) {
	                    //There's still more characters to try splitting on, not quite done yet
	                    if (splitOnChars.length >= 0 && splitChar != '') {
	                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	                        chunks = null;
	                    }
	                    //Finished!
	                    else {
	                        return element.innerHTML;
	                    }
	                }
	            }
	            //No valid chunks produced
	            else {
	                //No valid chunks even when splitting by letter, time to move
	                //on to the next node
	                if (splitChar == '') {
	                    applyEllipsis(target, '');
	                    target = getLastChild(element);
	                    
	                    reset();
	                }
	            }
	            
	            //If you get here it means still too big, let's keep truncating
	            if (opt.animate) {
	                setTimeout(function() {
	                    truncate(target, maxHeight);
	                }, opt.animate === true ? 10 : opt.animate);
	            }
	            else {
	                return truncate(target, maxHeight);
	            }
	        }
	        
	        function applyEllipsis(elem, str) {
	            elem.nodeValue = str + opt.truncationChar;
	        }
	
	
	// CONSTRUCTOR ________________________________________________________________
	
	        if (clampValue == 'auto') {
	            clampValue = getMaxLines();
	        }
	        else if (isCSSValue) {
	            clampValue = getMaxLines(parseInt(clampValue));
	        }
	
	        var clampedText;
	        if (supportsNativeClamp && opt.useNativeClamp) {
	            sty.overflow = 'hidden';
	            sty.textOverflow = 'ellipsis';
	            sty.webkitBoxOrient = 'vertical';
	            sty.display = '-webkit-box';
	            sty.webkitLineClamp = clampValue;
	
	            if (isCSSValue) {
	                sty.height = opt.clamp + 'px';
	            }
	        }
	        else {
	            var height = getMaxHeight(clampValue);
	            if (height < element.clientHeight) {
	                clampedText = truncate(getLastChild(element), height);
	            }
	        }
	        
	        return {
	            'original': originalText,
	            'clamped': clampedText
	        }
	    }
	
	    return clamp;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(900);
	var each = __webpack_require__(353).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(898);
	var Util = __webpack_require__(353);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(899);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
912,
/* 914 */
912,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(4);
	
	var CustomFilterContainer = React.createClass({
	  displayName: "CustomFilterContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "placeholderText": ""
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customFilterComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", null);
	    }
	
	    return React.createElement(that.props.customFilterComponent, {
	      changeFilter: this.props.changeFilter,
	      results: this.props.results,
	      currentResults: this.props.currentResults,
	      placeholderText: this.props.placeholderText });
	  }
	});
	
	module.exports = CustomFilterContainer;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var React = __webpack_require__(4);
	
	var CustomPaginationContainer = React.createClass({
	  displayName: "CustomPaginationContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "maxPage": 0,
	      "nextText": "",
	      "previousText": "",
	      "currentPage": 0,
	      "customPagerComponent": {},
	      "customPagerComponentOptions": {}
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customPagerComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", null);
	    }
	
	    return React.createElement(that.props.customPagerComponent, _extends({}, this.props.customPagerComponentOptions, { maxPage: this.props.maxPage, nextText: this.props.nextText, previousText: this.props.previousText, currentPage: this.props.currentPage, setPage: this.props.setPage, previous: this.props.previous, next: this.props.next }));
	  }
	});
	
	module.exports = CustomPaginationContainer;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(4);
	
	var CustomRowComponentContainer = React.createClass({
	  displayName: "CustomRowComponentContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "data": [],
	      "metadataColumns": [],
	      "className": "",
	      "customComponent": {},
	      "globalData": {}
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", { className: this.props.className });
	    }
	
	    var nodes = this.props.data.map(function (row, index) {
	      return React.createElement(that.props.customComponent, { data: row, metadataColumns: that.props.metadataColumns, key: index, globalData: that.props.globalData });
	    });
	
	    var footer = this.props.showPager && this.props.pagingContent;
	    return React.createElement("div", { className: this.props.className, style: this.props.style }, nodes);
	  }
	});
	
	module.exports = CustomRowComponentContainer;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(4);
	
	var GridFilter = React.createClass({
	    displayName: "GridFilter",
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "placeholderText": ""
	        };
	    },
	    handleChange: function handleChange(event) {
	        this.props.changeFilter(event.target.value);
	    },
	    render: function render() {
	        return React.createElement("div", { className: "filter-container" }, React.createElement("input", { type: "text", name: "filter", placeholder: this.props.placeholderText, className: "form-control", onChange: this.handleChange }));
	    }
	});
	
	module.exports = GridFilter;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(4);
	
	var GridNoData = React.createClass({
	    displayName: "GridNoData",
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "noDataMessage": "No Data"
	        };
	    },
	    render: function render() {
	        var that = this;
	
	        return React.createElement("div", null, this.props.noDataMessage);
	    }
	});
	
	module.exports = GridNoData;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(4);
	var assign = __webpack_require__(173);
	
	//needs props maxPage, currentPage, nextFunction, prevFunction
	var GridPagination = React.createClass({
	    displayName: 'GridPagination',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "maxPage": 0,
	            "nextText": "",
	            "previousText": "",
	            "currentPage": 0,
	            "useGriddleStyles": true,
	            "nextClassName": "griddle-next",
	            "previousClassName": "griddle-previous",
	            "nextIconComponent": null,
	            "previousIconComponent": null
	        };
	    },
	    pageChange: function pageChange(event) {
	        this.props.setPage(parseInt(event.target.value, 10) - 1);
	    },
	    render: function render() {
	        var previous = "";
	        var next = "";
	
	        if (this.props.currentPage > 0) {
	            previous = React.createElement('button', { type: 'button', onClick: this.props.previous, style: this.props.useGriddleStyles ? { "color": "#222", border: "none", background: "none", margin: "0 0 0 10px" } : null }, this.props.previousIconComponent, this.props.previousText);
	        }
	
	        if (this.props.currentPage !== this.props.maxPage - 1) {
	            next = React.createElement('button', { type: 'button', onClick: this.props.next, style: this.props.useGriddleStyles ? { "color": "#222", border: "none", background: "none", margin: "0 10px 0 0" } : null }, this.props.nextText, this.props.nextIconComponent);
	        }
	
	        var leftStyle = null;
	        var middleStyle = null;
	        var rightStyle = null;
	
	        if (this.props.useGriddleStyles === true) {
	            var baseStyle = {
	                "float": "left",
	                minHeight: "1px",
	                marginTop: "5px"
	            };
	
	            rightStyle = assign({ textAlign: "right", width: "34%" }, baseStyle);
	            middleStyle = assign({ textAlign: "center", width: "33%" }, baseStyle);
	            leftStyle = assign({ width: "33%" }, baseStyle);
	        }
	
	        var options = [];
	
	        for (var i = 1; i <= this.props.maxPage; i++) {
	            options.push(React.createElement('option', { value: i, key: i }, i));
	        }
	
	        return React.createElement('div', { style: this.props.useGriddleStyles ? { minHeight: "35px" } : null }, React.createElement('div', { className: this.props.previousClassName, style: leftStyle }, previous), React.createElement('div', { className: 'griddle-page', style: middleStyle }, React.createElement('select', { value: this.props.currentPage + 1, onChange: this.pageChange }, options), ' / ', this.props.maxPage), React.createElement('div', { className: this.props.nextClassName, style: rightStyle }, next));
	    }
	});
	
	module.exports = GridPagination;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(4);
	var ColumnProperties = __webpack_require__(121);
	var deep = __webpack_require__(363);
	var isFunction = __webpack_require__(176);
	var fromPairs = __webpack_require__(1063);
	var assign = __webpack_require__(173);
	var defaults = __webpack_require__(1057);
	var toPairs = __webpack_require__(1084);
	var without = __webpack_require__(408);
	
	var GridRow = React.createClass({
	  displayName: 'GridRow',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "isChildRow": false,
	      "showChildren": false,
	      "data": {},
	      "columnSettings": null,
	      "rowSettings": null,
	      "hasChildren": false,
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "onRowClick": null,
	      "multipleSelectionSettings": null
	    };
	  },
	  handleClick: function handleClick(e) {
	    if (this.props.onRowClick !== null && isFunction(this.props.onRowClick)) {
	      this.props.onRowClick(this, e);
	    } else if (this.props.hasChildren) {
	      this.props.toggleChildren();
	    }
	  },
	  handleSelectionChange: function handleSelectionChange(e) {
	    //hack to get around warning that's not super useful in this case
	    return;
	  },
	  handleSelectClick: function handleSelectClick(e) {
	    if (this.props.multipleSelectionSettings.isMultipleSelection) {
	      if (e.target.type === "checkbox") {
	        this.props.multipleSelectionSettings.toggleSelectRow(this.props.data, this.refs.selected.checked);
	      } else {
	        this.props.multipleSelectionSettings.toggleSelectRow(this.props.data, !this.refs.selected.checked);
	      }
	    }
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridRow: The columnSettings prop is null and it shouldn't be");
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    this.verifyProps();
	    var that = this;
	    var columnStyles = null;
	
	    if (this.props.useGriddleStyles) {
	      columnStyles = {
	        margin: "0px",
	        padding: that.props.paddingHeight + "px 5px " + that.props.paddingHeight + "px 5px",
	        height: that.props.rowHeight ? this.props.rowHeight - that.props.paddingHeight * 2 + "px" : null,
	        backgroundColor: "#FFF",
	        borderTopColor: "#DDD",
	        color: "#222"
	      };
	    }
	
	    var columns = this.props.columnSettings.getColumns();
	
	    // make sure that all the columns we need have default empty values
	    // otherwise they will get clipped
	    var defaultValues = fromPairs(columns, []);
	
	    // creates a 'view' on top the data so we will not alter the original data but will allow us to add default values to missing columns
	    var dataView = assign({}, this.props.data);
	
	    defaults(dataView, defaultValues);
	    var data = toPairs(deep.pick(dataView, without(columns, 'children')));
	    var nodes = data.map(function (col, index) {
	      var returnValue = null;
	      var meta = _this.props.columnSettings.getColumnMetadataByName(col[0]);
	
	      //todo: Make this not as ridiculous looking
	      var firstColAppend = index === 0 && _this.props.hasChildren && _this.props.showChildren === false && _this.props.useGriddleIcons ? React.createElement('span', { style: _this.props.useGriddleStyles ? { fontSize: "10px", marginRight: "5px" } : null }, _this.props.parentRowCollapsedComponent) : index === 0 && _this.props.hasChildren && _this.props.showChildren && _this.props.useGriddleIcons ? React.createElement('span', { style: _this.props.useGriddleStyles ? { fontSize: "10px" } : null }, _this.props.parentRowExpandedComponent) : "";
	
	      if (index === 0 && _this.props.isChildRow && _this.props.useGriddleStyles) {
	        columnStyles = assign(columnStyles, { paddingLeft: 10 });
	      }
	
	      if (_this.props.columnSettings.hasColumnMetadata() && typeof meta !== 'undefined' && meta !== null) {
	        if (typeof meta.customComponent !== 'undefined' && meta.customComponent !== null) {
	          var customComponent = React.createElement(meta.customComponent, { data: col[1], rowData: dataView, metadata: meta });
	          returnValue = React.createElement('td', { onClick: _this.handleClick, className: meta.cssClassName, key: index, style: columnStyles }, customComponent);
	        } else {
	          returnValue = React.createElement('td', { onClick: _this.handleClick, className: meta.cssClassName, key: index, style: columnStyles }, firstColAppend, col[1]);
	        }
	      }
	
	      return returnValue || React.createElement('td', { onClick: _this.handleClick, key: index, style: columnStyles }, firstColAppend, col[1]);
	    });
	
	    if (nodes && this.props.multipleSelectionSettings && this.props.multipleSelectionSettings.isMultipleSelection) {
	      var selectedRowIds = this.props.multipleSelectionSettings.getSelectedRowIds();
	
	      nodes.unshift(React.createElement('td', { key: 'selection', style: columnStyles }, React.createElement('input', {
	        type: 'checkbox',
	        checked: this.props.multipleSelectionSettings.getIsRowChecked(dataView),
	        onChange: this.handleSelectionChange,
	        ref: 'selected' })));
	    }
	
	    //Get the row from the row settings.
	    var className = that.props.rowSettings && that.props.rowSettings.getBodyRowMetadataClass(that.props.data) || "standard-row";
	
	    if (that.props.isChildRow) {
	      className = "child-row";
	    } else if (that.props.hasChildren) {
	      className = that.props.showChildren ? this.props.parentRowExpandedClassName : this.props.parentRowCollapsedClassName;
	    }
	    return React.createElement('tr', { onClick: this.props.multipleSelectionSettings && this.props.multipleSelectionSettings.isMultipleSelection ? this.handleSelectClick : null, className: className }, nodes);
	  }
	});
	
	module.exports = GridRow;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(4);
	var includes = __webpack_require__(1064);
	var without = __webpack_require__(408);
	var find = __webpack_require__(250);
	
	var GridSettings = React.createClass({
	    displayName: 'GridSettings',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columns": [],
	            "columnMetadata": [],
	            "selectedColumns": [],
	            "settingsText": "",
	            "maxRowsText": "",
	            "resultsPerPage": 0,
	            "enableToggleCustom": false,
	            "useCustomComponent": false,
	            "useGriddleStyles": true,
	            "toggleCustomComponent": function toggleCustomComponent() {}
	        };
	    },
	    setPageSize: function setPageSize(event) {
	        var value = parseInt(event.target.value, 10);
	        this.props.setPageSize(value);
	    },
	    handleChange: function handleChange(event) {
	        var columnName = event.target.dataset ? event.target.dataset.name : event.target.getAttribute('data-name');
	        if (event.target.checked === true && includes(this.props.selectedColumns, columnName) === false) {
	            this.props.selectedColumns.push(columnName);
	            this.props.setColumns(this.props.selectedColumns);
	        } else {
	            /* redraw with the selected columns minus the one just unchecked */
	            this.props.setColumns(without(this.props.selectedColumns, columnName));
	        }
	    },
	    render: function render() {
	        var that = this;
	
	        var nodes = [];
	        //don't show column selector if we're on a custom component
	        if (that.props.useCustomComponent === false) {
	            nodes = this.props.columns.map(function (col, index) {
	                var checked = includes(that.props.selectedColumns, col);
	                //check column metadata -- if this one is locked make it disabled and don't put an onChange event
	                var meta = find(that.props.columnMetadata, { columnName: col });
	                var displayName = col;
	
	                if (typeof meta !== "undefined" && typeof meta.displayName !== "undefined" && meta.displayName != null) {
	                    displayName = meta.displayName;
	                }
	
	                if (typeof meta !== "undefined" && meta != null && meta.locked) {
	                    return React.createElement('div', { className: 'column checkbox' }, React.createElement('label', null, React.createElement('input', { type: 'checkbox', disabled: true, name: 'check', checked: checked, 'data-name': col }), displayName));
	                } else if (typeof meta !== "undefined" && meta != null && typeof meta.visible !== "undefined" && meta.visible === false) {
	                    return null;
	                }
	                return React.createElement('div', { className: 'griddle-column-selection checkbox', key: col, style: that.props.useGriddleStyles ? { "float": "left", width: "20%" } : null }, React.createElement('label', null, React.createElement('input', { type: 'checkbox', name: 'check', onChange: that.handleChange, checked: checked, 'data-name': col }), displayName));
	            });
	        }
	
	        var toggleCustom = that.props.enableToggleCustom ? React.createElement('div', { className: 'form-group' }, React.createElement('label', { htmlFor: 'maxRows' }, React.createElement('input', { type: 'checkbox', checked: this.props.useCustomComponent, onChange: this.props.toggleCustomComponent }), ' ', this.props.enableCustomFormatText)) : "";
	
	        var setPageSize = this.props.showSetPageSize ? React.createElement('div', null, React.createElement('label', { htmlFor: 'maxRows' }, this.props.maxRowsText, ':', React.createElement('select', { onChange: this.setPageSize, value: this.props.resultsPerPage }, React.createElement('option', { value: '5' }, '5'), React.createElement('option', { value: '10' }, '10'), React.createElement('option', { value: '25' }, '25'), React.createElement('option', { value: '50' }, '50'), React.createElement('option', { value: '100' }, '100')))) : "";
	
	        return React.createElement('div', { className: 'griddle-settings', style: this.props.useGriddleStyles ? { backgroundColor: "#FFF", border: "1px solid #DDD", color: "#222", padding: "10px", marginBottom: "10px" } : null }, React.createElement('h6', null, this.props.settingsText), React.createElement('div', { className: 'griddle-columns', style: this.props.useGriddleStyles ? { clear: "both", display: "table", width: "100%", borderBottom: "1px solid #EDEDED", marginBottom: "10px" } : null }, nodes), setPageSize, toggleCustom);
	    }
	});
	
	module.exports = GridSettings;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(4);
	var GridTitle = __webpack_require__(936);
	var GridRowContainer = __webpack_require__(364);
	var ColumnProperties = __webpack_require__(121);
	var RowProperties = __webpack_require__(365);
	
	var GridTable = React.createClass({
	  displayName: 'GridTable',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "data": [],
	      "columnSettings": null,
	      "rowSettings": null,
	      "sortSettings": null,
	      "multipleSelectionSettings": null,
	      "className": "",
	      "enableInfiniteScroll": false,
	      "nextPage": null,
	      "hasMorePages": false,
	      "useFixedHeader": false,
	      "useFixedLayout": true,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "filterByColumn": null,
	      "infiniteScrollLoadTreshold": null,
	      "bodyHeight": null,
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "externalLoadingComponent": null,
	      "externalIsLoading": false,
	      "onRowClick": null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      scrollTop: 0,
	      scrollHeight: this.props.bodyHeight,
	      clientHeight: this.props.bodyHeight
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    // After the initial render, see if we need to load additional pages.
	    this.gridScroll();
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // After the subsequent renders, see if we need to load additional pages.
	    this.gridScroll();
	  },
	  gridScroll: function gridScroll() {
	    if (this.props.enableInfiniteScroll && !this.props.externalIsLoading) {
	      // If the scroll height is greater than the current amount of rows displayed, update the page.
	      var scrollable = this.refs.scrollable;
	      var scrollTop = scrollable.scrollTop;
	      var scrollHeight = scrollable.scrollHeight;
	      var clientHeight = scrollable.clientHeight;
	
	      // If the scroll position changed and the difference is greater than a row height
	      if (this.props.rowHeight !== null && this.state.scrollTop !== scrollTop && Math.abs(this.state.scrollTop - scrollTop) >= this.getAdjustedRowHeight()) {
	        var newState = {
	          scrollTop: scrollTop,
	          scrollHeight: scrollHeight,
	          clientHeight: clientHeight
	        };
	
	        // Set the state to the new state
	        this.setState(newState);
	      }
	
	      // Determine the diff by subtracting the amount scrolled by the total height, taking into consideratoin
	      // the spacer's height.
	      var scrollHeightDiff = scrollHeight - (scrollTop + clientHeight) - this.props.infiniteScrollLoadTreshold;
	
	      // Make sure that we load results a little before reaching the bottom.
	      var compareHeight = scrollHeightDiff * 0.6;
	
	      if (compareHeight <= this.props.infiniteScrollLoadTreshold) {
	        this.props.nextPage();
	      }
	    }
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridTable: The columnSettings prop is null and it shouldn't be");
	    }
	    if (this.props.rowSettings === null) {
	      console.error("gridTable: The rowSettings prop is null and it shouldn't be");
	    }
	  },
	  getAdjustedRowHeight: function getAdjustedRowHeight() {
	    return this.props.rowHeight + this.props.paddingHeight * 2; // account for padding.
	  },
	  getNodeContent: function getNodeContent() {
	    this.verifyProps();
	    var that = this;
	
	    //figure out if we need to wrap the group in one tbody or many
	    var anyHasChildren = false;
	
	    // If the data is still being loaded, don't build the nodes unless this is an infinite scroll table.
	    if (!this.props.externalIsLoading || this.props.enableInfiniteScroll) {
	      var nodeData = that.props.data;
	      var aboveSpacerRow = null;
	      var belowSpacerRow = null;
	      var usingDefault = false;
	
	      // If we have a row height specified, only render what's going to be visible.
	      if (this.props.enableInfiniteScroll && this.props.rowHeight !== null && this.refs.scrollable !== undefined) {
	        var adjustedHeight = that.getAdjustedRowHeight();
	        var visibleRecordCount = Math.ceil(that.state.clientHeight / adjustedHeight);
	
	        // Inspired by : http://jsfiddle.net/vjeux/KbWJ2/9/
	        var displayStart = Math.max(0, Math.floor(that.state.scrollTop / adjustedHeight) - visibleRecordCount * 0.25);
	        var displayEnd = Math.min(displayStart + visibleRecordCount * 1.25, this.props.data.length - 1);
	
	        // Split the amount of nodes.
	        nodeData = nodeData.slice(displayStart, displayEnd + 1);
	
	        // Set the above and below nodes.
	        var aboveSpacerRowStyle = { height: displayStart * adjustedHeight + "px" };
	        aboveSpacerRow = React.createElement('tr', { key: 'above-' + aboveSpacerRowStyle.height, style: aboveSpacerRowStyle });
	        var belowSpacerRowStyle = { height: (this.props.data.length - displayEnd) * adjustedHeight + "px" };
	        belowSpacerRow = React.createElement('tr', { key: 'below-' + belowSpacerRowStyle.height, style: belowSpacerRowStyle });
	      }
	
	      var nodes = nodeData.map(function (row, index) {
	        var hasChildren = typeof row["children"] !== "undefined" && row["children"].length > 0;
	        var uniqueId = that.props.rowSettings.getRowKey(row, index);
	
	        //at least one item in the group has children.
	        if (hasChildren) {
	          anyHasChildren = hasChildren;
	        }
	
	        return React.createElement(GridRowContainer, {
	          useGriddleStyles: that.props.useGriddleStyles,
	          isSubGriddle: that.props.isSubGriddle,
	          parentRowExpandedClassName: that.props.parentRowExpandedClassName,
	          parentRowCollapsedClassName: that.props.parentRowCollapsedClassName,
	          parentRowExpandedComponent: that.props.parentRowExpandedComponent,
	          parentRowCollapsedComponent: that.props.parentRowCollapsedComponent,
	          data: row,
	          key: uniqueId + '-container',
	          uniqueId: uniqueId,
	          columnSettings: that.props.columnSettings,
	          rowSettings: that.props.rowSettings,
	          paddingHeight: that.props.paddingHeight,
	          multipleSelectionSettings: that.props.multipleSelectionSettings,
	          rowHeight: that.props.rowHeight,
	          hasChildren: hasChildren,
	          tableClassName: that.props.className,
	          onRowClick: that.props.onRowClick
	        });
	      });
	
	      // no data section
	      if (this.props.showNoData) {
	        var colSpan = this.props.columnSettings.getVisibleColumnCount();
	        nodes.push(React.createElement('tr', { key: 'no-data-section' }, React.createElement('td', { colSpan: colSpan }, this.props.noDataSection)));
	      }
	
	      // Add the spacer rows for nodes we're not rendering.
	      if (aboveSpacerRow) {
	        nodes.unshift(aboveSpacerRow);
	      }
	      if (belowSpacerRow) {
	        nodes.push(belowSpacerRow);
	      }
	
	      // Send back the nodes.
	      return {
	        nodes: nodes,
	        anyHasChildren: anyHasChildren
	      };
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var that = this;
	    var nodes = [];
	
	    // for if we need to wrap the group in one tbody or many
	    var anyHasChildren = false;
	
	    // Grab the nodes to render
	    var nodeContent = this.getNodeContent();
	    if (nodeContent) {
	      nodes = nodeContent.nodes;
	      anyHasChildren = nodeContent.anyHasChildren;
	    }
	
	    var gridStyle = null;
	    var loadingContent = null;
	    var tableStyle = {
	      width: "100%"
	    };
	
	    if (this.props.useFixedLayout) {
	      tableStyle.tableLayout = "fixed";
	    }
	
	    if (this.props.enableInfiniteScroll) {
	      // If we're enabling infinite scrolling, we'll want to include the max height of the grid body + allow scrolling.
	      gridStyle = {
	        "position": "relative",
	        "overflowY": "scroll",
	        "height": this.props.bodyHeight + "px",
	        "width": "100%"
	      };
	    }
	
	    // If we're currently loading, populate the loading content
	    if (this.props.externalIsLoading) {
	      var defaultLoadingStyle = null;
	      var defaultColSpan = null;
	
	      if (this.props.useGriddleStyles) {
	        defaultLoadingStyle = {
	          textAlign: "center",
	          paddingBottom: "40px"
	        };
	      }
	
	      defaultColSpan = this.props.columnSettings.getVisibleColumnCount();
	
	      var loadingComponent = this.props.externalLoadingComponent ? React.createElement(this.props.externalLoadingComponent, null) : React.createElement('div', null, 'Loading...');
	
	      loadingContent = React.createElement('tbody', null, React.createElement('tr', null, React.createElement('td', { style: defaultLoadingStyle, colSpan: defaultColSpan }, loadingComponent)));
	    }
	
	    //construct the table heading component
	    var tableHeading = this.props.showTableHeading ? React.createElement(GridTitle, { useGriddleStyles: this.props.useGriddleStyles, useGriddleIcons: this.props.useGriddleIcons,
	      sortSettings: this.props.sortSettings,
	      multipleSelectionSettings: this.props.multipleSelectionSettings,
	      columnSettings: this.props.columnSettings,
	      filterByColumn: this.props.filterByColumn,
	      rowSettings: this.props.rowSettings }) : undefined;
	
	    //check to see if any of the rows have children... if they don't wrap everything in a tbody so the browser doesn't auto do this
	    if (!anyHasChildren) {
	      nodes = React.createElement('tbody', null, nodes);
	    }
	
	    var pagingContent = React.createElement('tbody', null);
	    if (this.props.showPager) {
	      var pagingStyles = this.props.useGriddleStyles ? {
	        padding: "0px",
	        backgroundColor: "#EDEDED",
	        border: "0px",
	        color: "#222",
	        height: this.props.showNoData ? "20px" : null
	      } : null;
	      pagingContent = React.createElement('tbody', null, React.createElement('tr', null, React.createElement('td', { colSpan: this.props.multipleSelectionSettings.isMultipleSelection ? this.props.columnSettings.getVisibleColumnCount() + 1 : this.props.columnSettings.getVisibleColumnCount(), style: pagingStyles, className: 'footer-container' }, !this.props.showNoData ? this.props.pagingContent : null)));
	    }
	
	    // If we have a fixed header, split into two tables.
	    if (this.props.useFixedHeader) {
	      if (this.props.useGriddleStyles) {
	        tableStyle.tableLayout = "fixed";
	      }
	
	      return React.createElement('div', null, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, tableHeading), React.createElement('div', { ref: 'scrollable', onScroll: this.gridScroll, style: gridStyle }, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, nodes, loadingContent, pagingContent)));
	    }
	
	    return React.createElement('div', { ref: 'scrollable', onScroll: this.gridScroll, style: gridStyle }, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, tableHeading, nodes, loadingContent, pagingContent));
	  }
	});
	
	module.exports = GridTable;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var React = __webpack_require__(4);
	var ColumnProperties = __webpack_require__(121);
	var assign = __webpack_require__(173);
	
	var DefaultHeaderComponent = React.createClass({
	    displayName: 'DefaultHeaderComponent',
	
	    render: function render() {
	        return React.createElement('span', null, this.props.displayName);
	    }
	});
	
	var GridTitle = React.createClass({
	    displayName: 'GridTitle',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columnSettings": null,
	            "filterByColumn": function filterByColumn() {},
	            "rowSettings": null,
	            "sortSettings": null,
	            "multipleSelectionSettings": null,
	            "headerStyle": null,
	            "useGriddleStyles": true,
	            "useGriddleIcons": true,
	            "headerStyles": {}
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this.verifyProps();
	    },
	    sort: function sort(column) {
	        var that = this;
	        return function (event) {
	            that.props.sortSettings.changeSort(column);
	        };
	    },
	    toggleSelectAll: function toggleSelectAll(event) {
	        this.props.multipleSelectionSettings.toggleSelectAll();
	    },
	    handleSelectionChange: function handleSelectionChange(event) {
	        //hack to get around warning message that's not helpful in this case
	        return;
	    },
	    verifyProps: function verifyProps() {
	        if (this.props.columnSettings === null) {
	            console.error("gridTitle: The columnSettings prop is null and it shouldn't be");
	        }
	
	        if (this.props.sortSettings === null) {
	            console.error("gridTitle: The sortSettings prop is null and it shouldn't be");
	        }
	    },
	    render: function render() {
	        this.verifyProps();
	        var that = this;
	        var titleStyles = {};
	
	        var nodes = this.props.columnSettings.getColumns().map(function (col, index) {
	            var defaultTitleStyles = {};
	            var columnSort = "";
	            var columnIsSortable = that.props.columnSettings.getMetadataColumnProperty(col, "sortable", true);
	            var sortComponent = columnIsSortable ? that.props.sortSettings.sortDefaultComponent : null;
	
	            if (that.props.sortSettings.sortColumn == col && that.props.sortSettings.sortDirection === 'asc') {
	                columnSort = that.props.sortSettings.sortAscendingClassName;
	                sortComponent = that.props.useGriddleIcons && that.props.sortSettings.sortAscendingComponent;
	            } else if (that.props.sortSettings.sortColumn == col && that.props.sortSettings.sortDirection === 'desc') {
	                columnSort += that.props.sortSettings.sortDescendingClassName;
	                sortComponent = that.props.useGriddleIcons && that.props.sortSettings.sortDescendingComponent;
	            }
	
	            var meta = that.props.columnSettings.getColumnMetadataByName(col);
	            var displayName = that.props.columnSettings.getMetadataColumnProperty(col, "displayName", col);
	            var HeaderComponent = that.props.columnSettings.getMetadataColumnProperty(col, "customHeaderComponent", DefaultHeaderComponent);
	            var headerProps = that.props.columnSettings.getMetadataColumnProperty(col, "customHeaderComponentProps", {});
	
	            columnSort = meta == null ? columnSort : (columnSort && columnSort + " " || columnSort) + that.props.columnSettings.getMetadataColumnProperty(col, "cssClassName", "");
	
	            if (that.props.useGriddleStyles) {
	                defaultTitleStyles = {
	                    backgroundColor: "#EDEDEF",
	                    border: "0px",
	                    borderBottom: "1px solid #DDD",
	                    color: "#222",
	                    padding: "5px",
	                    cursor: columnIsSortable ? "pointer" : "default"
	                };
	            }
	            titleStyles = meta && meta.titleStyles ? assign({}, defaultTitleStyles, meta.titleStyles) : assign({}, defaultTitleStyles);
	            return React.createElement('th', { onClick: columnIsSortable ? that.sort(col) : null, 'data-title': col, className: columnSort, key: col,
	                style: titleStyles }, React.createElement(HeaderComponent, _extends({ columnName: col, displayName: displayName,
	                filterByColumn: that.props.filterByColumn }, headerProps)), sortComponent);
	        });
	
	        if (nodes && this.props.multipleSelectionSettings.isMultipleSelection) {
	            nodes.unshift(React.createElement('th', { key: 'selection', onClick: this.toggleSelectAll, style: titleStyles }, React.createElement('input', { type: 'checkbox',
	                checked: this.props.multipleSelectionSettings.getIsSelectAllChecked(),
	                onChange: this.handleSelectionChange })));
	        }
	
	        //Get the row from the row settings.
	        var className = that.props.rowSettings && that.props.rowSettings.getHeaderRowMetadataClass() || null;
	
	        return React.createElement('thead', null, React.createElement('tr', {
	            className: className,
	            style: this.props.headerStyles }, nodes));
	    }
	});
	
	module.exports = GridTitle;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var React = __webpack_require__(4);
	var GridTable = __webpack_require__(935);
	var GridFilter = __webpack_require__(930);
	var GridPagination = __webpack_require__(932);
	var GridSettings = __webpack_require__(934);
	var GridNoData = __webpack_require__(931);
	var GridRow = __webpack_require__(933);
	var GridRowContainer = __webpack_require__(364);
	var CustomRowComponentContainer = __webpack_require__(929);
	var CustomPaginationContainer = __webpack_require__(928);
	var CustomFilterContainer = __webpack_require__(927);
	var ColumnProperties = __webpack_require__(121);
	var RowProperties = __webpack_require__(365);
	var deep = __webpack_require__(363);
	
	var drop = __webpack_require__(1059);
	var dropRight = __webpack_require__(1060);
	var find = __webpack_require__(250);
	var first = __webpack_require__(1081);
	var forEach = __webpack_require__(399);
	var initial = __webpack_require__(1065);
	var isArray = __webpack_require__(26);
	var isEmpty = __webpack_require__(1066);
	var isNull = __webpack_require__(1069);
	var isUndefined = __webpack_require__(1072);
	var omit = __webpack_require__(1076);
	var map = __webpack_require__(403);
	var extend = __webpack_require__(173);
	var _filter = __webpack_require__(398);
	
	var _orderBy = __webpack_require__(1077);
	var _property = __webpack_require__(404);
	var _get = __webpack_require__(400);
	
	var Griddle = React.createClass({
	    displayName: 'Griddle',
	
	    statics: {
	        GridTable: GridTable,
	        GridFilter: GridFilter,
	        GridPagination: GridPagination,
	        GridSettings: GridSettings,
	        GridRow: GridRow
	    },
	    columnSettings: null,
	    rowSettings: null,
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columns": [],
	            "gridMetadata": null,
	            "columnMetadata": [],
	            "rowMetadata": null,
	            "results": [], // Used if all results are already loaded.
	            "initialSort": "",
	            "gridClassName": "",
	            "tableClassName": "",
	            "customRowComponentClassName": "",
	            "settingsText": "Settings",
	            "filterPlaceholderText": "Filter Results",
	            "nextText": "Next",
	            "previousText": "Previous",
	            "maxRowsText": "Rows per page",
	            "enableCustomFormatText": "Enable Custom Formatting",
	            //this column will determine which column holds subgrid data
	            //it will be passed through with the data object but will not be rendered
	            "childrenColumnName": "children",
	            //Any column in this list will be treated as metadata and will be passed through with the data but won't be rendered
	            "metadataColumns": [],
	            "showFilter": false,
	            "showSettings": false,
	            "useCustomRowComponent": false,
	            "useCustomGridComponent": false,
	            "useCustomPagerComponent": false,
	            "useCustomFilterer": false,
	            "useCustomFilterComponent": false,
	            "useGriddleStyles": true,
	            "useGriddleIcons": true,
	            "customRowComponent": null,
	            "customGridComponent": null,
	            "customPagerComponent": {},
	            "customFilterComponent": null,
	            "customFilterer": null,
	            "globalData": null,
	            "enableToggleCustom": false,
	            "noDataMessage": "There is no data to display.",
	            "noDataClassName": "griddle-nodata",
	            "customNoDataComponent": null,
	            "allowEmptyGrid": false,
	            "showTableHeading": true,
	            "showPager": true,
	            "useFixedHeader": false,
	            "useExternal": false,
	            "externalSetPage": null,
	            "externalChangeSort": null,
	            "externalSetFilter": null,
	            "externalSetPageSize": null,
	            "externalMaxPage": null,
	            "externalCurrentPage": null,
	            "externalSortColumn": null,
	            "externalSortAscending": true,
	            "externalLoadingComponent": null,
	            "externalIsLoading": false,
	            "enableInfiniteScroll": false,
	            "bodyHeight": null,
	            "paddingHeight": 5,
	            "rowHeight": 25,
	            "infiniteScrollLoadTreshold": 50,
	            "useFixedLayout": true,
	            "isSubGriddle": false,
	            "enableSort": true,
	            "onRowClick": null,
	            /* css class names */
	            "sortAscendingClassName": "sort-ascending",
	            "sortDescendingClassName": "sort-descending",
	            "parentRowCollapsedClassName": "parent-row",
	            "parentRowExpandedClassName": "parent-row expanded",
	            "settingsToggleClassName": "settings",
	            "nextClassName": "griddle-next",
	            "previousClassName": "griddle-previous",
	            "headerStyles": {},
	            /* icon components */
	            "sortAscendingComponent": " ▲",
	            "sortDescendingComponent": " ▼",
	            "sortDefaultComponent": null,
	            "parentRowCollapsedComponent": "▶",
	            "parentRowExpandedComponent": "▼",
	            "settingsIconComponent": "",
	            "nextIconComponent": "",
	            "previousIconComponent": "",
	            "isMultipleSelection": false, //currently does not support subgrids
	            "selectedRowIds": [],
	            "uniqueIdentifier": "id"
	        };
	    },
	    propTypes: {
	        isMultipleSelection: React.PropTypes.bool,
	        selectedRowIds: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.number), React.PropTypes.arrayOf(React.PropTypes.string)]),
	        uniqueIdentifier: React.PropTypes.string
	    },
	    defaultFilter: function defaultFilter(results, filter) {
	        var that = this;
	        return _filter(results, function (item) {
	            var arr = deep.keys(item);
	            for (var i = 0; i < arr.length; i++) {
	                var isFilterable = that.columnSettings.getMetadataColumnProperty(arr[i], "filterable", true);
	                if (isFilterable && (deep.getAt(item, arr[i]) || "").toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
	                    return true;
	                }
	            }
	            return false;
	        });
	    },
	
	    filterByColumnFilters: function filterByColumnFilters(columnFilters) {
	        var filteredResults = Object.keys(columnFilters).reduce(function (previous, current) {
	            return _filter(previous, function (item) {
	                if (deep.getAt(item, current || "").toString().toLowerCase().indexOf(columnFilters[current].toLowerCase()) >= 0) {
	                    return true;
	                }
	
	                return false;
	            });
	        }, this.props.results);
	
	        var newState = {
	            columnFilters: columnFilters
	        };
	
	        if (columnFilters) {
	            newState.filteredResults = filteredResults;
	            newState.maxPage = this.getMaxPage(newState.filteredResults);
	        } else if (this.state.filter) {
	            newState.filteredResults = this.props.useCustomFilterer ? this.props.customFilterer(this.props.results, filter) : this.defaultFilter(this.props.results, filter);
	        } else {
	            newState.filteredResults = null;
	        }
	
	        this.setState(newState);
	    },
	
	    filterByColumn: function filterByColumn(filter, column) {
	        var columnFilters = this.state.columnFilters;
	
	        //if filter is "" remove it from the columnFilters object
	        if (columnFilters.hasOwnProperty(column) && !filter) {
	            columnFilters = omit(columnFilters, column);
	        } else {
	            var newObject = {};
	            newObject[column] = filter;
	            columnFilters = extend({}, columnFilters, newObject);
	        }
	
	        this.filterByColumnFilters(columnFilters);
	    },
	
	    /* if we have a filter display the max page and results accordingly */
	    setFilter: function setFilter(filter) {
	        if (this.props.useExternal) {
	            this.props.externalSetFilter(filter);
	            return;
	        }
	
	        var that = this,
	            updatedState = {
	            page: 0,
	            filter: filter
	        };
	
	        // Obtain the state results.
	        updatedState.filteredResults = this.props.useCustomFilterer ? this.props.customFilterer(this.props.results, filter) : this.defaultFilter(this.props.results, filter);
	
	        // Update the max page.
	        updatedState.maxPage = that.getMaxPage(updatedState.filteredResults);
	
	        //if filter is null or undefined reset the filter.
	        if (isUndefined(filter) || isNull(filter) || isEmpty(filter)) {
	            updatedState.filter = filter;
	            updatedState.filteredResults = null;
	        }
	
	        // Set the state.
	        that.setState(updatedState);
	
	        this._resetSelectedRows();
	    },
	    setPageSize: function setPageSize(size) {
	        if (this.props.useExternal) {
	            this.props.externalSetPageSize(size);
	            return;
	        }
	
	        //make this better.
	        this.state.resultsPerPage = size;
	        this.setMaxPage();
	    },
	    toggleColumnChooser: function toggleColumnChooser() {
	        this.setState({
	            showColumnChooser: !this.state.showColumnChooser
	        });
	    },
	    isNullOrUndefined: function isNullOrUndefined(value) {
	        return value === undefined || value === null;
	    },
	    shouldUseCustomRowComponent: function shouldUseCustomRowComponent() {
	        return this.isNullOrUndefined(this.state.useCustomRowComponent) ? this.props.useCustomRowComponent : this.state.useCustomRowComponent;
	    },
	    shouldUseCustomGridComponent: function shouldUseCustomGridComponent() {
	        return this.isNullOrUndefined(this.state.useCustomGridComponent) ? this.props.useCustomGridComponent : this.state.useCustomGridComponent;
	    },
	    toggleCustomComponent: function toggleCustomComponent() {
	        if (this.state.customComponentType === "grid") {
	            this.setState({
	                useCustomGridComponent: !this.shouldUseCustomGridComponent()
	            });
	        } else if (this.state.customComponentType === "row") {
	            this.setState({
	                useCustomRowComponent: !this.shouldUseCustomRowComponent()
	            });
	        }
	    },
	    getMaxPage: function getMaxPage(results, totalResults) {
	        if (this.props.useExternal) {
	            return this.props.externalMaxPage;
	        }
	
	        if (!totalResults) {
	            totalResults = (results || this.getCurrentResults()).length;
	        }
	        var maxPage = Math.ceil(totalResults / this.state.resultsPerPage);
	        return maxPage;
	    },
	    setMaxPage: function setMaxPage(results) {
	        var maxPage = this.getMaxPage(results);
	        //re-render if we have new max page value
	        if (this.state.maxPage !== maxPage) {
	            this.setState({ page: 0, maxPage: maxPage, filteredColumns: this.columnSettings.filteredColumns });
	        }
	    },
	    setPage: function setPage(number) {
	        if (this.props.useExternal) {
	            this.props.externalSetPage(number);
	            return;
	        }
	
	        //check page size and move the filteredResults to pageSize * pageNumber
	        if (number * this.state.resultsPerPage <= this.state.resultsPerPage * this.state.maxPage) {
	            var that = this,
	                state = {
	                page: number
	            };
	
	            that.setState(state);
	        }
	
	        //When infinite scrolling is enabled, uncheck the "select all" checkbox, since more unchecked rows will be appended at the end
	        if (this.props.enableInfiniteScroll) {
	            this.setState({
	                isSelectAllChecked: false
	            });
	        } else {
	            //When the paging is done on the server, the previously selected rows on a certain page might not
	            // coincide with the new rows on that exact page page, if moving back and forth. Better reset the selection
	            this._resetSelectedRows();
	        }
	    },
	    setColumns: function setColumns(columns) {
	        this.columnSettings.filteredColumns = isArray(columns) ? columns : [columns];
	
	        this.setState({
	            filteredColumns: this.columnSettings.filteredColumns
	        });
	    },
	    nextPage: function nextPage() {
	        var currentPage = this.getCurrentPage();
	        if (currentPage < this.getCurrentMaxPage() - 1) {
	            this.setPage(currentPage + 1);
	        }
	    },
	    previousPage: function previousPage() {
	        var currentPage = this.getCurrentPage();
	        if (currentPage > 0) {
	            this.setPage(currentPage - 1);
	        }
	    },
	    changeSort: function changeSort(column) {
	        if (this.props.enableSort === false) {
	            return;
	        }
	
	        if (this.props.useExternal) {
	            this.props.externalChangeSort(column, this.props.externalSortColumn === column ? !this.props.externalSortAscending : true);
	            return;
	        }
	        var columnMeta = find(this.props.columnMetadata, { columnName: column }) || {};
	        var sortDirectionCycle = columnMeta.sortDirectionCycle ? columnMeta.sortDirectionCycle : [null, 'asc', 'desc'];
	        var sortDirection = null;
	        // Find the current position in the cycle (or -1).
	        var i = sortDirectionCycle.indexOf(this.state.sortDirection && column === this.state.sortColumn ? this.state.sortDirection : null);
	
	        // Proceed to the next position in the cycle (or start at the beginning).
	        i = (i + 1) % sortDirectionCycle.length;
	
	        if (sortDirectionCycle[i]) {
	            sortDirection = sortDirectionCycle[i];
	        } else {
	            sortDirection = null;
	        }
	
	        var state = {
	            page: 0,
	            sortColumn: column,
	            sortDirection: sortDirection
	        };
	
	        this.setState(state);
	
	        //When the sorting is done on the server, the previously selected rows might not correspond with the new ones.
	        //Better reset the selection
	        this._resetSelectedRows();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setMaxPage(nextProps.results);
	        if (nextProps.resultsPerPage !== this.props.resultsPerPage) {
	            this.setPageSize(nextProps.resultsPerPage);
	        }
	        //This will updaet the column Metadata
	        this.columnSettings.columnMetadata = nextProps.columnMetadata;
	        if (nextProps.results.length > 0) {
	            var deepKeys = deep.keys(nextProps.results[0]);
	
	            var is_same = this.columnSettings.allColumns.length == deepKeys.length && this.columnSettings.allColumns.every(function (element, index) {
	                return element === deepKeys[index];
	            });
	
	            if (!is_same) {
	                this.columnSettings.allColumns = deepKeys;
	            }
	        } else if (this.columnSettings.allColumns.length > 0) {
	            this.columnSettings.allColumns = [];
	        }
	
	        if (nextProps.columns !== this.columnSettings.filteredColumns) {
	            this.columnSettings.filteredColumns = nextProps.columns;
	        }
	
	        if (nextProps.selectedRowIds) {
	            var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true);
	
	            this.setState({
	                isSelectAllChecked: this._getAreAllRowsChecked(nextProps.selectedRowIds, map(visibleRows, this.props.uniqueIdentifier)),
	                selectedRowIds: nextProps.selectedRowIds
	            });
	        }
	    },
	    getInitialState: function getInitialState() {
	        var state = {
	            maxPage: 0,
	            page: 0,
	            filteredResults: null,
	            filteredColumns: [],
	            filter: "",
	            //this sets the individual column filters
	            columnFilters: {},
	            resultsPerPage: this.props.resultsPerPage || 5,
	            showColumnChooser: false,
	            isSelectAllChecked: false,
	            selectedRowIds: this.props.selectedRowIds
	        };
	        return state;
	    },
	    componentWillMount: function componentWillMount() {
	        this.verifyExternal();
	        this.verifyCustom();
	
	        this.columnSettings = new ColumnProperties(this.props.results.length > 0 ? deep.keys(this.props.results[0]) : [], this.props.columns, this.props.childrenColumnName, this.props.columnMetadata, this.props.metadataColumns);
	
	        this.rowSettings = new RowProperties(this.props.rowMetadata, this.props.useCustomTableRowComponent && this.props.customTableRowComponent ? this.props.customTableRowComponent : GridRow, this.props.useCustomTableRowComponent);
	
	        if (this.props.initialSort) {
	            this.changeSort(this.props.initialSort);
	        }
	        this.setMaxPage();
	
	        //don't like the magic strings
	        if (this.shouldUseCustomGridComponent()) {
	            this.setState({
	                customComponentType: "grid"
	            });
	        } else if (this.shouldUseCustomRowComponent()) {
	            this.setState({
	                customComponentType: "row"
	            });
	        } else {
	            this.setState({
	                filteredColumns: this.columnSettings.filteredColumns
	            });
	        }
	    },
	    //todo: clean these verify methods up
	    verifyExternal: function verifyExternal() {
	        if (this.props.useExternal === true) {
	            //hooray for big ugly nested if
	            if (this.props.externalSetPage === null) {
	                console.error("useExternal is set to true but there is no externalSetPage function specified.");
	            }
	
	            if (this.props.externalChangeSort === null) {
	                console.error("useExternal is set to true but there is no externalChangeSort function specified.");
	            }
	
	            if (this.props.externalSetFilter === null) {
	                console.error("useExternal is set to true but there is no externalSetFilter function specified.");
	            }
	
	            if (this.props.externalSetPageSize === null) {
	                console.error("useExternal is set to true but there is no externalSetPageSize function specified.");
	            }
	
	            if (this.props.externalMaxPage === null) {
	                console.error("useExternal is set to true but externalMaxPage is not set.");
	            }
	
	            if (this.props.externalCurrentPage === null) {
	                console.error("useExternal is set to true but externalCurrentPage is not set. Griddle will not page correctly without that property when using external data.");
	            }
	        }
	    },
	    //TODO: Do this with propTypes
	    verifyCustom: function verifyCustom() {
	        if (this.props.useCustomGridComponent === true && this.props.customGridComponent === null) {
	            console.error("useCustomGridComponent is set to true but no custom component was specified.");
	        }
	        if (this.props.useCustomRowComponent === true && this.props.customRowComponent === null) {
	            console.error("useCustomRowComponent is set to true but no custom component was specified.");
	        }
	        if (this.props.useCustomGridComponent === true && this.props.useCustomRowComponent === true) {
	            console.error("Cannot currently use both customGridComponent and customRowComponent.");
	        }
	        if (this.props.useCustomFilterer === true && this.props.customFilterer === null) {
	            console.error("useCustomFilterer is set to true but no custom filter function was specified.");
	        }
	        if (this.props.useCustomFilterComponent === true && this.props.customFilterComponent === null) {
	            console.error("useCustomFilterComponent is set to true but no customFilterComponent was specified.");
	        }
	    },
	    getDataForRender: function getDataForRender(data, cols, pageList) {
	        var _this = this;
	
	        var that = this;
	
	        // get the correct page size
	        if (this.state.sortColumn !== "") {
	            var column = this.state.sortColumn;
	            var sortColumn = _filter(this.props.columnMetadata, { columnName: column });
	            var customCompareFn;
	            var multiSort = {
	                columns: [],
	                orders: []
	            };
	
	            if (sortColumn.length > 0) {
	                customCompareFn = sortColumn[0].hasOwnProperty("customCompareFn") && sortColumn[0]["customCompareFn"];
	                if (sortColumn[0]["multiSort"]) {
	                    multiSort = sortColumn[0]["multiSort"];
	                }
	            }
	
	            if (this.state.sortDirection) {
	                if (typeof customCompareFn === 'function') {
	                    if (customCompareFn.length === 2) {
	                        data = data.sort(function (a, b) {
	                            return customCompareFn(_get(a, column), _get(b, column));
	                        });
	
	                        if (this.state.sortDirection === 'desc') {
	                            data.reverse();
	                        }
	                    } else if (customCompareFn.length === 1) {
	                        data = _orderBy(data, function (item) {
	                            return customCompareFn(_get(item, column));
	                        }, [this.state.sortDirection]);
	                    }
	                } else {
	                    var iteratees = [_property(column)];
	                    var orders = [this.state.sortDirection];
	                    multiSort.columns.forEach(function (col, i) {
	                        iteratees.push(_property(col));
	                        if (multiSort.orders[i] === 'asc' || multiSort.orders[i] === 'desc') {
	                            orders.push(multiSort.orders[i]);
	                        } else {
	                            orders.push(_this.state.sortDirection);
	                        }
	                    });
	
	                    data = _orderBy(data, iteratees, orders);
	                }
	            }
	        }
	
	        var currentPage = this.getCurrentPage();
	
	        if (!this.props.useExternal && pageList && this.state.resultsPerPage * (currentPage + 1) <= this.state.resultsPerPage * this.state.maxPage && currentPage >= 0) {
	            if (this.isInfiniteScrollEnabled()) {
	                // If we're doing infinite scroll, grab all results up to the current page.
	                data = first(data, (currentPage + 1) * this.state.resultsPerPage);
	            } else {
	                //the 'rest' is grabbing the whole array from index on and the 'initial' is getting the first n results
	                var rest = drop(data, currentPage * this.state.resultsPerPage);
	                data = (dropRight || initial)(rest, rest.length - this.state.resultsPerPage);
	            }
	        }
	
	        var meta = this.columnSettings.getMetadataColumns;
	
	        var transformedData = [];
	
	        for (var i = 0; i < data.length; i++) {
	            var mappedData = data[i];
	
	            if (typeof mappedData[that.props.childrenColumnName] !== "undefined" && mappedData[that.props.childrenColumnName].length > 0) {
	                //internally we're going to use children instead of whatever it is so we don't have to pass the custom name around
	                mappedData["children"] = that.getDataForRender(mappedData[that.props.childrenColumnName], cols, false);
	
	                if (that.props.childrenColumnName !== "children") {
	                    delete mappedData[that.props.childrenColumnName];
	                }
	            }
	
	            transformedData.push(mappedData);
	        }
	        return transformedData;
	    },
	    //this is the current results
	    getCurrentResults: function getCurrentResults() {
	        return this.state.filteredResults || this.props.results;
	    },
	    getCurrentPage: function getCurrentPage() {
	        return this.props.externalCurrentPage || this.state.page;
	    },
	    getCurrentSort: function getCurrentSort() {
	        return this.props.useExternal ? this.props.externalSortColumn : this.state.sortColumn;
	    },
	    getCurrentSortAscending: function getCurrentSortAscending() {
	        return this.props.useExternal ? this.props.externalSortAscending : this.state.sortDirection === 'asc';
	    },
	    getCurrentMaxPage: function getCurrentMaxPage() {
	        return this.props.useExternal ? this.props.externalMaxPage : this.state.maxPage;
	    },
	    //This takes the props relating to sort and puts them in one object
	    getSortObject: function getSortObject() {
	        return {
	            enableSort: this.props.enableSort,
	            changeSort: this.changeSort,
	            sortColumn: this.getCurrentSort(),
	            sortAscending: this.getCurrentSortAscending(),
	            sortDirection: this.state.sortDirection,
	            sortAscendingClassName: this.props.sortAscendingClassName,
	            sortDescendingClassName: this.props.sortDescendingClassName,
	            sortAscendingComponent: this.props.sortAscendingComponent,
	            sortDescendingComponent: this.props.sortDescendingComponent,
	            sortDefaultComponent: this.props.sortDefaultComponent
	        };
	    },
	    _toggleSelectAll: function _toggleSelectAll() {
	        var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true),
	            newIsSelectAllChecked = !this.state.isSelectAllChecked,
	            newSelectedRowIds = JSON.parse(JSON.stringify(this.state.selectedRowIds));
	
	        var self = this;
	        forEach(visibleRows, function (row) {
	            self._updateSelectedRowIds(row[self.props.uniqueIdentifier], newSelectedRowIds, newIsSelectAllChecked);
	        }, this);
	
	        this.setState({
	            isSelectAllChecked: newIsSelectAllChecked,
	            selectedRowIds: newSelectedRowIds
	        });
	    },
	    _toggleSelectRow: function _toggleSelectRow(row, isChecked) {
	
	        var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true),
	            newSelectedRowIds = JSON.parse(JSON.stringify(this.state.selectedRowIds));
	
	        this._updateSelectedRowIds(row[this.props.uniqueIdentifier], newSelectedRowIds, isChecked);
	
	        this.setState({
	            isSelectAllChecked: this._getAreAllRowsChecked(newSelectedRowIds, map(visibleRows, this.props.uniqueIdentifier)),
	            selectedRowIds: newSelectedRowIds
	        });
	    },
	    _updateSelectedRowIds: function _updateSelectedRowIds(id, selectedRowIds, isChecked) {
	
	        var isFound;
	
	        if (isChecked) {
	            isFound = find(selectedRowIds, function (item) {
	                return id === item;
	            });
	
	            if (isFound === undefined) {
	                selectedRowIds.push(id);
	            }
	        } else {
	            selectedRowIds.splice(selectedRowIds.indexOf(id), 1);
	        }
	    },
	    _getIsSelectAllChecked: function _getIsSelectAllChecked() {
	
	        return this.state.isSelectAllChecked;
	    },
	    _getAreAllRowsChecked: function _getAreAllRowsChecked(selectedRowIds, visibleRowIds) {
	
	        var i, isFound;
	
	        if (selectedRowIds.length !== visibleRowIds.length) {
	            return false;
	        }
	
	        for (i = 0; i < selectedRowIds.length; i++) {
	            isFound = find(visibleRowIds, function (visibleRowId) {
	                return selectedRowIds[i] === visibleRowId;
	            });
	
	            if (isFound === undefined) {
	                return false;
	            }
	        }
	
	        return true;
	    },
	    _getIsRowChecked: function _getIsRowChecked(row) {
	
	        return this.state.selectedRowIds.indexOf(row[this.props.uniqueIdentifier]) > -1 ? true : false;
	    },
	    getSelectedRowIds: function getSelectedRowIds() {
	
	        return this.state.selectedRowIds;
	    },
	    _resetSelectedRows: function _resetSelectedRows() {
	
	        this.setState({
	            isSelectAllChecked: false,
	            selectedRowIds: []
	        });
	    },
	    //This takes the props relating to multiple selection and puts them in one object
	    getMultipleSelectionObject: function getMultipleSelectionObject() {
	
	        return {
	            isMultipleSelection: find(this.props.results, function (result) {
	                return 'children' in result;
	            }) ? false : this.props.isMultipleSelection, //does not support subgrids
	            toggleSelectAll: this._toggleSelectAll,
	            getIsSelectAllChecked: this._getIsSelectAllChecked,
	
	            toggleSelectRow: this._toggleSelectRow,
	            getSelectedRowIds: this.getSelectedRowIds,
	            getIsRowChecked: this._getIsRowChecked
	        };
	    },
	    isInfiniteScrollEnabled: function isInfiniteScrollEnabled() {
	        // If a custom pager is included, don't allow for infinite scrolling.
	        if (this.props.useCustomPagerComponent) {
	            return false;
	        }
	
	        // Otherwise, send back the property.
	        return this.props.enableInfiniteScroll;
	    },
	    getClearFixStyles: function getClearFixStyles() {
	        return {
	            clear: "both",
	            display: "table",
	            width: "100%"
	        };
	    },
	    getSettingsStyles: function getSettingsStyles() {
	        return {
	            "float": "left",
	            width: "50%",
	            textAlign: "right"
	        };
	    },
	    getFilterStyles: function getFilterStyles() {
	        return {
	            "float": "left",
	            width: "50%",
	            textAlign: "left",
	            color: "#222",
	            minHeight: "1px"
	        };
	    },
	    getFilter: function getFilter() {
	        return this.props.showFilter && this.shouldUseCustomGridComponent() === false ? this.props.useCustomFilterComponent ? React.createElement(CustomFilterContainer, { changeFilter: this.setFilter, placeholderText: this.props.filterPlaceholderText, customFilterComponent: this.props.customFilterComponent, results: this.props.results, currentResults: this.getCurrentResults() }) : React.createElement(GridFilter, { changeFilter: this.setFilter, placeholderText: this.props.filterPlaceholderText }) : "";
	    },
	    getSettings: function getSettings() {
	        return this.props.showSettings ? React.createElement('button', { type: 'button', className: this.props.settingsToggleClassName, onClick: this.toggleColumnChooser,
	            style: this.props.useGriddleStyles ? { background: "none", border: "none", padding: 0, margin: 0, fontSize: 14 } : null }, this.props.settingsText, this.props.settingsIconComponent) : "";
	    },
	    getTopSection: function getTopSection(filter, settings) {
	        if (this.props.showFilter === false && this.props.showSettings === false) {
	            return "";
	        }
	
	        var filterStyles = null,
	            settingsStyles = null,
	            topContainerStyles = null;
	
	        if (this.props.useGriddleStyles) {
	            filterStyles = this.getFilterStyles();
	            settingsStyles = this.getSettingsStyles();
	
	            topContainerStyles = this.getClearFixStyles();
	        }
	
	        return React.createElement('div', { className: 'top-section', style: topContainerStyles }, React.createElement('div', { className: 'griddle-filter', style: filterStyles }, filter), React.createElement('div', { className: 'griddle-settings-toggle', style: settingsStyles }, settings));
	    },
	    getPagingSection: function getPagingSection(currentPage, maxPage) {
	        if ((this.props.showPager && !this.isInfiniteScrollEnabled() && !this.shouldUseCustomGridComponent()) === false) {
	            return undefined;
	        }
	
	        return React.createElement('div', { className: 'griddle-footer' }, this.props.useCustomPagerComponent ? React.createElement(CustomPaginationContainer, { customPagerComponentOptions: this.props.customPagerComponentOptions, next: this.nextPage, previous: this.previousPage, currentPage: currentPage, maxPage: maxPage, setPage: this.setPage, nextText: this.props.nextText, previousText: this.props.previousText, customPagerComponent: this.props.customPagerComponent }) : React.createElement(GridPagination, { useGriddleStyles: this.props.useGriddleStyles, next: this.nextPage, previous: this.previousPage, nextClassName: this.props.nextClassName, nextIconComponent: this.props.nextIconComponent, previousClassName: this.props.previousClassName, previousIconComponent: this.props.previousIconComponent, currentPage: currentPage, maxPage: maxPage, setPage: this.setPage, nextText: this.props.nextText, previousText: this.props.previousText }));
	    },
	    getColumnSelectorSection: function getColumnSelectorSection(keys, cols) {
	        return this.state.showColumnChooser ? React.createElement(GridSettings, { columns: keys, selectedColumns: cols, setColumns: this.setColumns, settingsText: this.props.settingsText,
	            settingsIconComponent: this.props.settingsIconComponent, maxRowsText: this.props.maxRowsText, setPageSize: this.setPageSize,
	            showSetPageSize: !this.shouldUseCustomGridComponent(), resultsPerPage: this.state.resultsPerPage, enableToggleCustom: this.props.enableToggleCustom,
	            toggleCustomComponent: this.toggleCustomComponent, useCustomComponent: this.shouldUseCustomRowComponent() || this.shouldUseCustomGridComponent(),
	            useGriddleStyles: this.props.useGriddleStyles, enableCustomFormatText: this.props.enableCustomFormatText, columnMetadata: this.props.columnMetadata }) : "";
	    },
	    getCustomGridSection: function getCustomGridSection() {
	        return React.createElement(this.props.customGridComponent, _extends({ data: this.props.results, className: this.props.customGridComponentClassName }, this.props.gridMetadata));
	    },
	    getCustomRowSection: function getCustomRowSection(data, cols, meta, pagingContent, globalData) {
	        return React.createElement('div', null, React.createElement(CustomRowComponentContainer, { data: data, columns: cols, metadataColumns: meta, globalData: globalData,
	            className: this.props.customRowComponentClassName, customComponent: this.props.customRowComponent,
	            style: this.props.useGriddleStyles ? this.getClearFixStyles() : null }), this.props.showPager && pagingContent);
	    },
	    getStandardGridSection: function getStandardGridSection(data, cols, meta, pagingContent, hasMorePages) {
	        var sortProperties = this.getSortObject();
	        var multipleSelectionProperties = this.getMultipleSelectionObject();
	
	        // no data section
	        var showNoData = this.shouldShowNoDataSection(data);
	        var noDataSection = this.getNoDataSection();
	
	        return React.createElement('div', { className: 'griddle-body' }, React.createElement(GridTable, { useGriddleStyles: this.props.useGriddleStyles,
	            noDataSection: noDataSection,
	            showNoData: showNoData,
	            columnSettings: this.columnSettings,
	            rowSettings: this.rowSettings,
	            sortSettings: sortProperties,
	            multipleSelectionSettings: multipleSelectionProperties,
	            filterByColumn: this.filterByColumn,
	            isSubGriddle: this.props.isSubGriddle,
	            useGriddleIcons: this.props.useGriddleIcons,
	            useFixedLayout: this.props.useFixedLayout,
	            showPager: this.props.showPager,
	            pagingContent: pagingContent,
	            data: data,
	            className: this.props.tableClassName,
	            enableInfiniteScroll: this.isInfiniteScrollEnabled(),
	            nextPage: this.nextPage,
	            showTableHeading: this.props.showTableHeading,
	            useFixedHeader: this.props.useFixedHeader,
	            parentRowCollapsedClassName: this.props.parentRowCollapsedClassName,
	            parentRowExpandedClassName: this.props.parentRowExpandedClassName,
	            parentRowCollapsedComponent: this.props.parentRowCollapsedComponent,
	            parentRowExpandedComponent: this.props.parentRowExpandedComponent,
	            bodyHeight: this.props.bodyHeight,
	            paddingHeight: this.props.paddingHeight,
	            rowHeight: this.props.rowHeight,
	            infiniteScrollLoadTreshold: this.props.infiniteScrollLoadTreshold,
	            externalLoadingComponent: this.props.externalLoadingComponent,
	            externalIsLoading: this.props.externalIsLoading,
	            hasMorePages: hasMorePages,
	            onRowClick: this.props.onRowClick }));
	    },
	    getContentSection: function getContentSection(data, cols, meta, pagingContent, hasMorePages, globalData) {
	        if (this.shouldUseCustomGridComponent() && this.props.customGridComponent !== null) {
	            return this.getCustomGridSection();
	        } else if (this.shouldUseCustomRowComponent()) {
	            return this.getCustomRowSection(data, cols, meta, pagingContent, globalData);
	        } else {
	            return this.getStandardGridSection(data, cols, meta, pagingContent, hasMorePages);
	        }
	    },
	    getNoDataSection: function getNoDataSection() {
	        if (this.props.customNoDataComponent != null) {
	            return React.createElement('div', { className: this.props.noDataClassName }, React.createElement(this.props.customNoDataComponent, null));
	        }
	        return React.createElement(GridNoData, { noDataMessage: this.props.noDataMessage });
	    },
	    shouldShowNoDataSection: function shouldShowNoDataSection(results) {
	        if (this.props.allowEmptyGrid) {
	            return false;
	        }
	
	        return this.props.useExternal === false && (typeof results === 'undefined' || results.length === 0) || this.props.useExternal === true && this.props.externalIsLoading === false && results.length === 0;
	    },
	    render: function render() {
	        var that = this,
	            results = this.getCurrentResults(); // Attempt to assign to the filtered results, if we have any.
	
	        var headerTableClassName = this.props.tableClassName + " table-header";
	
	        //figure out if we want to show the filter section
	        var filter = this.getFilter();
	        var settings = this.getSettings();
	
	        //if we have neither filter or settings don't need to render this stuff
	        var topSection = this.getTopSection(filter, settings);
	
	        var keys = [];
	        var cols = this.columnSettings.getColumns();
	        //figure out which columns are displayed and show only those
	        var data = this.getDataForRender(results, cols, true);
	
	        var meta = this.columnSettings.getMetadataColumns();
	
	        // Grab the column keys from the first results
	        keys = deep.keys(omit(results[0], meta));
	
	        // sort keys by order
	        keys = this.columnSettings.orderColumns(keys);
	
	        // Grab the current and max page values.
	        var currentPage = this.getCurrentPage();
	        var maxPage = this.getCurrentMaxPage();
	
	        // Determine if we need to enable infinite scrolling on the table.
	        var hasMorePages = currentPage + 1 < maxPage;
	
	        // Grab the paging content if it's to be displayed
	        var pagingContent = this.getPagingSection(currentPage, maxPage);
	
	        var resultContent = this.getContentSection(data, cols, meta, pagingContent, hasMorePages, this.props.globalData);
	
	        var columnSelector = this.getColumnSelectorSection(keys, cols);
	
	        var gridClassName = this.props.gridClassName.length > 0 ? "griddle " + this.props.gridClassName : "griddle";
	        //add custom to the class name so we can style it differently
	        gridClassName += this.shouldUseCustomRowComponent() ? " griddle-custom" : "";
	
	        return React.createElement('div', { className: gridClassName }, topSection, columnSelector, React.createElement('div', { className: 'griddle-container', style: this.props.useGriddleStyles && !this.props.isSubGriddle ? { border: "1px solid #DDD" } : null }, resultContent));
	    }
	});
	
	GridRowContainer.Griddle = module.exports = Griddle;


/***/ }),
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1355);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */
/***/ (function(module, exports) {

	module.exports = {"name":"stallion-book","version":"5.43.2","description":"Racingpost Stallion Book project","keywords":["stallion","sire","race","progeny","pedigree","weatherbys"],"homepage":"https://www.racingpost.com/bloodstock/stallion-book/","license":"UNLICENSED","private":true,"author":"Jedi Team <jedi@racingpost.com>","contributors":["MiniTrue Team <minitrue@racingpost.com>"],"repository":{"type":"git","url":"ssh://git@gitlab.com:racing-post/public-web/stallion-book.git"},"scripts":{"assets":"cp -R assets public/","lint":"","lint:watch":"npm run lint -- --watch","test":"mocha --compilers js:babel-register --require ./tests/js/helper.js \"tests/js/**/*@(.js|.jsx)\"","test:coverage":"istanbul cover --report lcov --report json --report text --report html node_modules/mocha/bin/_mocha -- -r babel-register -r tests/js/helper.js tests/js/**/*.spec.js","test:watch":"mocha --compilers js:babel-register --require ./tests/js/helper.js \"tests/js/**/*@(.js|.jsx)\" --watch","prebuild":"npm run check:src","build":"cross-env NODE_ENV=production babel-node tools/build.js","postinstall":"if [ \"$IGNORE_SCRIPTS\" != true ]; then composer install; fi","dev":"babel-node tools/buildDev.js","watch":"npm-run-all --parallel dev lint:watch","check:src":"","version":"shjs ./bin/sonar && git add .","prepare":"if [ \"$IGNORE_SCRIPTS\" != true ]; then npm run build && npm run assets; fi"},"dependencies":{"babel-cli":"^6.7.7","babel-core":"^6.7.7","babel-loader":"^6.2.4","babel-polyfill":"^6.9.0","babel-preset-es2015":"^6.6.0","babel-preset-react":"^6.5.0","clean-webpack-plugin":"^0.1.10","cross-env":"^1.0.8","css-loader":"^0.23.1","cssnano":"^3.5.2","es6-promise-polyfill":"^1.2.0","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.8.5","griddle-react":"^0.6.01","html-webpack-plugin":"^2.16.0","immutable":"^3.8.1","isomorphic-fetch":"^2.2.1","jquery":"^2.2.4","jquery.cookie":"^1.4.1","json-loader":"^0.5.4","lodash":"^4.17.4","moment":"^2.14.1","node-sass":"^4.14.1","numeral":"^1.5.3","postcss-loader":"^0.8.2","prop-types":"^15.5.8","react":"^15.5.0","react-addons-pure-render-mixin":"^15.1.0","react-addons-shallow-compare":"^15.3.0","react-dom":"^15.5.0","react-redux":"^4.4.8","react-router":"^3.0.4","react-router-redux":"^4.0.4","react-slick":"^0.29.0","redux":"^3.5.2","redux-thunk":"^2.0.1","rimraf":"^2.5.2","rp-advertising":"^6.3.0","rp-analytics":"4.21.2","rp-diffusion-connector":"6.3.0","rp-gui-guide":"16.22.1","rp-mq-breakpoints":"^1.2.0","rp-navigation":"12.39.7","rp-popup":"^6.3.1","rp-react-select":"^3.3.1","rp-react-svg-icon":"^1.1.5","rp-url-navigation-prefs":"^2.3.6","sass-loader":"^3.2.0","shelljs":"^0.7.2","style-loader":"^0.13.1","url-loader":"^0.5.7","webpack":"^1.13.0"},"devDependencies":{"babel-register":"^6.9.0","chai":"^3.5.0","chai-as-promised":"^5.3.0","chai-immutable":"^1.6.0","chai-spies":"^0.7.1","copy-webpack-plugin":"^3.0.1","enzyme":"^2.8.1","eslint":"^2.8.0","eslint-config-airbnb":"^8.0.0","eslint-import-resolver-webpack":"^0.2.3","eslint-plugin-import":"^1.6.1","eslint-plugin-jsx-a11y":"^1.0.4","eslint-plugin-react":"^5.0.1","expose-loader":"0.7.1","fetch-mock":"^5.5.0","istanbul":"^1.0.0-alpha.2","jsdom":"^9.2.1","mocha":"^2.5.3","nock":"^8.0.0","npm-run-all":"^3.1.2","pre-commit":"^1.1.3","react-test-renderer":"^15.5.4","redux-logger":"^2.7.4","script-loader":"^0.7.0","sinon":"^1.17.4","sinon-chai":"^2.8.0","webpack-assets-versions-plugin":"^2.2.0","webpack-bundle-analyzer":"^2.3.0","webpack-dev-middleware":"^1.6.1","webpack-hot-middleware":"^2.10.0","webpack-md5-hash":"^0.0.5"},"pre-commit":{"run":["lint"],"colors":false}}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1349);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1016),
	    hashDelete = __webpack_require__(1017),
	    hashGet = __webpack_require__(1018),
	    hashHas = __webpack_require__(1019),
	    hashSet = __webpack_require__(1020);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(87),
	    root = __webpack_require__(48);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(376);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 961 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(100),
	    keys = __webpack_require__(62);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(100),
	    keysIn = __webpack_require__(178);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(240),
	    arrayEach = __webpack_require__(369),
	    assignValue = __webpack_require__(168),
	    baseAssign = __webpack_require__(962),
	    baseAssignIn = __webpack_require__(963),
	    cloneBuffer = __webpack_require__(994),
	    copyArray = __webpack_require__(1001),
	    copySymbols = __webpack_require__(1002),
	    copySymbolsIn = __webpack_require__(1003),
	    getAllKeys = __webpack_require__(387),
	    getAllKeysIn = __webpack_require__(388),
	    getTag = __webpack_require__(101),
	    initCloneArray = __webpack_require__(1021),
	    initCloneByTag = __webpack_require__(1022),
	    initCloneObject = __webpack_require__(1023),
	    isArray = __webpack_require__(26),
	    isBuffer = __webpack_require__(175),
	    isMap = __webpack_require__(1067),
	    isObject = __webpack_require__(42),
	    isSet = __webpack_require__(1070),
	    keys = __webpack_require__(62),
	    keysIn = __webpack_require__(178);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(242);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1007);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(967),
	    keys = __webpack_require__(62);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(86),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(240),
	    equalArrays = __webpack_require__(384),
	    equalByTag = __webpack_require__(1011),
	    equalObjects = __webpack_require__(1012),
	    getTag = __webpack_require__(101),
	    isArray = __webpack_require__(26),
	    isBuffer = __webpack_require__(175),
	    isTypedArray = __webpack_require__(252);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(101),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(176),
	    isMasked = __webpack_require__(1026),
	    isObject = __webpack_require__(42),
	    toSource = __webpack_require__(397);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(101),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(86),
	    isLength = __webpack_require__(251),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42),
	    isPrototype = __webpack_require__(128),
	    nativeKeysIn = __webpack_require__(1039);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(378),
	    getMatchData = __webpack_require__(389),
	    matchesStrictComparable = __webpack_require__(393);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(377),
	    get = __webpack_require__(400),
	    hasIn = __webpack_require__(401),
	    isKey = __webpack_require__(248),
	    isStrictComparable = __webpack_require__(391),
	    matchesStrictComparable = __webpack_require__(393),
	    toKey = __webpack_require__(102);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(981),
	    hasIn = __webpack_require__(401);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(123),
	    baseSet = __webpack_require__(984),
	    castPath = __webpack_require__(99);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(123);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(168),
	    castPath = __webpack_require__(99),
	    isIndex = __webpack_require__(171),
	    isObject = __webpack_require__(42),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1055),
	    defineProperty = __webpack_require__(383),
	    identity = __webpack_require__(130);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 986 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 987 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    arrayMap = __webpack_require__(85),
	    isArray = __webpack_require__(26),
	    isSymbol = __webpack_require__(131);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1054);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(99),
	    last = __webpack_require__(1073),
	    parent = __webpack_require__(1041),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(130);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)(module)))

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(244);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 996 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(244);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(131);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(999);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(100),
	    getSymbols = __webpack_require__(246);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(100),
	    getSymbolsIn = __webpack_require__(390);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(125),
	    isIterateeCall = __webpack_require__(247);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(56);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(124),
	    isArrayLike = __webpack_require__(56),
	    keys = __webpack_require__(62);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(988),
	    getTag = __webpack_require__(101),
	    mapToArray = __webpack_require__(392),
	    setToPairs = __webpack_require__(1045);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(177);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    Uint8Array = __webpack_require__(368),
	    eq = __webpack_require__(129),
	    equalArrays = __webpack_require__(384),
	    mapToArray = __webpack_require__(392),
	    setToArray = __webpack_require__(1044);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(387);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1013 */,
/* 1014 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(99),
	    isArguments = __webpack_require__(174),
	    isArray = __webpack_require__(26),
	    isIndex = __webpack_require__(171),
	    isLength = __webpack_require__(251),
	    toKey = __webpack_require__(102);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(172);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(172);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(172);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(172);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(244),
	    cloneDataView = __webpack_require__(995),
	    cloneRegExp = __webpack_require__(996),
	    cloneSymbol = __webpack_require__(997),
	    cloneTypedArray = __webpack_require__(998);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(965),
	    getPrototype = __webpack_require__(245),
	    isPrototype = __webpack_require__(128);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    isArguments = __webpack_require__(174),
	    isArray = __webpack_require__(26);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1004);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(169);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(169);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(169);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(169);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(954),
	    ListCache = __webpack_require__(167),
	    Map = __webpack_require__(238);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(170);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(170);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(170);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(170);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1074);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(394);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1040 */,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(123),
	    baseSlice = __webpack_require__(126);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(167);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(167),
	    Map = __webpack_require__(238),
	    MapCache = __webpack_require__(239);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1037);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42),
	    now = __webpack_require__(1075),
	    toNumber = __webpack_require__(406);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(125),
	    eq = __webpack_require__(129),
	    isIterateeCall = __webpack_require__(247),
	    keysIn = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(373),
	    baseFlatten = __webpack_require__(243),
	    baseRest = __webpack_require__(125),
	    isArrayLikeObject = __webpack_require__(402);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(126),
	    toInteger = __webpack_require__(132);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.drop([1, 2, 3]);
	 * // => [2, 3]
	 *
	 * _.drop([1, 2, 3], 2);
	 * // => [3]
	 *
	 * _.drop([1, 2, 3], 5);
	 * // => []
	 *
	 * _.drop([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function drop(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = drop;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(126),
	    toInteger = __webpack_require__(132);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(374),
	    baseIteratee = __webpack_require__(124),
	    toInteger = __webpack_require__(132);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(243);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(376),
	    isArrayLike = __webpack_require__(56),
	    isString = __webpack_require__(1071),
	    toInteger = __webpack_require__(132),
	    values = __webpack_require__(1086);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(126);
	
	/**
	 * Gets all but the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.initial([1, 2, 3]);
	 * // => [1, 2]
	 */
	function initial(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 0, -1) : [];
	}
	
	module.exports = initial;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(379),
	    getTag = __webpack_require__(101),
	    isArguments = __webpack_require__(174),
	    isArray = __webpack_require__(26),
	    isArrayLike = __webpack_require__(56),
	    isBuffer = __webpack_require__(175),
	    isPrototype = __webpack_require__(128),
	    isTypedArray = __webpack_require__(252);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(972),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(249);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(378),
	    getMatchData = __webpack_require__(389);
	
	/**
	 * Performs a partial deep comparison between `object` and `source` to
	 * determine if `object` contains equivalent property values.
	 *
	 * **Note:** This method is equivalent to `_.matches` when `source` is
	 * partially applied.
	 *
	 * Partial comparisons will match empty array and empty object `source`
	 * values against any array or object value, respectively. See `_.isEqual`
	 * for a list of supported value comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 *
	 * _.isMatch(object, { 'b': 2 });
	 * // => true
	 *
	 * _.isMatch(object, { 'b': 1 });
	 * // => false
	 */
	function isMatch(object, source) {
	  return object === source || baseIsMatch(object, source, getMatchData(source));
	}
	
	module.exports = isMatch;


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(975),
	    baseUnary = __webpack_require__(127),
	    nodeUtil = __webpack_require__(249);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(86),
	    isArray = __webpack_require__(26),
	    isObjectLike = __webpack_require__(57);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(239);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(48);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85),
	    baseClone = __webpack_require__(964),
	    baseUnset = __webpack_require__(991),
	    castPath = __webpack_require__(99),
	    copyObject = __webpack_require__(100),
	    customOmitClone = __webpack_require__(1010),
	    flatRest = __webpack_require__(385),
	    getAllKeysIn = __webpack_require__(388);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(381),
	    isArray = __webpack_require__(26);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(980),
	    flatRest = __webpack_require__(385);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(243),
	    baseOrderBy = __webpack_require__(381),
	    baseRest = __webpack_require__(125),
	    isIterateeCall = __webpack_require__(247);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(126),
	    toInteger = __webpack_require__(132);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1056),
	    isObject = __webpack_require__(42);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(406);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(1009),
	    keys = __webpack_require__(62);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(407);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(992),
	    keys = __webpack_require__(62);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrevArrow = exports.NextArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(34));
	
	var _innerSliderUtils = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  var _super = _createSuper(PrevArrow);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  var _super2 = _createSuper(NextArrow);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(34));
	
	var _innerSliderUtils = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  var _super = _createSuper(Dots);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave,
	          infinite = _this$props.infinite,
	          slidesToScroll = _this$props.slidesToScroll,
	          slidesToShow = _this$props.slidesToShow,
	          slideCount = _this$props.slideCount,
	          currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	
	        var _leftBound = rightBound - (slidesToScroll - 1);
	
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1172));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	var _initialState = _interopRequireDefault(__webpack_require__(1170));
	
	var _lodash = _interopRequireDefault(__webpack_require__(952));
	
	var _classnames = _interopRequireDefault(__webpack_require__(34));
	
	var _innerSliderUtils = __webpack_require__(138);
	
	var _track = __webpack_require__(1173);
	
	var _dots = __webpack_require__(1168);
	
	var _arrows = __webpack_require__(1166);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  var _super = _createSuper(InnerSlider);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      _this.ro.disconnect();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      var setTrackStyle = _this.didPropsChange(prevProps);
	
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
	
	      if (!isTrackMounted) return;
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	        index: index
	      }, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	
	      _this.props.autoplay && _this.autoPlay("update");
	
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	
	        nodes[0] && nodes[0].focus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	
	    var ssrState = _this.ssrInit();
	
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
	          continue;
	        }
	
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	var _innerSlider = __webpack_require__(1171);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(951));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(1167));
	
	var _innerSliderUtils = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(901);
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(34));
	
	var _innerSliderUtils = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var focusedSlide;
	
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  var _super = _createSuper(Track);
	
	  function Track() {
	    var _this;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	var ArrowKeyStepper = function (_Component) {
	  _inherits(ArrowKeyStepper, _Component);
	
	  function ArrowKeyStepper(props, context) {
	    _classCallCheck(this, ArrowKeyStepper);
	
	    var _this = _possibleConstructorReturn(this, (ArrowKeyStepper.__proto__ || Object.getPrototypeOf(ArrowKeyStepper)).call(this, props, context));
	
	    _this.state = {
	      scrollToColumn: props.scrollToColumn,
	      scrollToRow: props.scrollToRow
	    };
	
	    _this._columnStartIndex = 0;
	    _this._columnStopIndex = 0;
	    _this._rowStartIndex = 0;
	    _this._rowStopIndex = 0;
	
	    _this._onKeyDown = _this._onKeyDown.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(ArrowKeyStepper, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var scrollToColumn = nextProps.scrollToColumn;
	      var scrollToRow = nextProps.scrollToRow;
	
	
	      if (this.props.scrollToColumn !== scrollToColumn) {
	        this.setState({ scrollToColumn: scrollToColumn });
	      }
	
	      if (this.props.scrollToRow !== scrollToRow) {
	        this.setState({ scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var children = _props.children;
	      var _state = this.state;
	      var scrollToColumn = _state.scrollToColumn;
	      var scrollToRow = _state.scrollToRow;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          onKeyDown: this._onKeyDown
	        },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onKeyDown',
	    value: function _onKeyDown(event) {
	      var _props2 = this.props;
	      var columnCount = _props2.columnCount;
	      var disabled = _props2.disabled;
	      var mode = _props2.mode;
	      var rowCount = _props2.rowCount;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var _state2 = this.state;
	      var scrollToColumnPrevious = _state2.scrollToColumn;
	      var scrollToRowPrevious = _state2.scrollToRow;
	      var _state3 = this.state;
	      var scrollToColumn = _state3.scrollToColumn;
	      var scrollToRow = _state3.scrollToRow;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	      switch (event.key) {
	        case 'ArrowDown':
	          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(this._rowStopIndex + 1, rowCount - 1);
	          break;
	        case 'ArrowLeft':
	          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(this._columnStartIndex - 1, 0);
	          break;
	        case 'ArrowRight':
	          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(this._columnStopIndex + 1, columnCount - 1);
	          break;
	        case 'ArrowUp':
	          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(this._rowStartIndex - 1, 0);
	          break;
	      }
	
	      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
	        event.preventDefault();
	
	        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref) {
	      var columnStartIndex = _ref.columnStartIndex;
	      var columnStopIndex = _ref.columnStopIndex;
	      var rowStartIndex = _ref.rowStartIndex;
	      var rowStopIndex = _ref.rowStopIndex;
	
	      this._columnStartIndex = columnStartIndex;
	      this._columnStopIndex = columnStopIndex;
	      this._rowStartIndex = rowStartIndex;
	      this._rowStopIndex = rowStopIndex;
	    }
	  }]);
	
	  return ArrowKeyStepper;
	}(_react.Component);
	
	ArrowKeyStepper.defaultProps = {
	  disabled: false,
	  mode: 'edges',
	  scrollToColumn: 0,
	  scrollToRow: 0
	};
	exports.default = ArrowKeyStepper;
	 false ? ArrowKeyStepper.propTypes = {
	  children: _react.PropTypes.func.isRequired,
	  className: _react.PropTypes.string,
	  columnCount: _react.PropTypes.number.isRequired,
	  disabled: _react.PropTypes.bool.isRequired,
	  mode: _react.PropTypes.oneOf(['cells', 'edges']),
	  rowCount: _react.PropTypes.number.isRequired,
	  scrollToColumn: _react.PropTypes.number.isRequired,
	  scrollToRow: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowKeyStepper = exports.default = undefined;
	
	var _ArrowKeyStepper2 = __webpack_require__(1174);
	
	var _ArrowKeyStepper3 = _interopRequireDefault(_ArrowKeyStepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArrowKeyStepper3.default;
	exports.ArrowKeyStepper = _ArrowKeyStepper3.default;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _detectElementResize = __webpack_require__(1210);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Decorator component that automatically adjusts the width and height of a single child.
	 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
	 * All other properties will be passed through to the child component.
	 */
	var AutoSizer = function (_Component) {
	  _inherits(AutoSizer, _Component);
	
	  function AutoSizer(props) {
	    _classCallCheck(this, AutoSizer);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));
	
	    _this.state = {
	      height: 0,
	      width: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Delay access of parentNode until mount.
	      // This handles edge-cases where the component has already been unmounted before its ref has been set,
	      // As well as libraries like react-lite which have a slightly different lifecycle.
	      this._parentNode = this._autoSizer.parentNode;
	
	      // Defer requiring resize handler in order to support server-side rendering.
	      // See issue #41
	      this._detectElementResize = (0, _detectElementResize2.default)();
	      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	      this._onResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disableHeight = _props.disableHeight;
	      var disableWidth = _props.disableWidth;
	      var _state = this.state;
	      var height = _state.height;
	      var width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setRef,
	          style: outerStyle
	        },
	        children({ height: height, width: width })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var onResize = this.props.onResize;
	
	      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
	      // This can result in invalid style values which can result in NaN values if we don't handle them.
	      // See issue #150 for more context.
	
	      var boundingRect = this._parentNode.getBoundingClientRect();
	      var height = boundingRect.height || 0;
	      var width = boundingRect.width || 0;
	
	      var style = window.getComputedStyle(this._parentNode) || {};
	      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	      var paddingRight = parseInt(style.paddingRight, 10) || 0;
	      var paddingTop = parseInt(style.paddingTop, 10) || 0;
	      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	
	      this.setState({
	        height: height - paddingTop - paddingBottom,
	        width: width - paddingLeft - paddingRight
	      });
	
	      onResize({ height: height, width: width });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(autoSizer) {
	      this._autoSizer = autoSizer;
	    }
	  }]);
	
	  return AutoSizer;
	}(_react.Component);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {}
	};
	exports.default = AutoSizer;
	 false ? AutoSizer.propTypes = {
	  /**
	  * Function responsible for rendering children.
	  * This function should implement the following signature:
	  * ({ height, width }) => PropTypes.element
	  */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Disable dynamic :height property */
	  disableHeight: _react.PropTypes.bool,
	
	  /** Disable dynamic :width property */
	  disableWidth: _react.PropTypes.bool,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _react.PropTypes.func.isRequired
	} : void 0;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AutoSizer = exports.default = undefined;
	
	var _AutoSizer2 = __webpack_require__(1176);
	
	var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoSizer3.default;
	exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactDom = __webpack_require__(133);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _defaultCellSizeCache = __webpack_require__(270);
	
	var _defaultCellSizeCache2 = _interopRequireDefault(_defaultCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Measures a Grid cell's contents by rendering them in a way that is not visible to the user.
	 * Either a fixed width or height may be provided if it is desirable to measure only in one direction.
	 */
	var CellMeasurer = function (_Component) {
	  _inherits(CellMeasurer, _Component);
	
	  function CellMeasurer(props, state) {
	    _classCallCheck(this, CellMeasurer);
	
	    var _this = _possibleConstructorReturn(this, (CellMeasurer.__proto__ || Object.getPrototypeOf(CellMeasurer)).call(this, props, state));
	
	    _this._cellSizeCache = props.cellSizeCache || new _defaultCellSizeCache2.default();
	
	    _this.getColumnWidth = _this.getColumnWidth.bind(_this);
	    _this.getRowHeight = _this.getRowHeight.bind(_this);
	    _this.resetMeasurements = _this.resetMeasurements.bind(_this);
	    _this.resetMeasurementForColumn = _this.resetMeasurementForColumn.bind(_this);
	    _this.resetMeasurementForRow = _this.resetMeasurementForRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(CellMeasurer, [{
	    key: 'getColumnWidth',
	    value: function getColumnWidth(_ref) {
	      var index = _ref.index;
	
	      var columnWidth = this._cellSizeCache.getColumnWidth(index);
	      if (columnWidth != null) {
	        return columnWidth;
	      }
	
	      var rowCount = this.props.rowCount;
	
	
	      var maxWidth = 0;
	
	      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
	        var _measureCell2 = this._measureCell({
	          clientWidth: true,
	          columnIndex: index,
	          rowIndex: rowIndex
	        });
	
	        var width = _measureCell2.width;
	
	
	        maxWidth = Math.max(maxWidth, width);
	      }
	
	      this._cellSizeCache.setColumnWidth(index, maxWidth);
	
	      return maxWidth;
	    }
	  }, {
	    key: 'getRowHeight',
	    value: function getRowHeight(_ref2) {
	      var index = _ref2.index;
	
	      var rowHeight = this._cellSizeCache.getRowHeight(index);
	      if (rowHeight != null) {
	        return rowHeight;
	      }
	
	      var columnCount = this.props.columnCount;
	
	
	      var maxHeight = 0;
	
	      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
	        var _measureCell3 = this._measureCell({
	          clientHeight: true,
	          columnIndex: columnIndex,
	          rowIndex: index
	        });
	
	        var height = _measureCell3.height;
	
	
	        maxHeight = Math.max(maxHeight, height);
	      }
	
	      this._cellSizeCache.setRowHeight(index, maxHeight);
	
	      return maxHeight;
	    }
	  }, {
	    key: 'resetMeasurementForColumn',
	    value: function resetMeasurementForColumn(columnIndex) {
	      this._cellSizeCache.clearColumnWidth(columnIndex);
	    }
	  }, {
	    key: 'resetMeasurementForRow',
	    value: function resetMeasurementForRow(rowIndex) {
	      this._cellSizeCache.clearRowHeight(rowIndex);
	    }
	  }, {
	    key: 'resetMeasurements',
	    value: function resetMeasurements() {
	      this._cellSizeCache.clearAllColumnWidths();
	      this._cellSizeCache.clearAllRowHeights();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderAndMount();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var cellSizeCache = this.props.cellSizeCache;
	
	
	      if (cellSizeCache !== nextProps.cellSizeCache) {
	        this._cellSizeCache = nextProps.cellSizeCache;
	      }
	
	      this._updateDivDimensions(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unmountContainer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        getColumnWidth: this.getColumnWidth,
	        getRowHeight: this.getRowHeight,
	        resetMeasurements: this.resetMeasurements,
	        resetMeasurementForColumn: this.resetMeasurementForColumn,
	        resetMeasurementForRow: this.resetMeasurementForRow
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_getContainerNode',
	    value: function _getContainerNode(props) {
	      var container = props.container;
	
	
	      if (container) {
	        return _reactDom2.default.findDOMNode(typeof container === 'function' ? container() : container);
	      } else {
	        return document.body;
	      }
	    }
	  }, {
	    key: '_measureCell',
	    value: function _measureCell(_ref3) {
	      var _ref3$clientHeight = _ref3.clientHeight;
	      var clientHeight = _ref3$clientHeight === undefined ? false : _ref3$clientHeight;
	      var _ref3$clientWidth = _ref3.clientWidth;
	      var clientWidth = _ref3$clientWidth === undefined ? true : _ref3$clientWidth;
	      var columnIndex = _ref3.columnIndex;
	      var rowIndex = _ref3.rowIndex;
	      var cellRenderer = this.props.cellRenderer;
	
	
	      var rendered = cellRenderer({
	        columnIndex: columnIndex,
	        index: rowIndex, // Simplify List :rowRenderer use case
	        rowIndex: rowIndex
	      });
	
	      // Handle edge case where this method is called before the CellMeasurer has completed its initial render (and mounted).
	      this._renderAndMount();
	
	      // @TODO Keep an eye on this for future React updates as the interface may change:
	      // https://twitter.com/soprano/status/737316379712331776
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, rendered, this._div);
	
	      var measurements = {
	        height: clientHeight && this._div.clientHeight,
	        width: clientWidth && this._div.clientWidth
	      };
	
	      _reactDom2.default.unmountComponentAtNode(this._div);
	
	      return measurements;
	    }
	  }, {
	    key: '_renderAndMount',
	    value: function _renderAndMount() {
	      if (!this._div) {
	        this._div = document.createElement('div');
	        this._div.style.display = 'inline-block';
	        this._div.style.position = 'absolute';
	        this._div.style.visibility = 'hidden';
	        this._div.style.zIndex = -1;
	
	        this._updateDivDimensions(this.props);
	
	        this._containerNode = this._getContainerNode(this.props);
	        this._containerNode.appendChild(this._div);
	      }
	    }
	  }, {
	    key: '_unmountContainer',
	    value: function _unmountContainer() {
	      if (this._div) {
	        this._containerNode.removeChild(this._div);
	
	        this._div = null;
	      }
	
	      this._containerNode = null;
	    }
	  }, {
	    key: '_updateDivDimensions',
	    value: function _updateDivDimensions(props) {
	      var height = props.height;
	      var width = props.width;
	
	
	      if (height && height !== this._divHeight) {
	        this._divHeight = height;
	        this._div.style.height = height + 'px';
	      }
	
	      if (width && width !== this._divWidth) {
	        this._divWidth = width;
	        this._div.style.width = width + 'px';
	      }
	    }
	  }]);
	
	  return CellMeasurer;
	}(_react.Component);
	
	exports.default = CellMeasurer;
	 false ? CellMeasurer.propTypes = {
	  /**
	   * Renders a cell given its indices.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional, custom caching strategy for cell sizes.
	   */
	  cellSizeCache: _react.PropTypes.object,
	
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ getColumnWidth, getRowHeight, resetMeasurements }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * A Node, Component instance, or function that returns either.
	   * If this property is not specified the document body will be used.
	   */
	  container: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.func, _react2.default.PropTypes.node]),
	
	  /**
	   * Assign a fixed :height in order to measure dynamic text :width only.
	   */
	  height: _react.PropTypes.number,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Assign a fixed :width in order to measure dynamic text :height only.
	   */
	  width: _react.PropTypes.number
	} : void 0;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = idCellSizeCache;
	
	var _defaultCellSizeCache = __webpack_require__(270);
	
	var _defaultCellSizeCache2 = _interopRequireDefault(_defaultCellSizeCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Alternate CellMeasurer `cellSizeCache` implementation.
	 * Similar to `defaultCellSizeCache` except that sizes are tied to data id rather than index.
	 * Requires an index-to-id map function (passed in externally) to operate.
	 */
	function idCellSizeCache(_ref) {
	  var indexToIdMap = _ref.indexToIdMap;
	  var _ref$uniformColumnWid = _ref.uniformColumnWidth;
	  var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
	  var _ref$uniformRowHeight = _ref.uniformRowHeight;
	  var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
	
	  var cellSizeCache = new _defaultCellSizeCache2.default({
	    uniformColumnWidth: uniformColumnWidth,
	    uniformRowHeight: uniformRowHeight
	  });
	
	  return {
	    clearAllColumnWidths: function clearAllColumnWidths() {
	      cellSizeCache.clearAllColumnWidths();
	    },
	    clearAllRowHeights: function clearAllRowHeights() {
	      cellSizeCache.clearAllRowHeights();
	    },
	    clearColumnWidth: function clearColumnWidth(index) {
	      cellSizeCache.clearColumnWidth(indexToIdMap(index));
	    },
	    clearRowHeight: function clearRowHeight(index) {
	      cellSizeCache.clearRowHeight(indexToIdMap(index));
	    },
	    getColumnWidth: function getColumnWidth(index) {
	      return cellSizeCache.getColumnWidth(indexToIdMap(index));
	    },
	    getRowHeight: function getRowHeight(index) {
	      return cellSizeCache.getRowHeight(indexToIdMap(index));
	    },
	    setColumnWidth: function setColumnWidth(index, width) {
	      cellSizeCache.setColumnWidth(indexToIdMap(index), width);
	    },
	    setRowHeight: function setRowHeight(index, height) {
	      cellSizeCache.setRowHeight(indexToIdMap(index), height);
	    }
	  };
	}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.idCellSizeCache = exports.defaultCellSizeCache = exports.CellMeasurer = exports.default = undefined;
	
	var _CellMeasurer2 = __webpack_require__(1178);
	
	var _CellMeasurer3 = _interopRequireDefault(_CellMeasurer2);
	
	var _defaultCellSizeCache2 = __webpack_require__(270);
	
	var _defaultCellSizeCache3 = _interopRequireDefault(_defaultCellSizeCache2);
	
	var _idCellSizeCache2 = __webpack_require__(1179);
	
	var _idCellSizeCache3 = _interopRequireDefault(_idCellSizeCache2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer3.default;
	exports.CellMeasurer = _CellMeasurer3.default;
	exports.defaultCellSizeCache = _defaultCellSizeCache3.default;
	exports.idCellSizeCache = _idCellSizeCache3.default;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionView = __webpack_require__(1182);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(1186);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(1209);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var Collection = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection(props, context) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    return _this;
	  }
	
	  /** See Collection#recomputeCellSizesAndPositions */
	
	
	  _createClass(Collection, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = _objectWithoutProperties(this.props, []);
	
	      return _react2.default.createElement(_CollectionView2.default, _extends({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: function ref(_ref) {
	          _this2._collectionView = _ref;
	        }
	      }, props));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props;
	      var cellCount = _props.cellCount;
	      var cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter;
	      var sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref2) {
	      var align = _ref2.align;
	      var cellIndex = _ref2.cellIndex;
	      var height = _ref2.height;
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var width = _ref2.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref3) {
	      var _this3 = this;
	
	      var height = _ref3.height;
	      var isScrolling = _ref3.isScrolling;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	      var _props2 = this.props;
	      var cellGroupRenderer = _props2.cellGroupRenderer;
	      var cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref4) {
	          var index = _ref4.index;
	          return _this3._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }]);
	
	  return Collection;
	}(_react.Component);
	
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	 false ? Collection.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _react.PropTypes.number
	} : void 0;
	
	
	function defaultCellGroupRenderer(_ref5) {
	  var cellCache = _ref5.cellCache;
	  var cellRenderer = _ref5.cellRenderer;
	  var cellSizeAndPositionGetter = _ref5.cellSizeAndPositionGetter;
	  var indices = _ref5.indices;
	  var isScrolling = _ref5.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    var cellRendererProps = {
	      index: index,
	      isScrolling: isScrolling,
	      key: index,
	      style: {
	        height: cellMetadata.height,
	        left: cellMetadata.x,
	        position: 'absolute',
	        top: cellMetadata.y,
	        width: cellMetadata.width
	      }
	    };
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer(cellRendererProps);
	      }
	
	      return cellCache[index];
	    } else {
	      return cellRenderer(cellRendererProps);
	    }
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createCallbackMemoizer = __webpack_require__(272);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(352);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// @TODO It would be nice to refactor Grid to use this code as well.
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_Component) {
	  _inherits(CollectionView, _Component);
	
	  function CollectionView(props, context) {
	    _classCallCheck(this, CollectionView);
	
	    var _this = _possibleConstructorReturn(this, (CollectionView.__proto__ || Object.getPrototypeOf(CollectionView)).call(this, props, context));
	
	    _this.state = {
	      calculateSizeAndPositionDataOnNextUpdate: false,
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes callbacks only when their values have changed.
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around.
	    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  _createClass(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this.setState({
	        calculateSizeAndPositionDataOnNextUpdate: true
	      });
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var cellLayoutManager = _props.cellLayoutManager;
	      var scrollLeft = _props.scrollLeft;
	      var scrollToCell = _props.scrollToCell;
	      var scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge.height;
	      var totalWidth = _cellLayoutManager$ge.width;
	
	      // Initialize onScroll callback.
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props;
	      var height = _props2.height;
	      var scrollToAlignment = _props2.scrollToAlignment;
	      var scrollToCell = _props2.scrollToCell;
	      var width = _props2.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var cellLayoutManager = this.props.cellLayoutManager;
	
	
	      cellLayoutManager.calculateSizeAndPositionData();
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextProps.cellCount === 0 && (nextState.scrollLeft !== 0 || nextState.scrollTop !== 0)) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        nextProps.cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      if (nextState.calculateSizeAndPositionDataOnNextUpdate) {
	        this.setState({
	          calculateSizeAndPositionDataOnNextUpdate: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var cellCount = _props3.cellCount;
	      var cellLayoutManager = _props3.cellLayoutManager;
	      var className = _props3.className;
	      var height = _props3.height;
	      var horizontalOverscanSize = _props3.horizontalOverscanSize;
	      var id = _props3.id;
	      var noContentRenderer = _props3.noContentRenderer;
	      var style = _props3.style;
	      var verticalOverscanSize = _props3.verticalOverscanSize;
	      var width = _props3.width;
	      var _state2 = this.state;
	      var isScrolling = _state2.isScrolling;
	      var scrollLeft = _state2.scrollLeft;
	      var scrollTop = _state2.scrollTop;
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge2.height;
	      var totalWidth = _cellLayoutManager$ge2.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        WebkitOverflowScrolling: 'touch',
	        width: width,
	        willChange: 'transform'
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref) {
	            _this2._scrollingContainer = _ref;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Collection', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, collectionStyle, style),
	          tabIndex: 0
	        },
	        cellCount > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            }
	          },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this3 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this3.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this3._disablePointerEventsTimeoutId = null;
	        _this3.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnSectionRenderedHelper',
	    value: function _invokeOnSectionRenderedHelper() {
	      var _props4 = this.props;
	      var cellLayoutManager = _props4.cellLayoutManager;
	      var onSectionRendered = _props4.onSectionRendered;
	
	
	      this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref2) {
	      var _this4 = this;
	
	      var scrollLeft = _ref2.scrollLeft;
	      var scrollTop = _ref2.scrollTop;
	      var totalHeight = _ref2.totalHeight;
	      var totalWidth = _ref2.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref3) {
	          var scrollLeft = _ref3.scrollLeft;
	          var scrollTop = _ref3.scrollTop;
	          var _props5 = _this4.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref4) {
	      var scrollLeft = _ref4.scrollLeft;
	      var scrollTop = _ref4.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_updateScrollPositionForScrollToCell',
	    value: function _updateScrollPositionForScrollToCell() {
	      var _props6 = this.props;
	      var cellLayoutManager = _props6.cellLayoutManager;
	      var height = _props6.height;
	      var scrollToAlignment = _props6.scrollToAlignment;
	      var scrollToCell = _props6.scrollToCell;
	      var width = _props6.width;
	      var _state3 = this.state;
	      var scrollLeft = _state3.scrollLeft;
	      var scrollTop = _state3.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          this._setScrollPosition(scrollPosition);
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props7 = this.props;
	      var cellLayoutManager = _props7.cellLayoutManager;
	      var height = _props7.height;
	      var isScrollingChange = _props7.isScrollingChange;
	      var width = _props7.width;
	
	      var scrollbarSize = this._scrollbarSize;
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize();
	
	      var totalHeight = _cellLayoutManager$ge3.height;
	      var totalWidth = _cellLayoutManager$ge3.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!this.state.isScrolling) {
	          isScrollingChange(true);
	        }
	
	        this.setState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    }
	  }]);
	
	  return CollectionView;
	}(_react.Component);
	
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  style: {},
	  verticalOverscanSize: 0
	};
	exports.default = CollectionView;
	 false ? CollectionView.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _react.PropTypes.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Collection element.
	   */
	  id: _react.PropTypes.string,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _react.PropTypes.number.isRequired,
	
	  isScrollingChange: _react.PropTypes.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _react.PropTypes.number,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _react.PropTypes.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height;
	    var width = _ref.width;
	    var x = _ref.x;
	    var y = _ref.y;
	
	    _classCallCheck(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  _createClass(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	
	  return Section;
	}(); /** @rlow */
	
	
	exports.default = Section;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Window Sections are used to group nearby cells.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This enables us to more quickly determine which cells to display in a given region of the Window.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _Section = __webpack_require__(1183);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SECTION_SIZE = 100;
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
	
	    _classCallCheck(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  _createClass(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height;
	      var width = _ref.width;
	      var x = _ref.x;
	      var y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return Object.keys(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height;
	      var width = _ref3.width;
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return Object.keys(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return Object.keys(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum;
	      var index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = exports.default = undefined;
	
	var _Collection2 = __webpack_require__(1181);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection3.default;
	exports.Collection = _Collection3.default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(1184);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter;
	  var sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_Component) {
	  _inherits(ColumnSizer, _Component);
	
	  function ColumnSizer(props, context) {
	    _classCallCheck(this, ColumnSizer);
	
	    var _this = _possibleConstructorReturn(this, (ColumnSizer.__proto__ || Object.getPrototypeOf(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props;
	      var columnMaxWidth = _props.columnMaxWidth;
	      var columnMinWidth = _props.columnMinWidth;
	      var columnCount = _props.columnCount;
	      var width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var columnMaxWidth = _props2.columnMaxWidth;
	      var columnMinWidth = _props2.columnMinWidth;
	      var columnCount = _props2.columnCount;
	      var width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child && typeof child.recomputeGridSize !== 'function') {
	        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	
	  return ColumnSizer;
	}(_react.Component);
	
	exports.default = ColumnSizer;
	 false ? ColumnSizer.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _react.PropTypes.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _react.PropTypes.number,
	
	  /** Number of columns in Grid or Table child */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /** Width of Grid or Table child */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = exports.default = undefined;
	
	var _ColumnSizer2 = __webpack_require__(1187);
	
	var _ColumnSizer3 = _interopRequireDefault(_ColumnSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer3.default;
	exports.ColumnSizer = _ColumnSizer3.default;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1192);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1191);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(272);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _getOverscanIndices = __webpack_require__(1193);
	
	var _getOverscanIndices2 = _interopRequireDefault(_getOverscanIndices);
	
	var _scrollbarSize = __webpack_require__(352);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _updateScrollIndexHelper = __webpack_require__(1194);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(578);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props, context) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes onSectionRendered callback only when start/stop row or column indices change
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around
	    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
	    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
	    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._columnWidthGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._rowHeightGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	
	    // See defaultCellRangeRenderer() for more information on the usage of these caches
	    _this._cellCache = {};
	    _this._styleCache = {};
	    return _this;
	  }
	
	  /**
	   * Pre-measure all columns and rows in a Grid.
	   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	   */
	
	
	  _createClass(Grid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props = this.props;
	      var columnCount = _props.columnCount;
	      var rowCount = _props.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      this.forceUpdate();
	    }
	
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: 'scrollToCell',
	    value: function scrollToCell(_ref2) {
	      var columnIndex = _ref2.columnIndex;
	      var rowIndex = _ref2.rowIndex;
	
	      var props = this.props;
	      this._updateScrollLeftForScrollToColumn(_extends({}, props, {
	        scrollToColumn: columnIndex
	      }));
	      this._updateScrollTopForScrollToRow(_extends({}, props, {
	        scrollToRow: rowIndex
	      }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props;
	      var scrollLeft = _props2.scrollLeft;
	      var scrollToColumn = _props2.scrollToColumn;
	      var scrollTop = _props2.scrollTop;
	      var scrollToRow = _props2.scrollToRow;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      if (scrollToColumn >= 0 || scrollToRow >= 0) {
	        this._updateScrollLeftForScrollToColumn();
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var columnCount = _props3.columnCount;
	      var height = _props3.height;
	      var rowCount = _props3.rowCount;
	      var scrollToAlignment = _props3.scrollToAlignment;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollToRow = _props3.scrollToRow;
	      var width = _props3.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	
	        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	        previousCellsCount: prevProps.columnCount,
	        previousCellSize: prevProps.columnWidth,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToColumn,
	        previousSize: prevProps.width,
	        scrollOffset: scrollLeft,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToColumn,
	        size: width,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
	          return _this2._updateScrollLeftForScrollToColumn(_extends({}, _this2.props, { scrollToColumn: scrollToColumn }));
	        }
	      });
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	        previousCellsCount: prevProps.rowCount,
	        previousCellSize: prevProps.rowHeight,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToRow,
	        previousSize: prevProps.height,
	        scrollOffset: scrollTop,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToRow,
	        size: height,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
	          return _this2._updateScrollTopForScrollToRow(_extends({}, _this2.props, { scrollToRow: scrollToRow }));
	        }
	      });
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this3 = this;
	
	      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	        if (nextProps.scrollTop != null) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this._setScrollPosition(newState);
	      }
	
	      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
	        this._styleCache = {};
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.columnCount,
	        cellSize: this.props.columnWidth,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: nextProps.columnWidth,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.rowCount,
	        cellSize: this.props.rowHeight,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: nextProps.rowHeight,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
	        }
	      });
	
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var autoContainerWidth = _props4.autoContainerWidth;
	      var autoHeight = _props4.autoHeight;
	      var className = _props4.className;
	      var containerStyle = _props4.containerStyle;
	      var height = _props4.height;
	      var id = _props4.id;
	      var noContentRenderer = _props4.noContentRenderer;
	      var style = _props4.style;
	      var tabIndex = _props4.tabIndex;
	      var width = _props4.width;
	      var isScrolling = this.state.isScrolling;
	
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref3) {
	            _this4._scrollingContainer = _ref3;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, gridStyle, style),
	          tabIndex: tabIndex
	        },
	        childrenToDisplay.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            style: _extends({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : ''
	            }, containerStyle)
	          },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer;
	      var cellRangeRenderer = props.cellRangeRenderer;
	      var columnCount = props.columnCount;
	      var height = props.height;
	      var overscanColumnCount = props.overscanColumnCount;
	      var overscanRowCount = props.overscanRowCount;
	      var rowCount = props.rowCount;
	      var width = props.width;
	      var isScrolling = state.isScrolling;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
	      var scrollDirectionVertical = state.scrollDirectionVertical;
	      var scrollLeft = state.scrollLeft;
	      var scrollTop = state.scrollTop;
	
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = (0, _getOverscanIndices2.default)({
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: this._renderedColumnStartIndex,
	          stopIndex: this._renderedColumnStopIndex
	        });
	
	        var overscanRowIndices = (0, _getOverscanIndices2.default)({
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: this._renderedRowStartIndex,
	          stopIndex: this._renderedRowStopIndex
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_debounceScrollEnded',
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_debounceScrollEndedCallback',
	    value: function _debounceScrollEndedCallback() {
	      this._disablePointerEventsTimeoutId = null;
	
	      var styleCache = this._styleCache;
	
	      // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      // Copy over the visible cell styles so avoid unnecessary re-render.
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = rowIndex + '-' + columnIndex;
	          this._styleCache[key] = styleCache[key];
	        }
	      }
	
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: '_invokeOnGridRenderedHelper',
	    value: function _invokeOnGridRenderedHelper() {
	      var onSectionRendered = this.props.onSectionRendered;
	
	
	      this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: this._columnStartIndex,
	          columnOverscanStopIndex: this._columnStopIndex,
	          columnStartIndex: this._renderedColumnStartIndex,
	          columnStopIndex: this._renderedColumnStopIndex,
	          rowOverscanStartIndex: this._rowStartIndex,
	          rowOverscanStopIndex: this._rowStopIndex,
	          rowStartIndex: this._renderedRowStartIndex,
	          rowStopIndex: this._renderedRowStopIndex
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref4) {
	      var _this5 = this;
	
	      var scrollLeft = _ref4.scrollLeft;
	      var scrollTop = _ref4.scrollTop;
	      var totalColumnsWidth = _ref4.totalColumnsWidth;
	      var totalRowsHeight = _ref4.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref5) {
	          var scrollLeft = _ref5.scrollLeft;
	          var scrollTop = _ref5.scrollTop;
	          var _props5 = _this5.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref6) {
	      var scrollLeft = _ref6.scrollLeft;
	      var scrollTop = _ref6.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapPropertyGetter',
	    value: function _wrapPropertyGetter(value) {
	      return value instanceof Function ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(size) {
	      return this._wrapPropertyGetter(size);
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var columnCount = props.columnCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToColumn = props.scrollToColumn;
	      var width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (scrollToColumn >= 0 && columnCount > 0) {
	        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
	
	        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	
	        if (scrollLeft !== calculatedScrollLeft) {
	          this._setScrollPosition({
	            scrollLeft: calculatedScrollLeft
	          });
	        }
	      }
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var height = props.height;
	      var rowCount = props.rowCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToRow = props.scrollToRow;
	      var scrollTop = state.scrollTop;
	
	
	      if (scrollToRow >= 0 && rowCount > 0) {
	        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
	
	        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	
	        if (scrollTop !== calculatedScrollTop) {
	          this._setScrollPosition({
	            scrollTop: calculatedScrollTop
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceScrollEnded();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props6 = this.props;
	      var autoHeight = _props6.autoHeight;
	      var height = _props6.height;
	      var width = _props6.width;
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	    }
	  }]);
	
	  return Grid;
	}(_react.Component);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  overscanColumnCount: 0,
	  overscanRowCount: 10,
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  style: {},
	  tabIndex: 0
	};
	exports.default = Grid;
	 false ? Grid.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _react.PropTypes.bool,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their index ranges.
	   * Should implement the following interface: ({
	   *   cellCache: Map,
	   *   cellRenderer: Function,
	   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
	   *   columnStartIndex: number,
	   *   columnStopIndex: number,
	   *   isScrolling: boolean,
	   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
	   *   rowStartIndex: number,
	   *   rowStopIndex: number,
	   *   scrollLeft: number,
	   *   scrollTop: number
	   * }): Array<PropTypes.node>
	   */
	  cellRangeRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Grid element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed column width (number) or a function that returns the width of a column given its index.
	   * Should implement the following interface: (index: number): number
	   */
	  columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: _react.PropTypes.object,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Grid element.
	   */
	  id: _react.PropTypes.string,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Grid that was just rendered.
	   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _react.PropTypes.number,
	
	  /** Horizontal offset. */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Column index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToColumn: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Row index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToRow: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /**
	   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager = function () {
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount;
	    var cellSizeGetter = _ref.cellSizeGetter;
	    var estimatedCellSize = _ref.estimatedCellSize;
	
	    _classCallCheck(this, CellSizeAndPositionManager);
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	
	    // Cache of size and position data for cells, mapped by cell index.
	    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	    this._cellSizeAndPositionData = {};
	
	    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	    this._lastMeasuredIndex = -1;
	  }
	
	  _createClass(CellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount;
	      var estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          if (_size == null || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          }
	
	          this._cellSizeAndPositionData[i] = {
	            offset: _offset,
	            size: _size
	          };
	
	          _offset += _size;
	        }
	
	        this._lastMeasuredIndex = index;
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completedly estimated initially.
	     * As cells as measured the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	
	      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(_ref5) {
	      var high = _ref5.high;
	      var low = _ref5.low;
	      var offset = _ref5.offset;
	
	      var middle = void 0;
	      var currentOffset = void 0;
	
	      while (low <= high) {
	        middle = low + Math.floor((high - low) / 2);
	        currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(_ref6) {
	      var index = _ref6.index;
	      var offset = _ref6.offset;
	
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch({
	        high: Math.min(index, this._cellCount - 1),
	        low: Math.floor(index / 2),
	        offset: offset
	      });
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch({
	          high: lastMeasuredIndex,
	          low: 0,
	          offset: offset
	        });
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch({
	          index: lastMeasuredIndex,
	          offset: offset
	        });
	      }
	    }
	  }]);
	
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_MAX_SCROLL_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CellSizeAndPositionManager = __webpack_require__(1190);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize;
	    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;
	
	    var params = _objectWithoutProperties(_ref, ['maxScrollSize']);
	
	    _classCallCheck(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  _createClass(ScalingCellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scalled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize;
	      var offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	      var totalSize = _ref3.totalSize;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex,
	        totalSize: totalSize
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize;
	      var offset = _ref5.offset;
	      var totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize;
	      var offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize;
	      var offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param cellsSize Width or height of cells for the current axis
	 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
	 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
	 * @param nextCellsCount Newly updated number of rows or columns in the current axis
	 * @param nextCellsSize Newly updated width or height of cells for the current axis
	 * @param nextScrollToIndex Newly updated scroll-to-index
	 * @param scrollToIndex Scroll-to-index
	 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSize = _ref.cellSize;
	  var computeMetadataCallback = _ref.computeMetadataCallback;
	  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
	  var nextCellsCount = _ref.nextCellsCount;
	  var nextCellSize = _ref.nextCellSize;
	  var nextScrollToIndex = _ref.nextScrollToIndex;
	  var scrollToIndex = _ref.scrollToIndex;
	  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverscanIndices;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function getOverscanIndices(_ref) {
	  var cellCount = _ref.cellCount;
	  var overscanCellsCount = _ref.overscanCellsCount;
	  var scrollDirection = _ref.scrollDirection;
	  var startIndex = _ref.startIndex;
	  var stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  switch (scrollDirection) {
	    case SCROLL_DIRECTION_FORWARD:
	      overscanStartIndex = startIndex;
	      overscanStopIndex = stopIndex + overscanCellsCount;
	      break;
	    case SCROLL_DIRECTION_BACKWARD:
	      overscanStartIndex = startIndex - overscanCellsCount;
	      overscanStopIndex = stopIndex;
	      break;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 *
	 * @param cellsSize Width or height of cells for the current axis
	 * @param cellSizeAndPositionManager Manages size and position metadata of cells
	 * @param previousCellsCount Previous number of rows or columns
	 * @param previousCellsSize Previous width or height of cells
	 * @param previousScrollToIndex Previous scroll-to-index
	 * @param previousSize Previous width or height of the virtualized container
	 * @param scrollOffset Current scrollLeft or scrollTop
	 * @param scrollToIndex Scroll-to-index
	 * @param size Width or height of the virtualized container
	 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
	 */
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize;
	  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
	  var previousCellsCount = _ref.previousCellsCount;
	  var previousCellSize = _ref.previousCellSize;
	  var previousScrollToAlignment = _ref.previousScrollToAlignment;
	  var previousScrollToIndex = _ref.previousScrollToIndex;
	  var previousSize = _ref.previousSize;
	  var scrollOffset = _ref.scrollOffset;
	  var scrollToAlignment = _ref.scrollToAlignment;
	  var scrollToIndex = _ref.scrollToIndex;
	  var size = _ref.size;
	  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(4);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _createCallbackMemoizer = __webpack_require__(272);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_Component) {
	  _inherits(InfiniteLoader, _Component);
	
	  function InfiniteLoader(props, context) {
	    _classCallCheck(this, InfiniteLoader);
	
	    var _this = _possibleConstructorReturn(this, (InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfiniteLoader, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var _this3 = this;
	
	      var startIndex = _ref.startIndex;
	      var stopIndex = _ref.stopIndex;
	      var _props = this.props;
	      var isRowLoaded = _props.isRowLoaded;
	      var minimumBatchSize = _props.minimumBatchSize;
	      var rowCount = _props.rowCount;
	      var threshold = _props.threshold;
	
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	
	  return InfiniteLoader;
	}(_react.Component);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	 false ? InfiniteLoader.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _react.PropTypes.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _react.PropTypes.number.isRequired
	} : void 0;
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex;
	  var lastRenderedStopIndex = _ref2.lastRenderedStopIndex;
	  var startIndex = _ref2.startIndex;
	  var stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded;
	  var minimumBatchSize = _ref3.minimumBatchSize;
	  var rowCount = _ref3.rowCount;
	  var startIndex = _ref3.startIndex;
	  var stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 *
	 * Additionally, while a Grid is scrolling the cells can be cached,
	 * So it's important to invalidate that cache by recalculating sizes
	 * before forcing a rerender.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
	
	  if (recomputeSize) {
	    recomputeSize.call(component);
	  } else {
	    component.forceUpdate();
	  }
	}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = exports.default = undefined;
	
	var _InfiniteLoader2 = __webpack_require__(1195);
	
	var _InfiniteLoader3 = _interopRequireDefault(_InfiniteLoader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader3.default;
	exports.InfiniteLoader = _InfiniteLoader3.default;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Grid = __webpack_require__(184);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._cellRenderer = _this._cellRenderer.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var className = _props.className;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var scrollToIndex = _props.scrollToIndex;
	      var width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: function ref(_ref) {
	          _this2.Grid = _ref;
	        },
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	      var style = _ref2.style;
	
	      var rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);
	
	      var rowRenderer = this.props.rowRenderer;
	
	      // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(style, 'width');
	
	      var writable = _Object$getOwnPropert.writable;
	
	      if (writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer(_extends({
	        index: rowIndex,
	        style: style
	      }, rest));
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref3) {
	      var clientHeight = _ref3.clientHeight;
	      var scrollHeight = _ref3.scrollHeight;
	      var scrollTop = _ref3.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref4.rowOverscanStopIndex;
	      var rowStartIndex = _ref4.rowStartIndex;
	      var rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.defaultProps = {
	  estimatedRowSize: 30,
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = List;
	 false ? List.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: _react.PropTypes.func.isRequired,
	
	  /** Number of rows in list. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.default = undefined;
	
	var _List2 = __webpack_require__(1197);
	
	var _List3 = _interopRequireDefault(_List2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(184);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders 1, 2, or 4 Grids depending on configuration.
	 * A main (body) Grid will always be rendered.
	 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
	 * If no sticky columns, only 1 sticky header Grid will be rendered.
	 * If sticky columns, 2 sticky header Grids will be rendered.
	 */
	var MultiGrid = function (_Component) {
	  _inherits(MultiGrid, _Component);
	
	  function MultiGrid(props, context) {
	    _classCallCheck(this, MultiGrid);
	
	    var _this = _possibleConstructorReturn(this, (MultiGrid.__proto__ || Object.getPrototypeOf(MultiGrid)).call(this, props, context));
	
	    _this.state = {
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
	    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
	    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
	    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
	    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
	    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
	    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
	    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
	    return _this;
	  }
	
	  /** See Grid#measureAllCells */
	
	
	  _createClass(MultiGrid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
	      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
	      this._topLeftGrid && this._topLeftGrid.measureAllCells();
	      this._topRightGrid && this._topRightGrid.measureAllCells();
	    }
	
	    /** See issue #546 */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      console.warn('MultiGrid measureAllRows() is deprecated; use measureAllCells() instead.');
	
	      this.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	      var _props = this.props;
	      var fixedColumnCount = _props.fixedColumnCount;
	      var fixedRowCount = _props.fixedRowCount;
	
	
	      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
	      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
	
	      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	      this._topRightGrid && this._topRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: rowIndex
	      });
	
	      this._leftGridWidth = null;
	      this._topGridHeight = null;
	      this._maybeCalculateCachedStyles(null, this.props);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._maybeCalculateCachedStyles(null, this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props;
	      var columnWidth = _props2.columnWidth;
	      var fixedColumnCount = _props2.fixedColumnCount;
	      var fixedRowCount = _props2.fixedRowCount;
	      var rowHeight = _props2.rowHeight;
	
	
	      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
	        this._leftGridWidth = null;
	      }
	
	      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
	        this._topGridHeight = null;
	      }
	
	      this._maybeCalculateCachedStyles(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var onScroll = _props3.onScroll;
	      var onSectionRendered = _props3.onSectionRendered;
	      var scrollLeftProp = _props3.scrollLeft;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollTopProp = _props3.scrollTop;
	      var scrollToRow = _props3.scrollToRow;
	
	      var rest = _objectWithoutProperties(_props3, ['onScroll', 'onSectionRendered', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);
	
	      // scrollTop and scrollToRow props are explicitly filtered out and ignored
	
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollTop = _state.scrollTop;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: this._containerOuterStyle },
	        _react2.default.createElement(
	          'div',
	          { style: this._containerTopStyle },
	          this._renderTopLeftGrid(rest),
	          this._renderTopRightGrid(_extends({}, rest, {
	            scrollLeft: scrollLeft
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: this._containerBottomStyle },
	          this._renderBottomLeftGrid(_extends({}, rest, {
	            scrollTop: scrollTop
	          })),
	          this._renderBottomRightGrid(_extends({}, rest, {
	            onScroll: onScroll,
	            onSectionRendered: onSectionRendered,
	            scrollLeft: scrollLeft,
	            scrollToColumn: scrollToColumn,
	            scrollToRow: scrollToRow,
	            scrollTop: scrollTop
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_bottomLeftGridRef',
	    value: function _bottomLeftGridRef(ref) {
	      this._bottomLeftGrid = ref;
	    }
	  }, {
	    key: '_bottomRightGridRef',
	    value: function _bottomRightGridRef(ref) {
	      this._bottomRightGrid = ref;
	    }
	  }, {
	    key: '_cellRendererBottomLeftGrid',
	    value: function _cellRendererBottomLeftGrid(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	
	      var rest = _objectWithoutProperties(_ref2, ['rowIndex']);
	
	      var _props4 = this.props;
	      var cellRenderer = _props4.cellRenderer;
	      var fixedRowCount = _props4.fixedRowCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererBottomRightGrid',
	    value: function _cellRendererBottomRightGrid(_ref3) {
	      var columnIndex = _ref3.columnIndex;
	      var rowIndex = _ref3.rowIndex;
	
	      var rest = _objectWithoutProperties(_ref3, ['columnIndex', 'rowIndex']);
	
	      var _props5 = this.props;
	      var cellRenderer = _props5.cellRenderer;
	      var fixedColumnCount = _props5.fixedColumnCount;
	      var fixedRowCount = _props5.fixedRowCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount,
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererTopRightGrid',
	    value: function _cellRendererTopRightGrid(_ref4) {
	      var columnIndex = _ref4.columnIndex;
	
	      var rest = _objectWithoutProperties(_ref4, ['columnIndex']);
	
	      var _props6 = this.props;
	      var cellRenderer = _props6.cellRenderer;
	      var fixedColumnCount = _props6.fixedColumnCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount
	      }));
	    }
	  }, {
	    key: '_columnWidthRightGrid',
	    value: function _columnWidthRightGrid(_ref5) {
	      var index = _ref5.index;
	      var _props7 = this.props;
	      var fixedColumnCount = _props7.fixedColumnCount;
	      var columnWidth = _props7.columnWidth;
	
	
	      return columnWidth instanceof Function ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
	    }
	  }, {
	    key: '_getBottomGridHeight',
	    value: function _getBottomGridHeight(props) {
	      var height = props.height;
	
	
	      var topGridHeight = this._getTopGridHeight(props);
	
	      return height - topGridHeight;
	    }
	  }, {
	    key: '_getLeftGridWidth',
	    value: function _getLeftGridWidth(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var columnWidth = props.columnWidth;
	
	
	      if (this._leftGridWidth == null) {
	        if (columnWidth instanceof Function) {
	          var leftGridWidth = 0;
	
	          for (var index = 0; index < fixedColumnCount; index++) {
	            leftGridWidth += columnWidth({ index: index });
	          }
	
	          this._leftGridWidth = leftGridWidth;
	        } else {
	          this._leftGridWidth = columnWidth * fixedColumnCount;
	        }
	      }
	
	      return this._leftGridWidth;
	    }
	  }, {
	    key: '_getRightGridWidth',
	    value: function _getRightGridWidth(props) {
	      var width = props.width;
	
	
	      var leftGridWidth = this._getLeftGridWidth(props);
	
	      return width - leftGridWidth;
	    }
	  }, {
	    key: '_getTopGridHeight',
	    value: function _getTopGridHeight(props) {
	      var fixedRowCount = props.fixedRowCount;
	      var rowHeight = props.rowHeight;
	
	
	      if (this._topGridHeight == null) {
	        if (rowHeight instanceof Function) {
	          var topGridHeight = 0;
	
	          for (var index = 0; index < fixedRowCount; index++) {
	            topGridHeight += rowHeight({ index: index });
	          }
	
	          this._topGridHeight = topGridHeight;
	        } else {
	          this._topGridHeight = rowHeight * fixedRowCount;
	        }
	      }
	
	      return this._topGridHeight;
	    }
	
	    /**
	     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
	     * This method recalculates styles only when specific props change.
	     */
	
	  }, {
	    key: '_maybeCalculateCachedStyles',
	    value: function _maybeCalculateCachedStyles(prevProps, props) {
	      var columnWidth = props.columnWidth;
	      var height = props.height;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowHeight = props.rowHeight;
	      var style = props.style;
	      var styleBottomLeftGrid = props.styleBottomLeftGrid;
	      var styleBottomRightGrid = props.styleBottomRightGrid;
	      var styleTopLeftGrid = props.styleTopLeftGrid;
	      var styleTopRightGrid = props.styleTopRightGrid;
	      var width = props.width;
	
	
	      var firstRender = !prevProps;
	      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
	      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
	      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;
	
	      if (firstRender || sizeChange || style !== prevProps.style) {
	        this._containerOuterStyle = _extends({
	          height: height,
	          width: width
	        }, style);
	      }
	
	      if (firstRender || sizeChange || topSizeChange) {
	        this._containerTopStyle = {
	          height: this._getTopGridHeight(props),
	          position: 'relative',
	          width: width
	        };
	
	        this._containerBottomStyle = {
	          height: height - this._getTopGridHeight(props),
	          overflow: 'hidden',
	          position: 'relative',
	          width: width
	        };
	      }
	
	      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
	        this._bottomLeftGridStyle = _extends({
	          left: 0,
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute'
	        }, styleBottomLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
	        this._bottomRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          outline: 0,
	          position: 'absolute'
	        }, styleBottomRightGrid);
	      }
	
	      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
	        this._topLeftGridStyle = _extends({
	          left: 0,
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
	        this._topRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          outline: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopRightGrid);
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(scrollInfo) {
	      var scrollLeft = scrollInfo.scrollLeft;
	      var scrollTop = scrollInfo.scrollTop;
	
	      this.setState({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	      var onScroll = this.props.onScroll;
	      if (onScroll) {
	        onScroll(scrollInfo);
	      }
	    }
	  }, {
	    key: '_renderBottomLeftGrid',
	    value: function _renderBottomLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowCount = props.rowCount;
	      var scrollTop = props.scrollTop;
	
	
	      if (!fixedColumnCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomLeftGrid,
	        columnCount: fixedColumnCount,
	        height: this._getBottomGridHeight(props),
	        ref: this._bottomLeftGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollTop: scrollTop,
	        style: this._bottomLeftGridStyle,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderBottomRightGrid',
	    value: function _renderBottomRightGrid(props) {
	      var columnCount = props.columnCount;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var rowCount = props.rowCount;
	      var scrollToColumn = props.scrollToColumn;
	      var scrollToRow = props.scrollToRow;
	
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: this._onScroll,
	        ref: this._bottomRightGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollToColumn: scrollToColumn - fixedColumnCount,
	        scrollToRow: scrollToRow - fixedRowCount,
	        style: this._bottomRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopLeftGrid',
	    value: function _renderTopLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	
	
	      if (!fixedColumnCount || !fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        columnCount: fixedColumnCount,
	        height: this._getTopGridHeight(props),
	        ref: this._topLeftGridRef,
	        rowCount: fixedRowCount,
	        style: this._topLeftGridStyle,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopRightGrid',
	    value: function _renderTopRightGrid(props) {
	      var columnCount = props.columnCount;
	      var fixedColumnCount = props.fixedColumnCount;
	      var fixedRowCount = props.fixedRowCount;
	      var scrollLeft = props.scrollLeft;
	
	
	      if (!fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererTopRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getTopGridHeight(props),
	        ref: this._topRightGridRef,
	        rowCount: fixedRowCount,
	        scrollLeft: scrollLeft,
	        style: this._topRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_rowHeightBottomGrid',
	    value: function _rowHeightBottomGrid(_ref6) {
	      var index = _ref6.index;
	      var _props8 = this.props;
	      var fixedRowCount = _props8.fixedRowCount;
	      var rowHeight = _props8.rowHeight;
	
	
	      return rowHeight instanceof Function ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
	    }
	  }, {
	    key: '_topLeftGridRef',
	    value: function _topLeftGridRef(ref) {
	      this._topLeftGrid = ref;
	    }
	  }, {
	    key: '_topRightGridRef',
	    value: function _topRightGridRef(ref) {
	      this._topRightGrid = ref;
	    }
	  }]);
	
	  return MultiGrid;
	}(_react.Component);
	
	MultiGrid.defaultProps = {
	  fixedColumnCount: 0,
	  fixedRowCount: 0,
	  style: {},
	  styleBottomLeftGrid: {},
	  styleBottomRightGrid: {},
	  styleTopLeftGrid: {},
	  styleTopRightGrid: {}
	};
	exports.default = MultiGrid;
	 false ? MultiGrid.propTypes = {
	  fixedColumnCount: _react.PropTypes.number.isRequired,
	  fixedRowCount: _react.PropTypes.number.isRequired,
	  style: _react.PropTypes.object.isRequired,
	  styleBottomLeftGrid: _react.PropTypes.object.isRequired,
	  styleBottomRightGrid: _react.PropTypes.object.isRequired,
	  styleTopLeftGrid: _react.PropTypes.object.isRequired,
	  styleTopRightGrid: _react.PropTypes.object.isRequired
	} : void 0;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiGrid = exports.default = undefined;
	
	var _MultiGrid2 = __webpack_require__(1199);
	
	var _MultiGrid3 = _interopRequireDefault(_MultiGrid2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MultiGrid3.default;
	exports.MultiGrid = _MultiGrid3.default;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_Component) {
	  _inherits(ScrollSync, _Component);
	
	  function ScrollSync(props, context) {
	    _classCallCheck(this, ScrollSync);
	
	    var _this = _possibleConstructorReturn(this, (ScrollSync.__proto__ || Object.getPrototypeOf(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var clientHeight = _state.clientHeight;
	      var clientWidth = _state.clientWidth;
	      var scrollHeight = _state.scrollHeight;
	      var scrollLeft = _state.scrollLeft;
	      var scrollTop = _state.scrollTop;
	      var scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight;
	      var clientWidth = _ref.clientWidth;
	      var scrollHeight = _ref.scrollHeight;
	      var scrollLeft = _ref.scrollLeft;
	      var scrollTop = _ref.scrollTop;
	      var scrollWidth = _ref.scrollWidth;
	
	      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
	    }
	  }]);
	
	  return ScrollSync;
	}(_react.Component);
	
	exports.default = ScrollSync;
	 false ? ScrollSync.propTypes = {
	  /**
	   * Function responsible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired
	} : void 0;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = exports.default = undefined;
	
	var _ScrollSync2 = __webpack_require__(1201);
	
	var _ScrollSync3 = _interopRequireDefault(_ScrollSync2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync3.default;
	exports.ScrollSync = _ScrollSync3.default;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Column = __webpack_require__(579);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(133);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Grid = __webpack_require__(184);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _defaultRowRenderer = __webpack_require__(584);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _SortDirection = __webpack_require__(271);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var disableHeader = _props.disableHeader;
	      var gridClassName = _props.gridClassName;
	      var gridStyle = _props.gridStyle;
	      var headerHeight = _props.headerHeight;
	      var height = _props.height;
	      var id = _props.id;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var rowClassName = _props.rowClassName;
	      var rowStyle = _props.rowStyle;
	      var scrollToIndex = _props.scrollToIndex;
	      var style = _props.style;
	      var width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = disableHeader ? height : height - headerHeight;
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      _react2.default.Children.toArray(children).forEach(function (column, index) {
	        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
	
	        _this2._cachedColumnStyles[index] = _extends({}, flexStyles, {
	          overflow: 'hidden'
	        });
	      });
	
	      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactVirtualized__Table', className),
	          id: id,
	          style: style
	        },
	        !disableHeader && _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('ReactVirtualized__Table__headerRow', rowClass),
	            style: _extends({}, rowStyleObject, {
	              height: headerHeight,
	              overflow: 'hidden',
	              paddingRight: scrollbarWidth,
	              width: width
	            })
	          },
	          this._getRenderedHeaderRow()
	        ),
	        _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__Grid', gridClassName),
	          cellRenderer: this._createRow,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          id: undefined,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: function ref(_ref) {
	            _this2.Grid = _ref;
	          },
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: _extends({}, gridStyle, {
	            overflowX: 'hidden'
	          })
	        }))
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref2) {
	      var column = _ref2.column;
	      var columnIndex = _ref2.columnIndex;
	      var isScrolling = _ref2.isScrolling;
	      var rowData = _ref2.rowData;
	      var rowIndex = _ref2.rowIndex;
	      var _column$props = column.props;
	      var cellDataGetter = _column$props.cellDataGetter;
	      var cellRenderer = _column$props.cellRenderer;
	      var className = _column$props.className;
	      var columnData = _column$props.columnData;
	      var dataKey = _column$props.dataKey;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, rowData: rowData, rowIndex: rowIndex });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'Row' + rowIndex + '-Col' + columnIndex,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__rowColumn', className),
	          style: style,
	          title: title
	        },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref3) {
	      var column = _ref3.column;
	      var index = _ref3.index;
	      var _props2 = this.props;
	      var headerClassName = _props2.headerClassName;
	      var headerStyle = _props2.headerStyle;
	      var onHeaderClick = _props2.onHeaderClick;
	      var sort = _props2.sort;
	      var sortBy = _props2.sortBy;
	      var sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props;
	      var dataKey = _column$props2.dataKey;
	      var disableSort = _column$props2.disableSort;
	      var headerRenderer = _column$props2.headerRenderer;
	      var label = _column$props2.label;
	      var columnData = _column$props2.columnData;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
	        'ReactVirtualized__Table__sortableHeaderColumn': sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, headerStyle);
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var a11yProps = {};
	
	      if (sortEnabled || onHeaderClick) {
	        (function () {
	          // If this is a sortable header, clicking it should update the table data's sorting.
	          var newSortDirection = sortBy !== dataKey || sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	          var onClick = function onClick() {
	            sortEnabled && sort({
	              sortBy: dataKey,
	              sortDirection: newSortDirection
	            });
	            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey });
	          };
	
	          var onKeyDown = function onKeyDown(event) {
	            if (event.key === 'Enter' || event.key === ' ') {
	              onClick();
	            }
	          };
	
	          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
	          a11yProps.role = 'rowheader';
	          a11yProps.tabIndex = 0;
	          a11yProps.onClick = onClick;
	          a11yProps.onKeyDown = onKeyDown;
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, a11yProps, {
	          key: 'Header-Col' + index,
	          className: classNames,
	          style: style
	        }),
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref4) {
	      var _this3 = this;
	
	      var index = _ref4.rowIndex;
	      var isScrolling = _ref4.isScrolling;
	      var key = _ref4.key;
	      var style = _ref4.style;
	      var _props3 = this.props;
	      var children = _props3.children;
	      var onRowClick = _props3.onRowClick;
	      var onRowDoubleClick = _props3.onRowDoubleClick;
	      var onRowMouseOver = _props3.onRowMouseOver;
	      var onRowMouseOut = _props3.onRowMouseOut;
	      var rowClassName = _props3.rowClassName;
	      var rowGetter = _props3.rowGetter;
	      var rowRenderer = _props3.rowRenderer;
	      var rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = rowClassName instanceof Function ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = _react2.default.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('ReactVirtualized__Table__row', rowClass);
	      var flattenedStyle = _extends({}, style, rowStyleObject, {
	        height: this._getRowHeight(index),
	        overflow: 'hidden',
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        key: key,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: flattenedStyle
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = _extends({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getRenderedHeaderRow',
	    value: function _getRenderedHeaderRow() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var children = _props4.children;
	      var disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : _react2.default.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return rowHeight instanceof Function ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref5) {
	      var clientHeight = _ref5.clientHeight;
	      var scrollHeight = _ref5.scrollHeight;
	      var scrollTop = _ref5.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref6) {
	      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref6.rowOverscanStopIndex;
	      var rowStartIndex = _ref6.rowStartIndex;
	      var rowStopIndex = _ref6.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      var Grid = (0, _reactDom.findDOMNode)(this.Grid);
	      var clientWidth = Grid.clientWidth || 0;
	      var offsetWidth = Grid.offsetWidth || 0;
	      var scrollbarWidth = offsetWidth - clientWidth;
	
	      this.setState({ scrollbarWidth: scrollbarWidth });
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = Table;
	 false ? Table.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** One or more Columns describing the data displayed in this row */
	  children: function children(props, propName, componentName) {
	    var children = _react2.default.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].type !== _Column2.default) {
	        return new Error('Table only accepts children of type Column');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _react.PropTypes.bool,
	
	  /**
	   * Used to estimate the total height of a Table before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _react.PropTypes.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _react.PropTypes.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _react.PropTypes.string,
	
	  /** Fixed height of header row */
	  headerHeight: _react.PropTypes.number.isRequired,
	
	  /** Fixed/available height for out DOM element */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional id */
	  id: _react.PropTypes.string,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func,
	
	  /**
	  * Optional callback when a column's header is clicked.
	  * ({ columnData: any, dataKey: string }): void
	  */
	  onHeaderClick: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _react.PropTypes.object,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _react.PropTypes.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _react.PropTypes.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _react.PropTypes.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]).isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * ({ sortBy: string, sortDirection: SortDirection }): void
	   */
	  sort: _react.PropTypes.func,
	
	  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _react.PropTypes.string,
	
	  /** Table data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _react.PropTypes.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SortIndicator = exports.SortDirection = exports.Column = exports.Table = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.default = undefined;
	
	var _Table2 = __webpack_require__(1203);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _defaultCellDataGetter2 = __webpack_require__(581);
	
	var _defaultCellDataGetter3 = _interopRequireDefault(_defaultCellDataGetter2);
	
	var _defaultCellRenderer2 = __webpack_require__(582);
	
	var _defaultCellRenderer3 = _interopRequireDefault(_defaultCellRenderer2);
	
	var _defaultHeaderRenderer2 = __webpack_require__(583);
	
	var _defaultHeaderRenderer3 = _interopRequireDefault(_defaultHeaderRenderer2);
	
	var _defaultRowRenderer2 = __webpack_require__(584);
	
	var _defaultRowRenderer3 = _interopRequireDefault(_defaultRowRenderer2);
	
	var _Column2 = __webpack_require__(579);
	
	var _Column3 = _interopRequireDefault(_Column2);
	
	var _SortDirection2 = __webpack_require__(271);
	
	var _SortDirection3 = _interopRequireDefault(_SortDirection2);
	
	var _SortIndicator2 = __webpack_require__(580);
	
	var _SortIndicator3 = _interopRequireDefault(_SortIndicator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table3.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter3.default;
	exports.defaultCellRenderer = _defaultCellRenderer3.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer3.default;
	exports.defaultRowRenderer = _defaultRowRenderer3.default;
	exports.Table = _Table3.default;
	exports.Column = _Column3.default;
	exports.SortDirection = _SortDirection3.default;
	exports.SortIndicator = _SortIndicator3.default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _reactDom = __webpack_require__(133);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsShallowCompare = __webpack_require__(33);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _onScroll = __webpack_require__(585);
	
	var _dimensions = __webpack_require__(1207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowScroller = function (_Component) {
	  _inherits(WindowScroller, _Component);
	
	  function WindowScroller(props) {
	    _classCallCheck(this, WindowScroller);
	
	    // Handle server-side rendering case
	    var _this = _possibleConstructorReturn(this, (WindowScroller.__proto__ || Object.getPrototypeOf(WindowScroller)).call(this, props));
	
	    var height = typeof window !== 'undefined' ? (0, _dimensions.getHeight)(props.scrollElement || window) : 0;
	
	    _this.state = {
	      height: height,
	      isScrolling: false,
	      scrollTop: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this.__handleWindowScrollEvent = _this.__handleWindowScrollEvent.bind(_this);
	    _this.__resetIsScrolling = _this.__resetIsScrolling.bind(_this);
	    return _this;
	  }
	
	  // Can’t use defaultProps for scrollElement without breaking server-side rendering
	
	
	  _createClass(WindowScroller, [{
	    key: 'updatePosition',
	    value: function updatePosition(scrollElement) {
	      var onResize = this.props.onResize;
	      var height = this.state.height;
	
	
	      scrollElement = scrollElement || this.props.scrollElement || window;
	      this._positionFromTop = (0, _dimensions.getPositionFromTop)(_reactDom2.default.findDOMNode(this), scrollElement);
	
	      var newHeight = (0, _dimensions.getHeight)(scrollElement);
	      if (height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	        onResize({
	          height: newHeight
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollElement = this.props.scrollElement || window;
	
	      this.updatePosition(scrollElement);
	
	      (0, _onScroll.registerScrollListener)(this, scrollElement);
	
	      window.addEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollElement = this.props.scrollElement || window;
	      var nextScrollElement = nextProps.scrollElement || window;
	
	      if (scrollElement !== nextScrollElement) {
	        this.updatePosition(nextScrollElement);
	
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        (0, _onScroll.registerScrollListener)(this, nextScrollElement);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _onScroll.unregisterScrollListener)(this, this.props.scrollElement || window);
	
	      window.removeEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state;
	      var isScrolling = _state.isScrolling;
	      var scrollTop = _state.scrollTop;
	      var height = _state.height;
	
	
	      return children({
	        height: height,
	        isScrolling: isScrolling,
	        scrollTop: scrollTop
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize(event) {
	      this.updatePosition();
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__handleWindowScrollEvent',
	    value: function __handleWindowScrollEvent(event) {
	      var onScroll = this.props.onScroll;
	
	
	      var scrollElement = this.props.scrollElement || window;
	      var scrollTop = Math.max(0, (0, _dimensions.getScrollTop)(scrollElement) - this._positionFromTop);
	
	      this.setState({
	        isScrolling: true,
	        scrollTop: scrollTop
	      });
	
	      onScroll({
	        scrollTop: scrollTop
	      });
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__resetIsScrolling',
	    value: function __resetIsScrolling() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: 'scrollElement',
	    get: function get() {
	      return this.props.scrollElement || window;
	    }
	  }]);
	
	  return WindowScroller;
	}(_react.Component);
	
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {}
	};
	exports.default = WindowScroller;
	 false ? WindowScroller.propTypes = {
	  /**
	   * Function responsible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, isScrolling, scrollTop }) => PropTypes.element
	   */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-resize: ({ height }) */
	  onResize: _react.PropTypes.func.isRequired,
	
	  /** Callback to be invoked on-scroll: ({ scrollTop }) */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /** Element to attach scroll event listeners. Defaults to window. */
	  scrollElement: _react.PropTypes.any
	} : void 0;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = exports.default = undefined;
	
	var _onScroll = __webpack_require__(585);
	
	Object.defineProperty(exports, 'IS_SCROLLING_TIMEOUT', {
	  enumerable: true,
	  get: function get() {
	    return _onScroll.IS_SCROLLING_TIMEOUT;
	  }
	});
	
	var _WindowScroller2 = __webpack_require__(1205);
	
	var _WindowScroller3 = _interopRequireDefault(_WindowScroller2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller3.default;
	exports.WindowScroller = _WindowScroller3.default;

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHeight = getHeight;
	exports.getPositionFromTop = getPositionFromTop;
	exports.getScrollTop = getScrollTop;
	/**
	 * Gets the height of the element, accounting for API differences between
	 * `window` and other DOM elements.
	 */
	function getHeight(element) {
	  return element === window ? window.innerHeight : element.getBoundingClientRect().height;
	}
	
	/**
	 * Gets the vertical position of an element within its scroll container.
	 * Elements that have been “scrolled past” return negative values.
	 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
	 * In this case the body’s top position will be a negative number and this element’s top will be increased (by that amount).
	 */
	function getPositionFromTop(element, container) {
	  var offset = container === window ? 0 : getScrollTop(container);
	  var containerElement = container === window ? document.documentElement : container;
	  return element.getBoundingClientRect().top + offset - containerElement.getBoundingClientRect().top;
	}
	
	/**
	 * Gets the vertical scroll amount of the element, accounting for IE compatibility
	 * and API differences between `window` and other DOM elements.
	 */
	function getScrollTop(element) {
	  if (element === window) {
	    return 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
	  } else {
	    return element.scrollTop;
	  }
	}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(1175);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(1177);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(1180);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'defaultCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	Object.defineProperty(exports, 'uniformSizeCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.defaultCellSizeCache;
	  }
	});
	Object.defineProperty(exports, 'idCellMeasurerCellSizeCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.idCellSizeCache;
	  }
	});
	
	var _Collection = __webpack_require__(1185);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(1188);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _Table = __webpack_require__(1204);
	
	Object.defineProperty(exports, 'defaultTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Table;
	  }
	});
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortIndicator;
	  }
	});
	
	var _Grid = __webpack_require__(184);
	
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(1196);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _List = __webpack_require__(1198);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _List.List;
	  }
	});
	
	var _MultiGrid = __webpack_require__(1200);
	
	Object.defineProperty(exports, 'MultiGrid', {
	  enumerable: true,
	  get: function get() {
	    return _MultiGrid.MultiGrid;
	  }
	});
	
	var _ScrollSync = __webpack_require__(1202);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _WindowScroller = __webpack_require__(1206);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align;
	  var align = _ref$align === undefined ? 'auto' : _ref$align;
	  var cellOffset = _ref.cellOffset;
	  var cellSize = _ref.cellSize;
	  var containerSize = _ref.containerSize;
	  var currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 **/
	
	function createDetectElementResize() {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = this;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        animationstring = 'animation',
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            animationstring = pfx + 'Animation';
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles() {
	    if (!document.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = document.head || document.getElementsByTagName('head')[0],
	          style = document.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) element.attachEvent('onresize', fn);else {
	      if (!element.__resizeTriggers__) {
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles();
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) resetTriggers(element);
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) element.detachEvent('onresize', fn);else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}

/***/ }),
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(591);
	
	var _diff = __webpack_require__(1225);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(1227);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(1223);
	
	var _helpers = __webpack_require__(591);
	
	var _defaults = __webpack_require__(1224);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.disabledScrollClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(103);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rpMqBreakpoints = __webpack_require__(71);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _SelectPopover = __webpack_require__(1345);
	
	var _SelectPopover2 = _interopRequireDefault(_SelectPopover);
	
	var _SelectButton = __webpack_require__(1342);
	
	var _SelectButton2 = _interopRequireDefault(_SelectButton);
	
	var _SelectOption = __webpack_require__(1344);
	
	var _SelectOption2 = _interopRequireDefault(_SelectOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var disabledScrollClass = exports.disabledScrollClass = 'ui-disabledScroll';
	
	var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;
	
	/**
	 * The Select component. The only exported component.
	 */
	
	var Select = function (_PureComponent) {
	    _inherits(Select, _PureComponent);
	
	    _createClass(Select, null, [{
	        key: 'toggleElementClass',
	        value: function toggleElementClass(element, className, enabled) {
	            // IE 11 doesn't support second parameter in classList.toggle
	            if (enabled) {
	                element.classList.add(className);
	            } else {
	                element.classList.remove(className);
	            }
	        }
	    }, {
	        key: 'toggleDisabledScrollClass',
	        value: function toggleDisabledScrollClass(enabled) {
	            Select.toggleElementClass(document.querySelector('html'), disabledScrollClass, enabled);
	            Select.toggleElementClass(document.body, disabledScrollClass, enabled);
	        }
	    }, {
	        key: 'getOptionProp',
	        value: function getOptionProp(option, getter) {
	            if ((0, _lodash.isString)(getter) || (0, _lodash.isArray)(getter)) {
	                return (0, _lodash.get)(option, getter);
	            }
	
	            if ((0, _lodash.isFunction)(getter)) {
	                return getter(option);
	            }
	
	            return null;
	        }
	    }]);
	
	    function Select(props) {
	        _classCallCheck(this, Select);
	
	        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	        _this.renderNoOptions = function () {
	            var _this$props = _this.props,
	                noOptionsRenderer = _this$props.noOptionsRenderer,
	                noOptionsMessage = _this$props.noOptionsMessage;
	
	
	            if (noOptionsRenderer) return noOptionsRenderer();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ui-errorMessage' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui-errorMessage__icon' },
	                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui-errorMessage__text' },
	                    noOptionsMessage
	                )
	            );
	        };
	
	        _this.state = {
	            popoverOpen: false,
	            query: ''
	        };
	        _this.startPagePositionTop = null;
	
	        _this.handlePageClick = _this.handlePageClick.bind(_this);
	        _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_this);
	
	        _this.closePopover = _this.closePopover.bind(_this);
	        _this.togglePopover = _this.togglePopover.bind(_this);
	
	        _this.clearSelection = _this.clearSelection.bind(_this);
	
	        _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	        _this.handleOptionClick = _this.handleOptionClick.bind(_this);
	
	        _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	
	        _this.getOptionLabel = _this.getOptionLabel.bind(_this);
	        _this.getOptionValue = _this.getOptionValue.bind(_this);
	        _this.isOptionSelected = _this.isOptionSelected.bind(_this);
	        _this.renderButtonLabel = _this.renderButtonLabel.bind(_this);
	        _this.renderButtonOption = _this.renderButtonOption.bind(_this);
	        _this.renderOption = _this.renderOption.bind(_this);
	        return _this;
	    }
	
	    _createClass(Select, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('click', this.handlePageClick, false);
	            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('click', this.handlePageClick, false);
	            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
	
	            if (this.isPopoverOpen()) {
	                this.closePopover();
	            }
	        }
	    }, {
	        key: 'getRenderingOptions',
	        value: function getRenderingOptions() {
	            var _this2 = this;
	
	            var _props = this.props,
	                options = _props.options,
	                optionsSorter = _props.optionsSorter;
	            var _state$query = this.state.query,
	                query = _state$query === undefined ? '' : _state$query;
	
	            return (optionsSorter === null ? _lodash.identity : _lodash.sortBy)(!query ? options : options.filter(function (option) {
	                return _this2.props.optionsQueryComparator(_this2.getOptionLabel(option), query);
	            }), optionsSorter || function (option) {
	                return _this2.getOptionLabel(option).toLowerCase();
	            });
	        }
	    }, {
	        key: 'getOptionValue',
	        value: function getOptionValue(option) {
	            return Select.getOptionProp(option, this.props.valueGetter);
	        }
	    }, {
	        key: 'getOptionLabel',
	        value: function getOptionLabel(option) {
	            return Select.getOptionProp(option, this.props.labelGetter);
	        }
	    }, {
	        key: 'isOptionSelected',
	        value: function isOptionSelected(option) {
	            var currentValue = this.getOptionValue(option);
	            if ((0, _lodash.isArray)(this.props.value)) {
	                return this.props.value.indexOf(currentValue) >= 0;
	            }
	            return currentValue === this.props.value;
	        }
	    }, {
	        key: 'isPopoverOpen',
	        value: function isPopoverOpen() {
	            return this.state.popoverOpen;
	        }
	    }, {
	        key: 'togglePopover',
	        value: function togglePopover() {
	            var popoverOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isPopoverOpen();
	
	            this.setState({
	                popoverOpen: popoverOpen
	            });
	
	            this.togglePageScroll(popoverOpen, _rpMqBreakpoints2.default.current().code);
	        }
	    }, {
	        key: 'closePopover',
	        value: function closePopover() {
	            this.togglePopover(false);
	        }
	    }, {
	        key: 'clearSelection',
	        value: function clearSelection(e, value) {
	            e.stopPropagation();
	
	            if (this.props.disabled) {
	                return;
	            }
	
	            var result = this.props.multiSelect ? this.props.value.filter(function (item) {
	                return item !== value;
	            }) : null;
	
	            this.props.onChange(result);
	        }
	    }, {
	        key: 'togglePageScroll',
	        value: function togglePageScroll(popoverOpen, breakpointCode) {
	            if (popoverOpen && [EXTRA_NARROW, NARROW].indexOf(breakpointCode) > -1) {
	                this.disablePageScroll();
	            } else {
	                this.enablePageScroll();
	            }
	        }
	    }, {
	        key: 'enablePageScroll',
	        value: function enablePageScroll() {
	            Select.toggleDisabledScrollClass(false);
	
	            if (this.startPagePositionTop !== null) {
	                var windowPageYOffset = this.rootRef.getBoundingClientRect().top - this.startPagePositionTop + window.pageYOffset;
	                this.startPagePositionTop = null;
	                window.setTimeout(function () {
	                    window.scrollTo(window.pageXOffset, windowPageYOffset);
	                }, 0);
	            }
	        }
	    }, {
	        key: 'disablePageScroll',
	        value: function disablePageScroll() {
	            this.startPagePositionTop = this.rootRef.getBoundingClientRect().top;
	
	            Select.toggleDisabledScrollClass(true);
	        }
	    }, {
	        key: 'handleBreakpointChange',
	        value: function handleBreakpointChange(e) {
	            if (this.isPopoverOpen()) {
	                this.togglePageScroll(true, e.detail.breakpoint.code);
	            }
	        }
	    }, {
	        key: 'handleSingleOptionClick',
	        value: function handleSingleOptionClick(value, option) {
	            this.props.onChange(value, option);
	            this.closePopover();
	        }
	    }, {
	        key: 'handleMultiOptionClick',
	        value: function handleMultiOptionClick(value, option) {
	            this.props.onChange(value, option);
	        }
	    }, {
	        key: 'handleOptionClick',
	        value: function handleOptionClick(value, option) {
	            var _props2 = this.props,
	                onChange = _props2.onChange,
	                multiSelect = _props2.multiSelect;
	
	            onChange(value, option);
	            if (!multiSelect) {
	                this.closePopover();
	            }
	        }
	    }, {
	        key: 'handleQueryChange',
	        value: function handleQueryChange(query) {
	            this.setState({ query: query });
	        }
	    }, {
	        key: 'handlePageClick',
	        value: function handlePageClick(e) {
	            if (this.isPopoverOpen() && !this.rootRef.contains(e.target)) {
	                this.closePopover();
	            }
	        }
	    }, {
	        key: 'handleButtonClick',
	        value: function handleButtonClick() {
	            this.togglePopover();
	        }
	    }, {
	        key: 'renderButtonOption',
	        value: function renderButtonOption(value) {
	            var _this3 = this;
	
	            var option = this.props.options.find(function (item) {
	                return _this3.getOptionValue(item) === value;
	            });
	            return _react2.default.createElement(
	                'span',
	                { className: 'sb-select__button__label_flag', key: value },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sb-select__button__label' },
	                    this.getOptionLabel(option)
	                ),
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'sb-select__button__label_flagClose',
	                        onClick: function onClick(e) {
	                            return _this3.clearSelection(e, value);
	                        }
	                    },
	                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Small' })
	                )
	            );
	        }
	    }, {
	        key: 'renderButtonLabel',
	        value: function renderButtonLabel() {
	            var _props3 = this.props,
	                multiSelect = _props3.multiSelect,
	                value = _props3.value,
	                placeholder = _props3.placeholder;
	
	
	            if ((0, _lodash.isNil)(value) || multiSelect && !value.length) {
	                return placeholder;
	            }
	
	            return multiSelect ? value.map(this.renderButtonOption) : this.renderButtonOption(value);
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(option) {
	            var _this4 = this;
	
	            return _react2.default.createElement(_SelectOption2.default, {
	                key: this.getOptionValue(option),
	                option: option,
	                labelGetter: this.getOptionLabel,
	                valueGetter: this.getOptionValue,
	                isSelected: this.isOptionSelected,
	                immediateUpdate: this.props.multiSelect,
	                onClick: function onClick(value, valueOption) {
	                    _this4.handleOptionClick(value, valueOption);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props4 = this.props,
	                title = _props4.title,
	                disabled = _props4.disabled,
	                alphabet = _props4.alphabet,
	                showSearch = _props4.showSearch,
	                onPopoverDidOpen = _props4.onPopoverDidOpen,
	                multiSelect = _props4.multiSelect,
	                options = _props4.options,
	                rowHeight = _props4.rowHeight,
	                dropdownListHeight = _props4.dropdownListHeight;
	            var query = this.state.query;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: 'sb-select ' + (multiSelect ? 'sb-select_multi' : ''),
	                    ref: function ref(_ref) {
	                        return _this5.rootRef = _ref;
	                    }
	                },
	                _react2.default.createElement(_SelectButton2.default, {
	                    label: this.renderButtonLabel(),
	                    major: this.isPopoverOpen(),
	                    disabled: disabled,
	                    onClick: this.handleButtonClick
	                }),
	                this.isPopoverOpen() ? _react2.default.createElement(_SelectPopover2.default, {
	                    title: title,
	                    alphabet: alphabet,
	                    showSearch: showSearch && options.length > 0,
	                    query: query,
	                    rowHeight: rowHeight,
	                    options: this.getRenderingOptions(),
	                    optionLabelGetter: this.getOptionLabel,
	                    optionRenderer: function optionRenderer(opt) {
	                        return _this5.renderOption(opt);
	                    },
	                    noOptionsRenderer: this.renderNoOptions,
	                    onQueryChange: this.handleQueryChange,
	                    onClose: this.closePopover,
	                    onDidMount: onPopoverDidOpen,
	                    dropdownListHeight: dropdownListHeight
	                }) : null
	            );
	        }
	    }]);
	
	    return Select;
	}(_react.PureComponent);
	
	Select.propTypes = {
	    /**
	     * Title to be displayed in popover on mobile devices
	     */
	    title: _react.PropTypes.string.isRequired,
	    /**
	     * Placeholder to be displayed while no value selected
	     */
	    placeholder: _react.PropTypes.string,
	    /**
	     * Disables the component
	     */
	    disabled: _react.PropTypes.bool,
	    /**
	     * Select should be used as a controlled component.
	     * This property sets it's value.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
	    /**
	     * This property allows multiple options to be selected..
	     */
	    multiSelect: _react.PropTypes.bool,
	    /**
	     * Options to be rendered in open popover.
	     * It should have structure [{ label: 'Option Label', value: 'optionValue' }] by default.
	     * Options with custom structure are acceptable too (see 'labelGetter' and 'valueGetter' for details).
	     */
	    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    /**
	     * Shows alphabet in popover.
	     * It could be boolean if you want to control the visibility of the default (English) alphabet.
	     * You can also provide a string with custom chars to be rendered instead of default alphabet.
	     */
	    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
	    /**
	     * Controls the visibility of search input in popover.
	     */
	    showSearch: _react.PropTypes.bool,
	    /**
	     * Controls height of row element, defaults to 64px
	     */
	    rowHeight: _react.PropTypes.number,
	    /**
	     * Controls height of options list into dropdown (for medium and larger screens),
	     */
	    dropdownListHeight: _react.PropTypes.number,
	    /**
	     * You can set custom option label getter if you have custom option object structure.
	     * By default, it is 'label'.
	     * It uses _.get for string and array label getter.
	     * You also can pass a function which accepts option object as a parameter and returns string label.
	     * For example, ({ name }) => name
	     */
	    labelGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
	    /**
	     * You can set custom option value getter if you have custom option object structure.
	     * By default it is 'value'.
	     * It uses _.get for string and array value getter.
	     * You also can pass a function which accepts option object as a parameter and returns value.
	     * For example, ({ id }) => id
	     */
	    valueGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
	    /**
	     * By default options are sorted by labels in alphabet order.
	     * You can override default sorting with this property.
	     * It uses _.sortBy API.
	     * Pass null if you want to disable sorting.
	     */
	    optionsSorter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	    /**
	     * Comapring option and filter query
	     */
	    optionsQueryComparator: _react.PropTypes.func,
	    /**
	     * Message to render if no options available (due to search query or any other reason).
	     * It is ignored if noOptionsRenderer is set.
	     */
	    noOptionsMessage: _react.PropTypes.string,
	    /**
	     * Function that renders the placeholder if no options available (due to search query or any other reason)
	     */
	    noOptionsRenderer: _react.PropTypes.func,
	    /**
	     * Select should be used as a controlled component.
	     * You should handle change event with this property to change component value.
	     */
	    onChange: _react.PropTypes.func.isRequired,
	    /**
	     * You can handle popover open with this property.
	     * If your handler returns Promise, component will render the Spinne while promise unresolved.
	     * It could be used to load options asynchronously.
	     */
	    onPopoverDidOpen: _react.PropTypes.func
	};
	
	Select.defaultProps = {
	    value: null,
	    placeholder: 'Select',
	    labelGetter: 'label',
	    valueGetter: 'value',
	    noOptionsMessage: 'No results',
	    noOptionsRenderer: null,
	    optionsQueryComparator: function optionsQueryComparator(optionLabel, query) {
	        return optionLabel.toLowerCase().indexOf(query.toLowerCase()) > -1;
	    }
	};
	
	exports.default = Select;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The alphabet.
	 */
	var SelectAlphabet = function SelectAlphabet(_ref) {
	    var alphabet = _ref.alphabet,
	        _onClick = _ref.onClick;
	    return _react2.default.createElement(
	        'ul',
	        { className: 'sb-selectAlphabet' },
	        ((0, _lodash.isString)(alphabet) ? alphabet.split('') : alphabet).map(function (character, index) {
	            return _react2.default.createElement(
	                'li',
	                {
	                    key: index,
	                    onClick: function onClick() {
	                        return _onClick(character);
	                    },
	                    className: 'sb-selectAlphabet__character'
	                },
	                character
	            );
	        })
	    );
	};
	
	SelectAlphabet.propTypes = {
	    /**
	     * You can provide string with all alphabet characters or an array of characters to be displayed.
	     * It is English alphabet by default.
	     */
	    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
	    /**
	     * The 'click' event handler.
	     * It will receive a character as an argument.
	     */
	    onClick: _react.PropTypes.func.isRequired
	};
	
	SelectAlphabet.defaultProps = {
	    alphabet: 'abcdefghijklmnopqrstuvwxyz'
	};
	
	exports.default = SelectAlphabet;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _throttle = __webpack_require__(1082);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isMatch = __webpack_require__(1068);
	
	var _isMatch2 = _interopRequireDefault(_isMatch);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectAutoSizer = function (_PureComponent) {
	    _inherits(SelectAutoSizer, _PureComponent);
	
	    function SelectAutoSizer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SelectAutoSizer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectAutoSizer.__proto__ || Object.getPrototypeOf(SelectAutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            measured: false,
	            height: null,
	            width: null
	        }, _this.checkSize = function () {
	            // TODO: width and height should be calculated without padding
	            var _this$parentRef = _this.parentRef,
	                clientWidth = _this$parentRef.clientWidth,
	                clientHeight = _this$parentRef.clientHeight;
	
	            var _this$props$sizeProce = _this.props.sizeProcessor({
	                height: clientHeight,
	                width: clientWidth
	            }),
	                height = _this$props$sizeProce.height,
	                width = _this$props$sizeProce.width;
	
	            var state = {
	                height: height,
	                width: width,
	                measured: true
	            };
	            if ((0, _isMatch2.default)(_this.state, state)) {
	                return;
	            }
	            _this.setState(state, _this.props.onDidResize);
	        }, _this.checkSizeThrottled = (0, _throttle2.default)(_this.checkSize, 100, { leading: false, trailing: true }), _this.handleResize = _this.checkSizeThrottled, _this.handleOrientationChange = function () {
	            // Mobile devices (iOS 10.3.1) don't return valid parent element size
	            // right after the screen orientation change. It also fires the resize event
	            // with the same issue.
	            // So we need to check size after some time past after event.
	            // The only robust way to get new screen size I've found is to
	            // check the size several times (during at least 500ms).
	            // We could do this just once after 500ms past but it makes the UX worse.
	            // I've also tried to check repeatedly until the first size change happened
	            // but there were situations on iOS when it returns new height
	            // with old width.
	            var count = 0;
	            var checkSizeRepeated = function checkSizeRepeated() {
	                _this.checkSizeThrottled();
	                count += 1;
	                if (count < 5) {
	                    setTimeout(checkSizeRepeated, 100);
	                }
	            };
	            checkSizeRepeated();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SelectAutoSizer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.parentRef = this.rootRef.parentNode;
	            this.checkSize();
	
	            window.addEventListener('resize', this.handleResize);
	            window.addEventListener('orientationchange', this.handleOrientationChange);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            this.checkSize();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	            window.removeEventListener('orientationchange', this.handleOrientationChange);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                measured = _state.measured,
	                height = _state.height,
	                width = _state.width;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(_ref2) {
	                        return _this2.rootRef = _ref2;
	                    } },
	                measured ? this.props.contentRenderer({ height: height, width: width })
	                // Hack for IE11 to get correct clientWidth
	                : _react2.default.createElement(
	                    'div',
	                    null,
	                    '\xA0'
	                )
	            );
	        }
	    }]);
	
	    return SelectAutoSizer;
	}(_react.PureComponent);
	
	SelectAutoSizer.propTypes = {
	    sizeProcessor: _react.PropTypes.func,
	    contentRenderer: _react.PropTypes.func.isRequired,
	    onDidResize: _react.PropTypes.func
	};
	SelectAutoSizer.defaultProps = {
	    sizeProcessor: function sizeProcessor(obj) {
	        return obj;
	    },
	    onDidResize: function onDidResize() {
	        return null;
	    }
	};
	exports.default = SelectAutoSizer;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The button with selected value that toggles the popover.
	 * It doesn't pass element to the ref callback if written as a stateless function.
	 */
	var SelectButton = function (_PureComponent) {
	    _inherits(SelectButton, _PureComponent);
	
	    function SelectButton() {
	        _classCallCheck(this, SelectButton);
	
	        return _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).apply(this, arguments));
	    }
	
	    _createClass(SelectButton, [{
	        key: 'render',
	        // eslint-disable-line
	        value: function render() {
	            var _props = this.props,
	                label = _props.label,
	                major = _props.major,
	                disabled = _props.disabled,
	                onClick = _props.onClick;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)('ui-btn', 'sb-select__button', {
	                        'ui-btn_primary': major,
	                        'ui-btn_primary--disabled': major && disabled,
	                        'ui-btn--disabled': !major && disabled
	                    }),
	                    onClick: disabled ? null : onClick
	                },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sb-select__button__label' },
	                    label
	                ),
	                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'down', size: 'Medium' })
	            );
	        }
	    }]);
	
	    return SelectButton;
	}(_react.PureComponent);
	
	SelectButton.propTypes = {
	    /**
	     * This is the label to be displayed.
	     * It could be a string or a node to render.
	     */
	    label: _react.PropTypes.node.isRequired,
	    /**
	     * Applies major button styling.
	     */
	    major: _react.PropTypes.bool.isRequired,
	    /**
	     * Disables the button.
	     */
	    disabled: _react.PropTypes.bool,
	    /**
	     * The 'click' event handler.
	     */
	    onClick: _react.PropTypes.func.isRequired
	};
	
	exports.default = SelectButton;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The search input.
	 */
	var SelectInput = function SelectInput(_ref) {
	  var title = _ref.title,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      onKeyDown = _ref.onKeyDown;
	  return _react2.default.createElement(
	    "div",
	    { className: "sb-select__inputContainer" },
	    _react2.default.createElement(
	      "span",
	      { className: "sb-select__inputLabel" },
	      title
	    ),
	    _react2.default.createElement("input", {
	      className: "sb-select__input",
	      type: "text",
	      maxLength: "30",
	      placeholder: "Search...",
	      value: value,
	      onChange: onChange,
	      onKeyDown: onKeyDown
	    })
	  );
	};
	
	SelectInput.propTypes = {
	  /**
	   * Title to be displayed on mobile devices
	   */
	  title: _react.PropTypes.string.isRequired,
	  /**
	   * This is the controlled component, so it requires it's value.
	   */
	  value: _react.PropTypes.string.isRequired,
	  /**
	   * This is the controlled component, so it requires 'change' event handler.
	   */
	  onChange: _react.PropTypes.func.isRequired,
	  /**
	   * The 'keydown' event handler. It is used to handle 'Esc' and 'Enter' buttons.
	   */
	  onKeyDown: _react.PropTypes.func.isRequired
	};
	
	exports.default = SelectInput;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _clamper = __webpack_require__(653);
	
	var _clamper2 = _interopRequireDefault(_clamper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The option from the list.
	 */
	var SelectOption = function (_PureComponent) {
	    _inherits(SelectOption, _PureComponent);
	
	    function SelectOption(props) {
	        _classCallCheck(this, SelectOption);
	
	        var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(SelectOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _clamper2.default)(this.labelRef, { clamp: 2 });
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            var _props = this.props,
	                option = _props.option,
	                valueGetter = _props.valueGetter,
	                onClick = _props.onClick,
	                immediateUpdate = _props.immediateUpdate;
	
	            onClick(valueGetter(option), option);
	
	            if (immediateUpdate) {
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                option = _props2.option,
	                labelGetter = _props2.labelGetter,
	                isSelected = _props2.isSelected;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    onClick: this.handleClick,
	                    className: (0, _classnames2.default)('sb-selectList__option', 'ui-popoverList__link', { 'sb-selectList__option_selected': isSelected(option) })
	                },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'sb-selectList__label',
	                        ref: function ref(_ref) {
	                            return _this2.labelRef = _ref;
	                        }
	                    },
	                    labelGetter(option)
	                ),
	                _react2.default.createElement(_rpReactSvgIcon2.default, {
	                    iconName: 'tick',
	                    size: 'Medium'
	                })
	            );
	        }
	    }]);
	
	    return SelectOption;
	}(_react.PureComponent);
	
	SelectOption.propTypes = {
	    /**
	     * The option to render.
	     * It has no mandatory structure.
	     * You can pass any object with custom label and value getters.
	     */
	    option: _react.PropTypes.object.isRequired, // eslint-disable-line
	    /**
	     * The option label getter.
	     * It is used to display the option.
	     */
	    labelGetter: _react.PropTypes.func.isRequired,
	    /**
	     * The option value getter.
	     * It is used to pass the value to the onClick handler.
	     */
	    valueGetter: _react.PropTypes.func.isRequired,
	    /**
	     * Function to check is option selected.
	     * It is used to highlight the selected option.
	     */
	    isSelected: _react.PropTypes.func.isRequired,
	    /**
	     * The 'click' event handler.
	     * It gets option value and the option itself as arguments.
	     */
	    onClick: _react.PropTypes.func.isRequired,
	    /**
	     * Property for immediate option re render on selection
	     */
	    immediateUpdate: _react.PropTypes.bool
	};
	
	exports.default = SelectOption;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.POSITION_BOTTOM = exports.POSITION_TOP = exports.KEY_CODE_ESC = exports.KEY_CODE_ENTER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(103);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(1208);
	
	var _rpMqBreakpoints = __webpack_require__(71);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	var _rpReactSvgIcon = __webpack_require__(24);
	
	var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);
	
	var _SelectInput = __webpack_require__(1343);
	
	var _SelectInput2 = _interopRequireDefault(_SelectInput);
	
	var _SelectAlphabet = __webpack_require__(1340);
	
	var _SelectAlphabet2 = _interopRequireDefault(_SelectAlphabet);
	
	var _SelectAutoSizer = __webpack_require__(1341);
	
	var _SelectAutoSizer2 = _interopRequireDefault(_SelectAutoSizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
	var KEY_CODE_ESC = exports.KEY_CODE_ESC = 27;
	
	var POSITION_TOP = exports.POSITION_TOP = 'top';
	var POSITION_BOTTOM = exports.POSITION_BOTTOM = 'bottom';
	
	/**
	 * The popover with options, search input and alphabet.
	 */
	
	var SelectPopover = function (_PureComponent) {
	    _inherits(SelectPopover, _PureComponent);
	
	    _createClass(SelectPopover, null, [{
	        key: 'renderSpinner',
	        value: function renderSpinner() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'sb-selectSpinner' },
	                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'spinner', size: '2XL' })
	            );
	        }
	    }]);
	
	    function SelectPopover(props) {
	        _classCallCheck(this, SelectPopover);
	
	        var _this = _possibleConstructorReturn(this, (SelectPopover.__proto__ || Object.getPrototypeOf(SelectPopover)).call(this, props));
	
	        _this.handleBreakpointsSwitch = function (e) {
	            return _this.setState({
	                breakpointCode: e.detail.breakpoint.code
	            });
	        };
	
	        _this.checkPosition = (0, _lodash.once)(function () {
	            // Popover shouldn't jump from top to bottom while querying
	            // So we call this function only once
	            var _this$rootRef$parentN = _this.rootRef.parentNode.getBoundingClientRect(),
	                parentTop = _this$rootRef$parentN.top,
	                parentBottom = _this$rootRef$parentN.bottom;
	
	            var _this$rootRef$getBoun = _this.rootRef.getBoundingClientRect(),
	                height = _this$rootRef$getBoun.height;
	
	            var windowHeight = window.innerHeight;
	
	            // We show popover at bottom if there is enough space for it below the select button
	            // or there is not enough space above the select button.
	            // Otherwise it is shown at top.
	            var position = windowHeight - parentBottom >= height || parentTop < height ? POSITION_BOTTOM : POSITION_TOP;
	
	            if (position !== _this.state.position) {
	                _this.setState({ position: position });
	            }
	        });
	
	        _this.processListSize = function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            var _this$props = _this.props,
	                options = _this$props.options,
	                rowHeight = _this$props.rowHeight,
	                dropdownListHeight = _this$props.dropdownListHeight;
	            var breakpointCode = _this.state.breakpointCode;
	            var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
	                NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;
	
	            return {
	                width: width,
	                height: [EXTRA_NARROW, NARROW].includes(breakpointCode) ? height : Math.min(dropdownListHeight, options.length * rowHeight)
	            };
	        };
	
	        _this.state = {
	            didMountHandling: false,
	            breakpointCode: _rpMqBreakpoints2.default.current().code,
	            position: POSITION_BOTTOM
	        };
	
	        _this.renderOption = _this.renderOption.bind(_this);
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
	        _this.handleAlphabetClick = _this.handleAlphabetClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(SelectPopover, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var onDidMount = this.props.onDidMount;
	
	            if (onDidMount) {
	                var handlerResult = onDidMount();
	                if ((0, _lodash.isObject)(handlerResult) && (0, _lodash.isFunction)(handlerResult.then) && (0, _lodash.isFunction)(handlerResult.catch)) {
	                    this.toggleDidMountHandling(true);
	                    // TODO: handle errors
	                    handlerResult.then(function () {
	                        return _this2.toggleDidMountHandling(false);
	                    }).catch(function () {
	                        return _this2.toggleDidMountHandling(false);
	                    });
	                }
	            }
	
	            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
	        }
	    }, {
	        key: 'handleInputChange',
	        value: function handleInputChange(e) {
	            this.props.onQueryChange(e.target.value);
	
	            /*
	            * This does re-rendering of List
	            * if options were changed but quantity is the same.
	            *
	            * For example your query is "x"
	            * and you have two options "x1" and "x2".
	            * After that you change query to "y"
	            * and get "y1" and "y2".
	            * In this case List shows previous results
	            * and we should trigger update manually
	            */
	            if (this.listRef) {
	                this.listRef.forceUpdateGrid();
	            }
	        }
	    }, {
	        key: 'handleInputKeyDown',
	        value: function handleInputKeyDown(e) {
	            if (e.keyCode === KEY_CODE_ENTER || e.keyCode === KEY_CODE_ESC) {
	                this.props.onClose(e);
	            }
	        }
	    }, {
	        key: 'handleAlphabetClick',
	        value: function handleAlphabetClick(char) {
	            var _props = this.props,
	                options = _props.options,
	                optionLabelGetter = _props.optionLabelGetter;
	
	            this.listRef.scrollToRow(options.findIndex(function (option) {
	                return optionLabelGetter(option)[0].toLowerCase() >= char.toLowerCase();
	            }));
	        }
	    }, {
	        key: 'toggleDidMountHandling',
	        value: function toggleDidMountHandling(didMountHandling) {
	            this.setState({ didMountHandling: didMountHandling });
	        }
	    }, {
	        key: 'renderAlphabet',
	        value: function renderAlphabet() {
	            var alphabet = this.props.alphabet;
	
	            if (!alphabet) {
	                return null;
	            }
	
	            return _react2.default.createElement(_SelectAlphabet2.default, {
	                alphabet: (0, _lodash.isString)(alphabet) ? alphabet : undefined,
	                onClick: this.handleAlphabetClick
	            });
	        }
	    }, {
	        key: 'renderQueryInput',
	        value: function renderQueryInput() {
	            var _props2 = this.props,
	                query = _props2.query,
	                title = _props2.title,
	                showSearch = _props2.showSearch;
	
	            if (!showSearch) {
	                return null;
	            }
	            return _react2.default.createElement(_SelectInput2.default, {
	                title: title,
	                value: query,
	                onChange: this.handleInputChange,
	                onKeyDown: this.handleInputKeyDown
	            });
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(_ref2) {
	            var index = _ref2.index,
	                key = _ref2.key,
	                style = _ref2.style;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    key: key,
	                    style: style
	                },
	                this.props.optionRenderer(this.props.options[index])
	            );
	        }
	    }, {
	        key: 'renderList',
	        value: function renderList() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                options = _props3.options,
	                rowHeight = _props3.rowHeight,
	                noOptionsRenderer = _props3.noOptionsRenderer;
	
	
	            if (options.length === 0) {
	                return noOptionsRenderer();
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'sb-selectListWrap' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sb-selectList' },
	                    _react2.default.createElement(_SelectAutoSizer2.default, {
	                        sizeProcessor: this.processListSize,
	                        contentRenderer: function contentRenderer(_ref3) {
	                            var width = _ref3.width,
	                                height = _ref3.height;
	                            return _react2.default.createElement(_reactVirtualized.List, {
	                                ref: function ref(_ref5) {
	                                    return _this3.listRef = _ref5;
	                                },
	                                height: height,
	                                overscanRowCount: 15,
	                                rowHeight: rowHeight,
	                                rowCount: options.length,
	                                rowRenderer: function rowRenderer(_ref4) {
	                                    var index = _ref4.index,
	                                        key = _ref4.key,
	                                        style = _ref4.style;
	                                    return _this3.renderOption({ index: index, key: key, style: style });
	                                },
	                                scrollToAlignment: 'start',
	                                width: width
	                            });
	                        },
	                        onDidResize: this.checkPosition
	                    })
	                ),
	                this.renderAlphabet()
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props4 = this.props,
	                title = _props4.title,
	                onClose = _props4.onClose;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    ref: function ref(_ref6) {
	                        return _this4.rootRef = _ref6;
	                    },
	                    className: 'ui-popover ui-popover_headless ui-popover_' + this.state.position
	                },
	                _react2.default.createElement('div', { className: 'ui-popoverPointer' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui-popoverHeader' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'ui-popoverHeader__title' },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        {
	                            className: 'ui-btn ui-btn_secondary ui-popoverHeader__btn',
	                            onClick: onClose
	                        },
	                        _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Medium' })
	                    )
	                ),
	                this.renderQueryInput(),
	                this.state.didMountHandling ? SelectPopover.renderSpinner() : this.renderList()
	            );
	        }
	    }]);
	
	    return SelectPopover;
	}(_react.PureComponent);
	
	SelectPopover.propTypes = {
	    /**
	     * Title to be displayed on mobile devices
	     */
	    title: _react.PropTypes.string.isRequired,
	    /**
	     * Shows alphabet.
	     * It could be boolean if you want to control the visibility of the default (English) alphabet.
	     * You can also provide a string with custom chars to be rendered instead of default alphabet.
	     */
	    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
	    /**
	     * Controls the visibility of search input.
	     */
	    showSearch: _react.PropTypes.bool,
	    /**
	     * Controls height of row element, defaults to 64px
	     */
	    rowHeight: _react.PropTypes.number,
	    /**
	     * Controls height of options list into dropdown (for medium and larger screens),
	     */
	    dropdownListHeight: _react.PropTypes.number,
	    /**
	     * The search query value.
	     * This is the controlled component so it requires the search query value.
	     */
	    query: _react.PropTypes.string.isRequired,
	    /**
	     * Array of options to be rendered.
	     */
	    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    /**
	     * Funtion that gets the option as an argument and returns it's label.
	     * It is used to scroll to option by alphabet.
	     */
	    optionLabelGetter: _react.PropTypes.func.isRequired,
	    /**
	     * Function that gets the option as an argument and returns the React node for this option.
	     */
	    optionRenderer: _react.PropTypes.func.isRequired,
	    /**
	     * Function that renders the placeholder if no options available (due to search query or any other reason)
	     */
	    noOptionsRenderer: _react.PropTypes.func.isRequired,
	    /**
	     * This is the controlled component so it requires the search query change handler.
	     */
	    onQueryChange: _react.PropTypes.func.isRequired,
	    /**
	     * Close button 'click' handler.
	     */
	    onClose: _react.PropTypes.func.isRequired,
	    /**
	     * It could be considered as the 'open' event handler.
	     * If it returns a Promise application shows the spinner until promise resolved or rejected.
	     */
	    onDidMount: _react.PropTypes.func
	};
	
	SelectPopover.defaultProps = {
	    rowHeight: 64,
	    dropdownListHeight: 354,
	    query: '',
	    options: []
	};
	
	exports.default = SelectPopover;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Select = __webpack_require__(1339);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @link https://racingpost.atlassian.net/browse/PB2-610
	 */
	exports.default = _Select2.default;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
	exports.getPrefValue = getPrefValue;
	
	var _jquery = __webpack_require__(20);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
	var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
	var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';
	
	function getValuesIfExist(value, possibleValues) {
	    return value in possibleValues;
	}
	
	function getPrefValue(prefType, prefDefaultValue) {
	    return localStorage.getItem(prefType) || prefDefaultValue;
	}
	
	function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
	    var prefValue = void 0;
	
	    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
	        var $target = (0, _jquery2.default)(e.currentTarget);
	
	        function updateHref(value) {
	            $target.attr('href', function (index, href) {
	                return '' + href.replace(/\/$/, '') + possibleValues[value];
	            });
	            $target.removeClass(className);
	        }
	
	        if (prefValue) {
	            updateHref(prefValue);
	        } else {
	            prefValue = getPrefValue(prefType, prefDefaultValue);
	            if (!getValuesIfExist(prefValue, possibleValues)) {
	                prefValue = prefDefaultValue;
	            }
	            updateHref(prefValue);
	        }
	    });
	}
	
	function setPref(selector, storageKeyName, possibleValues) {
	    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
	    if (!getValuesIfExist(value, possibleValues)) {
	        return;
	    }
	
	    if (value) {
	        try {
	            localStorage.setItem(storageKeyName, value);
	        } catch (e) {
	            /* eslint-disable no-console */
	            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
	        }
	    }
	}
	
	function navigate() {
	    var cardTabsPossibleValues = {
	        // Legacy RP1 values
	        free: '/',
	        pro: '/pro',
	        'at-a-glance': '/at-a-glance',
	        'odds-comparison': '/odds-comparison',
	        'raceday-live': '/raceday-live',
	        // Janus values
	        card: '/',
	        'pro-card': '/pro',
	        compact: '/compact-view',
	        smart: '/smart-view',
	        'betting-odds': '/betting-odds'
	    };
	    var cardListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    var resultsListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    // Racecards tab preferences
	    // TODO: change to more related name
	    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
	    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);
	
	    // Racecards list types preferences
	    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
	    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);
	
	    // Results list types preferences
	    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
	    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
	}
	
	exports.default = navigate;

/***/ }),
/* 1348 */,
/* 1349 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ })
]);


// WEBPACK FOOTER //
// app.min.js